  // StockPage.js
  /////////alpha vantage api key: 1YL74LVNEA8HJJT3
  import ReactDOM from "react-dom";
  import React, { useState, useEffect, useCallback, useRef, Fragment, useMemo  } from "react";
  import { Listbox, Transition, ListboxButton, ListboxOptions, ListboxOption, Description } from "@headlessui/react";
import axios, { apiFetch } from "../api/client";
import { addFavorite, checkFavorite, purchaseStock, removeFavorite } from "../api/private";
  import Chart from "react-apexcharts";
  import ReactMarkdown from 'react-markdown'
  import remarkGfm from 'remark-gfm'
  import Draggable from "react-draggable";
  import Switch from "react-switch";
  import SettingsPopup from "./settingsPopup";
  import GaugeComponent from "react-gauge-component";
  import dayjs from "dayjs";
  import ReactSpeedometer from "react-d3-speedometer"
  import GaugeChart from "react-gauge-chart";
  import { BarChart } from '@mui/x-charts/BarChart';
  import { ScatterChart } from '@mui/x-charts/ScatterChart';
import MonteCarloHistogram from "./dcfChart";
import {
  ChartsTooltipContainer,
  useItemTooltip,
} from "@mui/x-charts";
  import { curveMonotoneX } from "d3-shape";
  import { FileText } from "lucide-react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  navigate,
  useLocation,
  Navigate,
  useNavigate,
  NavLink
} from "react-router-dom";
  import { useUser } from "../context/UserContext";
  import "../stockpagestyle.css";
  import emptys from "../images/Starempty-star.png";
  import filleds from "../images/Starfilled-star.png";
  import FlyIcon from "../images/SendMessage.png";
  import SleuthAIIcon from "../images/aiicon.png";
  import debounce from "lodash.debounce";

  import watermark from "../images/logo-black.png";
  import html2canvas from 'html2canvas';
  import gradientRec from "../images/gradientRec.svg";
  import candleStick from "../images/image_part_001.png";
  import { CSVLink } from "react-csv";
  import ohlc from "../images/image_part_002.png";
  import line from "../images/image_part_003.png";
  import heikin from "../images/image_part_004.png";
  import line1 from "../images/oneline.png";
  import drag from "../images/Drag.png";

  import dotted from "../images/Group 5.png";
  import full from "../images/Group 3.png";
  import dashed from "../images/Group 4.png";

  import w1 from "../images/Group 6.png";
  import w2 from "../images/Group 7.png";
  import w3 from "../images/Group 8.png";
  import w4 from "../images/Group 9.png";
  
  import line2 from "../images/twoline.png";
  import line3 from "../images/threeline.png";
  import fib1 from "../images/shortFib.png";
  import fib2 from "../images/midFib.png";
  import fib3 from "../images/longFib.png";
  import bin from "../images/trashIcon.png";
  import channel from "../images/channel.png";
  import PropTypes from "prop-types";
  import FinancialStatementTable from "./StatementTable";
  import FavoriteStar from "./FavStar";
  import { Radar } from "react-chartjs-2";
  import { format } from "d3-format";
  import SizeMe from 'react-sizeme';
  import { timeFormat, timeParse  } from "d3-time-format";
  import { initialData } from "./data";
  import {
    elderRay,
    EquidistantChannel,
    StraightLine,
    sar,
    SARSeries,
    ema,
    FibonacciRetracement,
    sma,
    MACDTooltip,
    MACDSeries,
    heikinAshi,
    kagi,
    VolumeProfileSeries,
    pointAndFigure,
    stochasticOscillator,
    renko,
    wma,
    macd,
    tma,
    BollingerBandTooltip,
    discontinuousTimeScaleProviderBuilder,
    Chart as ChartRF,
    ChartCanvas,
    CurrentCoordinate,
    OHLCSeries,
    BarSeries,
    bollingerBand,
    forceIndex,
    RSITooltip,
    RSISeries,
    rsi,
    atr,
    BollingerSeries,
    CandlestickSeries,
    KagiSeries,
    PointAndFigureSeries,
    RenkoSeries,
    ElderRaySeries,
    LineSeries,
    MovingAverageTooltip,
    OHLCTooltip,
    SingleValueTooltip,
    lastVisibleItemBasedZoomAnchor,
    XAxis,
    AreaSeries,
    YAxis,
    CrossHairCursor,
    EdgeIndicator,
    MouseCoordinateX,
    MouseCoordinateY,
    ZoomButtons,
    AlternatingFillAreaSeries,
    StandardDeviationChannel,
    withDeviceRatio,
    withSize,
    StochasticTooltip,
    StochasticSeries,
    TrendLine, DrawingObjectSelector,
    last
    
  } from "react-financial-charts";
  import {
    saveInteractiveNodes,
    getInteractiveNodes, toObject
  } from "./interactiveUtils";

  import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
  } from "chart.js";
  import { use } from "react";


//const toId = (item) => item.replace(/\s+/g, "").toLowerCase();



function ThinkingIndicator() {
  return (
    <div className="thinkingText">
      thinking…
    </div>
  );
}
  // Register required components
  ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
  );



function Modal({ open, onClose, children }) {
  // Always call hooks; gate the side-effect by `open`
  useEffect(() => {
    const prev = document.body.style.overflow;

    if (open) {
      document.body.style.overflow = "hidden";
    }

    // Cleanup restores previous overflow on unmount OR when `open` changes
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.4)",
          zIndex: 9998,
        }}
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
          padding: "24px 30px",
          zIndex: 9999,
          maxWidth: "90vw",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
        onClick={(e) => e.stopPropagation()} // prevent overlay close
        onKeyDown={(e) => e.key === "Escape" && onClose?.()} // optional: Esc to close
        tabIndex={-1}
      >
        {children}
      </div>
    </>,
    document.body
  );
}





  function IconSelect({ value, onChange, options }) {
    return (
      <Listbox value={value} onChange={onChange}>
        <div style={{ position: "relative", width: 120 }}>
          <ListboxButton
            style={{
              width: "100%",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid #ccc",
              borderRadius: 4,
              cursor: "pointer",
              background: "#fff",
            }}
          >
            <span style={{ display: "flex", alignItems: "center" }}>
              <img
                src={options.find(o => o.value === value).icon}
                alt=""
                style={{ width: 16, marginRight: 8 }}
              />
              {options.find(o => o.value === value).label}
            </span>
            <span>▾</span>
          </ListboxButton>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <ListboxOptions
              static
              style={{
                position: "absolute",
                marginTop: 4,
                width: "100%",
                background: "#fff",
                border: "1px solid #ccc",
                borderRadius: 4,
                zIndex: 10,
                maxHeight: 200,
                overflowY: "auto",
              }}
            >
              {options.map((opt) => (
                <ListboxOption
                  key={opt.value}
                  value={opt.value}
                  style={{
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  {({ selected, active }) => (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        background: active ? "#f7f7f7" : "transparent",
                        width: "100%",
                      }}
                    >
                      <img
                        src={opt.icon}
                        alt=""
                        style={{ width: 16, marginRight: 8 }}
                      />
                      <span
                        style={{
                          fontWeight: selected ? "600" : "400",
                        }}
                      >
                        {opt.label}
                      </span>
                    </div>
                  )}
                </ListboxOption>
              ))}
            </ListboxOptions>
          </Transition>
        </div>
      </Listbox>
    );
  }
  
const normalizeChatMessages = (payload) => {
  const candidates = [
    payload,
    payload?.messages,
    payload?.data,
    payload?.data?.messages,
  ];
  const messages = candidates.find(Array.isArray);
  return messages ? messages.filter((message) => message && typeof message === "object") : [];
};

const StockPage = ({ match, scrollRootRef }) => {

    const macdAppearance = {
      stroke: {
        macd: "#FF0000",
        signal: "#00F300",
      },
      fill: {
        divergence: "#4682B4"
      },
    };
const [mounted, setMounted] = useState(false);
useEffect(() => setMounted(true), []);


    const { ticker } = useParams();
    const [IncomeData, setIncomeData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [sma50Enabled, setSma50Enabled] = useState(false);
    const [sma100Enabled, setSma100Enabled] = useState(false);
    const [sma200Enabled, setSma200Enabled] = useState(false);
    const [interval, setInter2val] = useState("1d");
    const [lastChart, setLastChart] = useState("price");
    const [isBSmultiplierLoaded, setIsBSmultiplierLoaded] = useState(false);
    const [range, setRange] = useState("5y");
    const [currentPrice, setCurrentPrice] = useState(null); // New state for current price
    const [prevPrice, setPrevPrice] = useState(null);
    const [showCandlestick, setShowCandlestick] = useState(true);
    const [exchangeName, setExchangeName] = useState("NASDAQ"); // default value
    const { user, isLoggedIn } = useUser();
    const [logoInfo, setLogoInfo] = useState(null);
    const ratingLabels = ["Strong Sell", "Sell", "Neutral", "Buy", "Strong Buy"];
const ratingColors = ["#e74c3c", "#f56262", "#bdc3c7", "#2ecc71", "#27ae60"];
const ratingColors2 = ["#27ae60", "#2ecc71", "#ece253ff", "#f56262", "#e74c3c"];
    const [isFavorite, setIsFavorite] = useState(false); // New state for favorite status
    const [nameInfo, setnameInfo] = useState(null);
    const [messages, setMessages] = useState([]); // State for chat messages
    const [newMessage, setNewMessage] = useState("");
    const [messagStats, setMesageStats] = useState(1);
    const [candlesAppearance, setCandlesAppearance] = useState({
    wickStroke: (d) => (d.close > d.open ? "rgba(38, 166, 154, 1)" : "rgba(239, 83, 80, 1)"),
    fill: (d) => (d.close > d.open ? "rgba(38, 166, 154, 1)" : "rgba(239, 83, 80, 1)"),
    //stroke: "#000000",
    candleStrokeWidth: 1,
    widthRatio: 0.8,
    opacity: 1,
  });
    const [fetchingOlderMessages, setFetchingOlderMessages] = useState(false);
    const chatBoxRef = useRef(null);
    const [balanceSheetData, setBalanceSheetData] = useState(null);
    const [AllHistData, setAllHistData] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [activeStatement, setActiveStatement] = useState("balanceSheet");
    const [cfData, setcfData] = useState(null);
    const [BSmultiplier, setBSmultiplier] = useState(1000);
    const [ISmultiplier, setISmultiplier] = useState(1000);
    const [activeData, setActiveData] = useState("Summary");
    const [isChart, setIsChart] = useState(1);
    const [isQuarterly, setIsQuarterly] = useState(1);
    const [hoveredRow, setHoveredRow] = useState(null);
    const [mostRecentQ, setMostRecentQ] = useState("");
    const location = useLocation();
    const [QData, setQdata] = useState([]);
    const [FYData, setFYdata] = useState([]);
    const [description, setDescription] = useState("");
    const [longBio, setLongBio] = useState("");
    const [compRisks, setCompRisks] = useState([]);
    const [execs, setExecs] = useState([]);
  const [hover, setHover] = useState({ chartId: null, index: null });

    const [ratios, setRatios] = useState(null);
    const [lastFYdate, setlastFy] = useState(null);
    const [periodlow, set52weeklow] = useState(0);
    const [periodhigh, set52weekhigh] = useState(0);
    const [periodChange, setPeriodChange] = useState(0);
    const [logoim, setLogoimg] = useState(null);
    const [sector, setSector] = useState("");
    const [lastFetch, setLastFetch] = useState(new Date());
    const [industryt, setIndustry] = useState("");
    const [FinishedLoading, setFinishedLoading] = useState(false);
    const { width, height } = useWindowDimensions();
const [trendRating, setTrendRating] = useState("Neutral");
const [momentumRating, setMomentumRating] = useState("Neutral");
const [volumeRating, setVolumeRating] = useState("Neutral");
const [financialsTableVisible, setFinancialsTableVisible] = useState(false);
const [showDetailedFinancials, setShowDetailedFinancials] = useState(false);
  
    const chartContainerRef = useRef(null);
    const [chartType, setChartType] = useState("candlestick");
    const [showVolume, setShowVolume] = useState(true);  
const [isThinking, setIsThinking] = useState(false);
const [showTypewriter, setShowTypewriter] = useState(false);
const exampleQuestions = [
  `What was ${ticker}’s revenue last quarter?`,
  `How did ${ticker}’s EPS compare year‑over‑year in the most recent quarter?`,
  `Why is ${ticker} up today? Show me the latest headlines.`,
  `What’s the current P/E ratio for ${ticker}, and how does that compare to its 5‑year average?`,
  `Give me a breakdown of ${ticker}’s balance sheet—assets, liabilities, and equity—for the last quarter.`,
  `Calculate ${ticker}’s free cash flow for the most recent quarter.`,
  `How has ${ticker}’s return on equity (ROE) trended over the past four quarters?`,
  `What’s the Altman Z‑Score for ${ticker} and what does it imply about bankruptcy risk?`,
  `Show me ${ticker}’s basic valuation multiples: EV/EBITDA, P/B, and P/S.`,
  `Summarize the last five years of free cash flow for ${ticker}.`,
  `What are the key risks for ${ticker} based on its debt‑to‑equity and current ratio?`,
  `How would I hedge a long position in ${ticker} using options?`
];

const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
const ComparableTooltip = () => {
  const tooltipData = useItemTooltip();

  if (!tooltipData) {
    return null;
  }

  const p = tooltipData.value;

  if (!p) {
    return null;
  }

  return (
    <ChartsTooltipContainer trigger="item">
      <div
        style={{
          padding: "10px 12px",
          fontFamily: "Lexend",
          minWidth: 170,
          background: "#ffffff",
          borderRadius: 8,
          boxShadow: "0 4px 16px rgba(15, 23, 42, 0.14)",
          fontSize: 12,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 7,
            fontWeight: 600,
            marginBottom: 4,
          }}
        >
          <span
            style={{
              width: 9,
              height: 9,
              borderRadius: "50%",
              background: tooltipData.color,
              flexShrink: 0,
            }}
          />

          {tooltipData.label || p.ticker || "Company"}
        </div>

        {p.name && (
          <div
            style={{
              fontSize: 11,
              color: "#64748b",
              marginBottom: 7,
            }}
          >
            {p.name}
          </div>
        )}

        <div>
          {activeXMetric?.shortLabel || activeXMetric?.label || "X"}:{" "}
          <b>{formatComparableValue(compXAxis, p.x)}</b>
        </div>

        <div>
          {activeYMetric?.shortLabel || activeYMetric?.label || "Y"}:{" "}
          <b>{formatComparableValue(compYAxis, p.y)}</b>
        </div>

        {p.size != null && (
          <div>
            {activeSizeMetric?.shortLabel ||
              activeSizeMetric?.label ||
              "Size"}
            :{" "}
            <b>{formatComparableValue(compSizeMetric, p.size)}</b>
          </div>
        )}

        {p.marketCap != null && (
          <div>
            Market cap: <b>${formatCompactNumber(p.marketCap)}</b>
          </div>
        )}
      </div>
    </ChartsTooltipContainer>
  );
};

const demoStocks = [
  {
    id: 'aapl',
    symbol: 'AAPL',
    name: 'Apple Inc.',
    price: 255.53,
    marketCap: 3.28e12,
    pe: 34.1,
    ps: 8.29,
    pb: 57.1,
    evToSalesTTM: 8.18,
    evToEbitdaTTM: 23.6,
    grossMarginTTM: 0.4668,
    profitMarginTTM: 0.243,
    beta: 1.28,
    roaTTM: 0.285,
    roeTTM: 1.617,
    currentRatioQuarterly: 0.92,
    debtToEquity: 1.54,
    score: 85,
  },
  {
    id: 'msft',
    symbol: 'MSFT',
    name: 'Microsoft Corporation',
    price: 459.86,
    marketCap: 2.91e12,
    pe: 31.4,
    ps: 11.1,
    pb: 10.4,
    evToSalesTTM: 12.3,
    evToEbitdaTTM: 24.7,
    grossMarginTTM: 0.69,
    profitMarginTTM: 0.36,
    beta: 0.98,
    roaTTM: 0.18,
    roeTTM: 0.33,
    currentRatioQuarterly: 1.35,
    debtToEquity: 0.34,
    score: 78,
  },
  {
    id: 'nvda',
    symbol: 'NVDA',
    name: 'NVIDIA Corporation',
    price: 186.23,
    marketCap: 2.87e12,
    pe: 79.4,
    ps: 22.0,
    pb: 36.6,
    evToSalesTTM: 21.4,
    evToEbitdaTTM: 38.5,
    grossMarginTTM: 0.75,
    profitMarginTTM: 0.52,
    beta: 2.11,
    roaTTM: 0.45,
    roeTTM: 0.82,
    currentRatioQuarterly: 4.1,
    debtToEquity: 0.18,
    score: 100,
  },
  {
    id: 'avgo',
    symbol: 'AVGO',
    name: 'Broadcom Inc.',
    price: 351.71,
    marketCap: 9.01e11,
    pe: 89.5,
    ps: 16.5,
    pb: 14.6,
    evToSalesTTM: 16.71,
    evToEbitdaTTM: 28.4,
    grossMarginTTM: 0.661,
    profitMarginTTM: 0.103,
    beta: 1.0,
    roaTTM: 0.036,
    roeTTM: 0.18,
    currentRatioQuarterly: 1.0,
    debtToEquity: 1.4,
    score: 67,
  },
  {
    id: 'amd',
    symbol: 'AMD',
    name: 'Advanced Micro Devices',
    price: 215.4,
    marketCap: 3.3e11,
    pe: 54.2,
    ps: 12.7,
    pb: 4.8,
    evToSalesTTM: 11.9,
    evToEbitdaTTM: 41.0,
    grossMarginTTM: 0.49,
    profitMarginTTM: 0.08,
    beta: 1.9,
    roaTTM: 0.04,
    roeTTM: 0.07,
    currentRatioQuarterly: 2.5,
    debtToEquity: 0.05,
    score: 60,
  },
];

const toFiniteNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

const normalizeMarketCap = (value) => {
  const n = toFiniteNumber(value);
  if (n == null) return null;

  // getComparables appears to return market cap in millions, while other parts
  // of the app use absolute dollars. Normalize both shapes to dollars.
  return Math.abs(n) < 10000000 ? n * 1000000 : n;
};

const toPercentMetric = (value) => {
  const n = toFiniteNumber(value);
  if (n == null) return null;
  return Math.abs(n) <= 1.5 ? n * 100 : n;
};
const drawingMenuButtonStyle = {
  minHeight: 40,
  width: 190,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: 10,
  padding: "7px 12px",
  border: "none",
  background: "transparent",
  borderRadius: 7,
  cursor: "pointer",
  fontFamily: "Poppins",
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 1.2,
  color: "#334155",
  textAlign: "left",
  whiteSpace: "nowrap",
};

const drawingMenuImageStyle = {
  width: 28,
  height: 28,
  objectFit: "contain",
  flexShrink: 0,
};
const comparableMetricOptions = [
  { key: 'evSales', label: 'EV/Sales', shortLabel: 'EV/Sales', format: 'multiple' },
  { key: 'evEbitda', label: 'EV/EBITDA', shortLabel: 'EV/EBITDA', format: 'multiple' },
  { key: 'pe', label: 'P/E', shortLabel: 'P/E', format: 'multiple' },
  { key: 'ps', label: 'P/S', shortLabel: 'P/S', format: 'multiple' },
  { key: 'pb', label: 'P/B', shortLabel: 'P/B', format: 'multiple' },
  { key: 'grossMargin', label: 'Gross margin', shortLabel: 'Gross M.', format: 'percent' },
  { key: 'netMargin', label: 'Net margin', shortLabel: 'Net M.', format: 'percent' },
  { key: 'roe', label: 'ROE', shortLabel: 'ROE', format: 'percent' },
  { key: 'roa', label: 'ROA', shortLabel: 'ROA', format: 'percent' },
  { key: 'currentRatio', label: 'Current ratio', shortLabel: 'Current', format: 'multiple' },
  { key: 'debtEquity', label: 'Debt / equity', shortLabel: 'D/E', format: 'multiple' },
  { key: 'beta', label: 'Beta', shortLabel: 'Beta', format: 'number' },
  { key: 'price', label: 'Price', shortLabel: 'Price', format: 'currency' },
  { key: 'score', label: 'Comparable score', shortLabel: 'Score', format: 'number' },
  { key: 'marketCap', label: 'Market cap', shortLabel: 'Mkt cap', format: 'currencyCompact' },
];

const comparableMetricMap = comparableMetricOptions.reduce((acc, option) => {
  acc[option.key] = option;
  return acc;
}, {});

const getComparableMetric = (stock, key) => {
  if (!stock) return null;

  switch (key) {
    case 'marketCap':
      return normalizeMarketCap(stock.marketCap ?? stock.cap2 ?? stock.market_cap);
    case 'price':
      return toFiniteNumber(stock.price ?? stock.closePrice);
    case 'pe':
      return toFiniteNumber(stock.pe ?? stock.peTTM ?? stock.priceToEarnings);
    case 'ps':
      return toFiniteNumber(stock.ps ?? stock.priceToSales);
    case 'pb':
      return toFiniteNumber(stock.pb ?? stock.priceToBooks);
    case 'evSales':
      return toFiniteNumber(stock.evToSalesTTM ?? stock.evtoRevenue ?? stock.evToSales);
    case 'evEbitda':
      return toFiniteNumber(stock.evToEbitdaTTM ?? stock.evEbitda ?? stock.evtoebitda);
    case 'grossMargin':
      return toPercentMetric(stock.grossMarginTTM ?? stock.GrossMargin ?? stock.grossMargin);
    case 'netMargin':
      return toPercentMetric(stock.profitMarginTTM ?? stock.netMargin ?? stock.NetMargin);
    case 'roe':
      return toPercentMetric(stock.roeTTM ?? stock.ROE ?? stock.roe);
    case 'roa':
      return toPercentMetric(stock.roaTTM ?? stock.ROA ?? stock.roa);
    case 'currentRatio':
      return toFiniteNumber(stock.currentRatioQuarterly ?? stock.CurrentRatio ?? stock.currentRatio);
    case 'debtEquity':
      return toFiniteNumber(stock.debtToEquity ?? stock.debtToequity ?? stock.debtEquity);
    case 'beta':
      return toFiniteNumber(stock.beta);
    case 'score':
      return toFiniteNumber(stock.score);
    default:
      return null;
  }
};

const formatComparableValue = (key, value) => {
  const metric = comparableMetricMap[key];
  const n = toFiniteNumber(value);
  if (n == null) return '—';

  if (metric?.format === 'percent') return `${n.toFixed(1)}%`;
  if (metric?.format === 'currency') return `$${n.toFixed(2)}`;
  if (metric?.format === 'currencyCompact') return `$${formatCompactNumber(n)}`;
  if (metric?.format === 'multiple') return `${n.toFixed(2)}x`;
  return n.toFixed(2);
};

const formatCompactNumber = (value) => {
  const n = toFiniteNumber(value);
  if (n == null) return '—';
  if (Math.abs(n) >= 1e12) return `${(n / 1e12).toFixed(2)}T`;
  if (Math.abs(n) >= 1e9) return `${(n / 1e9).toFixed(2)}B`;
  if (Math.abs(n) >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
  if (Math.abs(n) >= 1e3) return `${(n / 1e3).toFixed(2)}K`;
  return n.toFixed(0);
};

// Simple linear size scale (selected size metric -> marker size px)
function scaleSize(values, minPx = 8, maxPx = 28) {
  const valid = values.filter((v) => Number.isFinite(v));
  if (!valid.length) return () => 14;

  const min = Math.min(...valid);
  const max = Math.max(...valid);
  const span = Math.max(1, max - min);
  return (v) => {
    if (!Number.isFinite(v)) return 14;
    return minPx + ((v - min) / span) * (maxPx - minPx);
  };
}

const onHover = (chartId) => (item) => {
  if (!item || item.dataIndex === undefined) {
    setHover({ chartId: null, index: null });
  } else {
    setHover({ chartId, index: item.dataIndex });
  }
};

const isHovering = (chartId) => hover.chartId === chartId && hover.index !== null;

  // If the current path is "/scanner", don't show the search bar
    useEffect(() => {
    //console.log("runs");
    const handleResize = () => {
    //console.log("handling");
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
      //console.log("mobile");
        
      } else {
      //console.log("desktop");
      
    }
    };
  
    // Invoke handleResize on component mount
    handleResize();
  
    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
  
    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);


const [comparables, setComparables] = useState([]);
const [points, setPoints] = useState([]);
const [compXAxis, setCompXAxis] = useState('evSales');
const [compYAxis, setCompYAxis] = useState('netMargin');
const [compSizeMetric, setCompSizeMetric] = useState('marketCap');

// Fetch comparables + current ticker
useEffect(() => {
  if (!ticker) return;

  const fetchComparables = async () => {
    try {
      const res = await axios.get(
        `https://stocksleuth.xyz:5000/getComparables?ticker=${ticker}`
      );

      const comps = (res.data?.comparables || []).filter(Boolean);
      setComparables(comps);

      const currentFromAPI = comps.find(
        (c) => c.symbol?.toUpperCase() === ticker.toUpperCase()
      );

      const current = currentFromAPI || {
        id: ticker.toLowerCase(),
        symbol: ticker.toUpperCase(),
        name: modifySecurityName(nameInfo) || ticker.toUpperCase(),
        isCurrent: true,
        price: ratios?.basicMetrics?.closePrice ?? currentPrice,
        marketCap: ratios?.basicMetrics?.marketCap ?? ratios?.basicMetrics?.cap2 ?? 0,
        pe: ratios?.basicMetrics?.priceToEarnings,
        ps: ratios?.basicMetrics?.priceToSales,
        pb: ratios?.basicMetrics?.priceToBooks,
        evToSalesTTM: ratios?.Ratios?.evtoRevenue ?? ratios?.ratios?.evtoRevenue,
        evToEbitdaTTM: ratios?.Ratios?.evtoebitda ?? ratios?.ratios?.evtoebitda,
        grossMarginTTM: ratios?.basicMetrics?.GrossMargin,
        profitMarginTTM: ratios?.basicMetrics?.netMargin,
        beta: ratios?.Ratios?.beta ?? ratios?.ratios?.beta,
        roaTTM: ratios?.Ratios?.ROA ?? ratios?.ratios?.ROA,
        roeTTM: ratios?.Ratios?.ROE ?? ratios?.ratios?.ROE,
        currentRatioQuarterly: ratios?.Ratios?.CurrentRatio ?? ratios?.ratios?.CurrentRatio,
        debtToEquity: ratios?.Ratios?.debtToequity ?? ratios?.ratios?.debtToequity,
        score: 100,
      };

      const uniqBySymbol = (arr) => {
        const seen = new Set();
        return arr.filter((item) => {
          const symbol = String(item?.symbol || '').toUpperCase();
          if (!symbol || seen.has(symbol)) return false;
          seen.add(symbol);
          return true;
        });
      };

      const merged = uniqBySymbol([current, ...comps].filter(Boolean)).slice(0, 14);
      setPoints(merged.length ? merged : demoStocks);
    } catch (err) {
      console.error("Error fetching comparables:", err);
      setComparables([]);
      setPoints(demoStocks); // fallback
    }
  };

  fetchComparables();
}, [ticker, ratios, currentPrice, nameInfo]);

// Always have something to work with
const stocks = points && points.length ? points : demoStocks;

const comparableScatterPoints = useMemo(() => {
  return stocks
    .map((stock) => {
      const x = getComparableMetric(stock, compXAxis);
      const y = getComparableMetric(stock, compYAxis);
      const size = getComparableMetric(stock, compSizeMetric);
      const marketCap = getComparableMetric(stock, 'marketCap');

      return {
        ...stock,
        id: stock.id || String(stock.symbol || '').toLowerCase(),
        symbol: String(stock.symbol || '').toUpperCase(),
        x,
        y,
        size,
        marketCap,
      };
    })
    .filter((stock) => Number.isFinite(stock.x) && Number.isFinite(stock.y));
}, [stocks, compXAxis, compYAxis, compSizeMetric]);

// Marker size scaling
const sizeFn = useMemo(() => {
  const scale = scaleSize(comparableScatterPoints.map((d) => d.size));
  return scale;
}, [comparableScatterPoints]);

// Build scatter series. One series per ticker keeps labels readable in the MUI legend/tooltip.
const series = useMemo(() => {
  return comparableScatterPoints.map((d) => ({
    label: d.symbol,
    data: [{
      x: d.x,
      y: d.y,
      id: d.id,
      symbol: d.symbol,
      name: d.name,
      marketCap: d.marketCap,
      size: d.size,
      isCurrent: String(d.symbol).toUpperCase() === String(ticker).toUpperCase(),
    }],
    markerSize: sizeFn(d.size),
  }));
}, [comparableScatterPoints, sizeFn, ticker]);

const activeXMetric = comparableMetricMap[compXAxis];
const activeYMetric = comparableMetricMap[compYAxis];
const activeSizeMetric = comparableMetricMap[compSizeMetric];

const selectStyle = {
  height: 32,
  borderRadius: 12,
  border: '1px solid rgba(148, 163, 184, 0.28)',
  background: '#f8fafc',
  color: '#111827',
  fontFamily: 'Lexend',
  fontSize: 11,
  fontWeight: 500,
  padding: '0 10px',
  outline: 'none',
};

const [isStickyTop, setIsStickyTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if ( ymoved > 22) {
        //console.log("sticky top triggered");
      setIsStickyTop(true);}
      else{
      setIsStickyTop(false);
      } // when sticky top is triggered
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

 const [fillColors6, setFillColors6] = useState({
    up: "rgba(38, 166, 154, 1)",
    down: "rgba(239, 83, 80, 1)",
  });

  const handleChange6 = (key, value) => {
    setCandlesAppearance((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleFillColorChange = (type, value) => {
    const newFillColors = { ...fillColors6, [type]: value };
    setFillColors6(newFillColors);
    setCandlesAppearance((prev) => ({
      ...prev,
      fill: (d) => (d.close > d.open ? newFillColors.up : newFillColors.down),
    }));
  };
const [fillColors62, setFillColors62] = useState({
    up: "rgba(38, 166, 154, 1)",
    down: "rgba(239, 83, 80, 1)",
  });
const handleFillColorChange2 = (type, value) => {
    const newFillColors = { ...fillColors62, [type]: value };
    setFillColors62(newFillColors);
    setCandlesAppearance((prev) => ({
      ...prev,
      wickStroke: (d) => (d.close > d.open ? newFillColors.up : newFillColors.down),
    }));
  };
function convertToMonthYear(dateString) {
  const clean = cleanDateString(dateString);
  if (!clean) return '';
  const date = new Date(clean);
  if (isNaN(date)) return '';
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${month}/${year}`;
}

// Format "2024"
function convertToYear(dateString) {
  const clean = cleanDateString(dateString);
  if (!clean) return '';
  const date = new Date(clean);
  if (isNaN(date)) return '';
  return `${date.getFullYear()}`;
}

// Example usage:

const handleCopyLink = (path) => {
  if (!document.hasFocus()) {
    console.warn("Cannot copy to clipboard: document is not focused.");
    return;
  }

  const url = `${window.location.origin}${window.location.pathname}#${path}`;
  
  navigator.clipboard.writeText(url)
    .then(() => {
      //console.log("Copied to clipboard:", url);
      // Optional: show toast or message here
    })
    .catch((err) => {
      console.error("Clipboard copy failed:", err);
      alert("Clipboard copy failed. Try clicking again with the tab focused.");
    });
};
 const [showStickyDetails, setShowStickyDetails] = useState(false);
  const scrollRef = useRef(null);
const [ymoved, setYMoved] = useState(0);
 useEffect(() => {
  const container = document.querySelector(".content"); // or "#content" if it's an ID
  if (!container) {
    console.warn("Scrollable container not found");
    return;
  }


  const handleScroll = () => {
    const scrollY = container.scrollTop;
    
    const threshold = 180;
    if (scrollY > 22) {
      setIsStickyTop(true);
    } else {
      setIsStickyTop(false);
      } 
    setYMoved(scrollY);
    setShowStickyDetails(scrollY > threshold);
  };

  container.addEventListener("scroll", handleScroll);

  return () => {
    container.removeEventListener("scroll", handleScroll);
  };
}, []);



const formatEasternTime = (date) => {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(date);
  };

  const isMarketOpen = (date) => {
    const eastern = new Date(date.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const hours = eastern.getHours();
    const minutes = eastern.getMinutes();
    const totalMinutes = hours * 60 + minutes;

    // Market open = 9:30 AM (570 min), close = 4:00 PM (960 min)
    return totalMinutes >= 570 && totalMinutes < 960;
  };

  const formatDateForClose = (date) => {
    const options = {
      timeZone: 'America/New_York',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(date);

    const month = parts.find(p => p.type === 'month').value;
    const day = parts.find(p => p.type === 'day').value;
    const hour = parts.find(p => p.type === 'hour').value;
    const minute = parts.find(p => p.type === 'minute').value;
    const dayPeriod = parts.find(p => p.type === 'dayPeriod').value;

    return `At close: ${month} ${day}, ${hour}:${minute}${dayPeriod} EDT`;
  };

  const displayText = isMarketOpen(lastFetch)
    ? `As of ${formatEasternTime(lastFetch)}: Current price`
    : formatDateForClose(lastFetch);






const shownExamples = exampleQuestions
  .sort(() => Math.random() - 0.5)
  .slice(0, 3);

    const [messagesAI, setMessagesAI] = useState([
      {
        sender: "sleuthAI",
        text: "👋 Hi there! Ask me anything about this stock, and I’ll help."
      }
    ]);
    const [inputText, setInputText] = useState("");
    const chatEndRef = useRef(null);
    const functions = [
      {
        name: "getQuarterlyData",
        description: "Fetch the latest quarterly financial report for a given stock.",
        parameters: {
          type: "object",
          properties: {
            symbol: { type: "string", description: "Ticker symbol, e.g. FLNG" }
          },
          required: ["symbol"]
        }
      },
      {
        name: "getYearlyData",
        description: "Fetch the latest full-year financial report for a given stock.",
        parameters: {
          type: "object",
          properties: {
            symbol: { type: "string", description: "Ticker symbol, e.g. FLNG" }
          },
          required: ["symbol"]
        }
      },
      {
        name: "getNewsItems",
        description: "Fetch up to `limit` news headlines and descriptions for a given stock.",
        parameters: {
          type: "object",
          properties: {
            symbol: { type: "string", description: "Ticker symbol, e.g. FLNG" },
            limit: { type: "integer", description: "Max number of items to return" }
          },
          required: ["symbol", "limit"]
        }
      }
    ];
    useEffect(() => {
      chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messagesAI]);
  
    const handleSend = (q = inputText) => {
      setIsThinking(true);
      const trimmed = q.trim();
      if (!trimmed) return;
    
      // 1) build your “data” object
      const first15Filtered = items
        .slice(0, 15)
        .map(({ title, description, pubDate }) => ({ title, description, pubDate }));
    
      const payloadData = {
        ticker,
        currentPrice,
        prevPrice,
        periodlow,
        periodhigh,
        ratios,
        description,
        nameInfo,
        sector,
        industry: industryt,
        sharesOutstanding,
        BSmultiplier,
        ISmultiplier,
      };
    
      // 2) append user message to UI
      setMessagesAI(m => [...m, { sender: "user", text: trimmed }]);
      setInputText("");
    
      // 3) call your AI with both data+question
      handleAIResponse(trimmed, payloadData, FYData[0], QData[0], first15Filtered);
    };
    
    async function handleAIResponse(question, data, yearly, quarter, news) {
      // build the chat history you want to send
      const history = messagesAI
    .map(m => ({
      role: m.sender === "user" ? "user" : "assistant",
      content: m.text
    }))
    .slice(-6);
    //console.log("history", history, messagesAI);
      const messages = [
        {
          role: "system",
          content: `

You are **StockSleuth AI**. You have three tools at your disposal:

---

### 1. getQuarterlyData(symbol)  
- **Purpose:** Returns **all** quarterly report fields (10‑Q), including:  
  - Income statement: revenue, EPS, net income, gross profit, operating expenses, etc.  
  - **Balance sheet**: assets, liabilities, **Property, Plant & Equipment**, equity, working capital, etc.  
  - Cash flow: net cash from operations, capEx, dividends, financing flows, etc.  
- **When to use:** Whenever the user asks for any quarterly‑period data **not** already present in the provided JSON.

---

### 2. getYearlyData(symbol)  
- **Purpose:** Returns full‑year metrics (10‑K): annual revenue, year‑over‑year growth, full‑year EPS, year‑end balance‑sheet totals, etc.  
- **When to use:** Whenever the user asks for any full‑year data **not** already present in the provided JSON.

---

### 3. getNewsItems(symbol, limit)  
- **Purpose:** Returns recent headlines and snippets.  
- **When to use:** For questions like “why is X up/down?”, requests for headlines, market sentiment, or broader news context.

---

## Basics Available in the "data" Object  
_These fields are already present under the "data" message—do **not** call a function to fetch them:_

- **Ratios**: beta, EV/EBITDA, ROE, current ratio, debt‑to‑equity, ROIC, etc.  
- **Bankruptcy scores**: Altman Z, Altman 2 Z, etc.  
- **basicMetrics**: EBITDA, EV, equity, cash, debt, marketCap, P/E, margins, free cash flows, DCF/share, revenues, etc.  
- **RadarValues**: liquidity, growth, value, health, profitability, dividend scores.

---

## Routing Rules (in order)

1. **Answer from basics.**  
   - If the user’s question can be answered (including simple derived calculations) using the fields in the "data" JSON, respond directly—do **not** call any tool.

2. **Fallback to quarterly.**  
   - If you cannot satisfy the request from basics—or the user asks for **any balance‑sheet item** (e.g. “PP&E,” “assets,” “liabilities,” “equity”) or the time period is unclear—invoke **getQuarterlyData** to fetch the latest quarter.

3. **Full‑year data.**  
   - If the user explicitly asks for annual or year‑end metrics not in basics, call **getYearlyData**.

4. **News or sentiment.**  
   - If the user wants headlines, “why is X up/down?”, or market context, call **getNewsItems**.

5. **Never say “I can’t.”**  
   - Always either answer from the data you have or invoke the correct tool.

---

**Always** set "function_call: "auto"" in your API request.

---
#### Definitions & Educational Explanations Allowed  
- You **may** explain, define, or describe any financial instrument (e.g. “What is a put option?”, “How do CFDs work?”) in clear, factual terms.  
- Such definitions are **educational only**—you are not recommending that the user buy or sell anything.  
- Only when the user asks “Should I buy/ sell/ invest in…?” do you append your disclaimer and refuse personalized advice.

---

### Example Integration

6. **Definitions Allowed.**  
   If the user asks “What is X?” or “How does Y work?” for any financial instrument or strategy, provide a factual, educational explanation.  
   - Do **not** treat these as “advice requests.”  
   - Only append the disclaimer when the user asks for a recommendation (“Should I…?”).

7. **Hedging & Risk Management.**  
   If the user asks how to hedge, protect, or manage risk, immediately provide educational strategies (options, CFDs, etc.) with mechanics, pros/cons, examples, then append the disclaimer.  

> **Disclaimer:** This information is educational only and does **not** constitute investment advice. Consult a licensed professional before acting.
`
}
,
        {
          role: "user",
          name: "data",
          content: JSON.stringify(data)
        },
        ...history,
        {
          role: "user",
          content: question
        }
      ];
    
      try {
        const res = await apiFetch("https://stocksleuth.xyz:5000/api/chatAI", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ messages, useFunctions : true })
        });
        if (!res.ok) throw new Error(`Status ${res.status}`);
        const json = await res.json();
        const aiMessage = json.choices?.[0]?.message?.content ?? "🤖 (no reply)";
        if ( JSON.stringify(aiMessage).includes("getQuarterlyData")){
          const messages = [
            {
              role: "system",
              content: `
You are StockSleuth AI. You now have the user’s stock data available in the “data” message. Your job is to answer any follow-up questions using exactly that JSON:

• If the requested metric or value exists in the data, return it directly (with appropriate units).  
• If a simple calculation is needed (for example, free cash flow, growth rates, margins), compute it from the fields in the data and return the result.  
• If the user asks for something not present in the data, explain that the information isn’t available.  
• Keep your answers concise, clear, and numerically precise.  

Always base your reply on the “data” message and do not request additional information.
use markdown to make the text more readable.
`

            },
            ...history,
            {
              role: "user",
              name: "data",
              content: JSON.stringify(quarter)
            },
            
            {
              role: "user",
              content: question
            }
          ];
        
          try {
            const res = await apiFetch("https://stocksleuth.xyz:5000/api/chatAI", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ messages, useFunctions : false })
            });
            if (!res.ok) throw new Error(`Status ${res.status}`);
            const json = await res.json();
            const aiMessage = json.choices?.[0]?.message?.content ?? "🤖 (no reply)";
            setMessagesAI(m => [...m, { sender: "sleuthAI", text: aiMessage }]);
            setIsThinking(false);
          } catch (err) {
            console.error("ChatAPI error:", err);
            setMessagesAI(m => [
              ...m,
              { sender: "sleuthAI", text: "😞 Oops, something went wrong." }
            ]);
          }
        }
        else if (JSON.stringify(aiMessage).includes("getYearlyData")){

          const messages = [
            {
              role: "system",
content: `
You are StockSleuth AI. You now have the user’s stock data available in the “data” message. Your job is to answer any follow-up questions using exactly that JSON:

• If the requested metric or value exists in the data, return it directly (with appropriate units).  
• If a simple calculation is needed (for example, free cash flow, growth rates, margins), compute it from the fields in the data and return the result.  
• If the user asks for something not present in the data, explain that the information isn’t available.  
• Keep your answers concise, clear, and numerically precise.  

Always base your reply on the “data” message and do not request additional information.
use markdown to make the text more readable.
`
            },
            ...history,
            {
              role: "user",
              name: "data",
              content: JSON.stringify(yearly)
            },
            {
              role: "user",
              content: question
            }
          ];
        
          try {
            const res = await apiFetch("https://stocksleuth.xyz:5000/api/chatAI", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ messages, useFunctions : false })
            });
            if (!res.ok) throw new Error(`Status ${res.status}`);
            const json = await res.json();
            const aiMessage = json.choices?.[0]?.message?.content ?? "🤖 (no reply)";
            setMessagesAI(m => [...m, { sender: "sleuthAI", text: aiMessage }]);
            setIsThinking(false);
          } catch (err) {
            console.error("ChatAPI error:", err);
            setMessagesAI(m => [
              ...m,
              { sender: "sleuthAI", text: "😞 Oops, something went wrong." }
            ]);
          }

        }
        else if (JSON.stringify(aiMessage).includes("getNewsItems")){
          const messages = [
            {
              role: "system",
content: `
You are StockSleuth AI. You now have the user’s stock data available in the “data” message. Your job is to answer any follow-up questions using exactly that JSON:

• If the requested metric or value exists in the data, return it directly (with appropriate units).  
• If a simple calculation is needed (for example, free cash flow, growth rates, margins), compute it from the fields in the data and return the result.  
• If the user asks for something not present in the data, explain that the information isn’t available.  
• Keep your answers concise, clear, and numerically precise.  

Always base your reply on the “data” message and do not request additional information.
use markdown to make the text more readable.
`
            },
            ...history,
            {
              role: "user",
              name: "data",
              content: JSON.stringify(news)
            },
            {
              role: "user",
              content: question
            }
          ];
        
          try {
            const res = await apiFetch("https://stocksleuth.xyz:5000/api/chatAI", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ messages, useFunctions : false })
            });
            if (!res.ok) throw new Error(`Status ${res.status}`);
            const json = await res.json();
            const aiMessage = json.choices?.[0]?.message?.content ?? "🤖 (no reply)";
            setMessagesAI(m => [...m, { sender: "sleuthAI", text: aiMessage }]);
            setIsThinking(false);
          } catch (err) {
            console.error("ChatAPI error:", err);
            setMessagesAI(m => [
              ...m,
              { sender: "sleuthAI", text: "😞 Oops, something went wrong." }
            ]);
          }

        }
        else{
        setMessagesAI(m => [...m, { sender: "sleuthAI", text: aiMessage }]);
        setShowTypewriter(true);
        setTimeout(() => setShowTypewriter(false), 800);
      setIsThinking(false);
    }
      } catch (err) {
        console.error("ChatAPI error:", err);
        setMessagesAI(m => [
          ...m,
          { sender: "sleuthAI", text: "😞 Oops, something went wrong." }
        ]);
      }
    }
    






    const [indicators, setIndicators] = useState([
      
      
      //{ indicator: 'macd', macdSignal: 9, macdFast: 12, macdSlow: 26},
      //{ indicator: 'bb' },
      //{ indicator: 'ema', value: 300 },
      //{ indicator: 'elder' },
    ]);
    const indicatorsList = [
      {indicator: "bb", label: "Bollinger Bands"},
      {indicator: "sma", label: "Simple Moving Average"},
      {indicator: "ema", label: "Exponential Moving Average"},
      {indicator: "elder", label: "Elder Ray"},
      {indicator: "wma", label: "Weighted Moving Average"},
      {indicator: "tma", label: "Triangular Moving Average"},
      {indicator: "macd", label: "MACD"},
      {indicator: "rsi", label: "RSI", label: "Relative Strength Index"},
      {indicator: "atr", label: "Average True Range"},
      {indicator: "stoch", label: "Stochastic Oscillator"},
      {indicator: "fi", label: "Force Index"},
      {indicator: "fiEMA", label: "Force Index EMA"},
      //{indicator: "elderImpulse", label: "Elder Impulse"},
      {indicator: "sar", label: "Parabolic SAR"},
      {indicator: "volumeProfile", label: "Volume Profile"}, 
      {indicator: "volume", label: "Volume"}, 
      {indicator: "volumeProfileBySession", label: "Volume Profile by Session"}, 
    ];
    const [tempConfigs, setTempConfigs] = useState([...indicators]);
    const updateTemp = (index, field, val) => {
      const updated = [...indicators];
      //console.log("updating", field, val, index, indicators);
      updated[index][field] = field === "value" ? parseInt(val) : val;
      setTempConfigs(updated);
    };

    const confirmChange = (index) => {
      const updated = [...indicators];
      updated[index] = tempConfigs[index];
      setIndicators(updated);
    };


   
    




    const [AdvChartData, setAdvChartData] = useState( [
      {
        date: "2021-02-02 16:00:00",
        open: 134.9307,
        low: 134.9105,
        high: 135.4215,
        close: 135.0087,
        volume: 73591581
      }]);

    const [dimensions, setDimensions] = useState({ width: 100, height: 100 });

    // ← ADD THIS
    ; // Empty dependency array ensures this effect runs only once after the initial render.
    




    const allIndicators = ["elder", "macd", "rsi", "atr", "stoch", "fi", "fiEMA"];


    const active = indicators
    .map((cfg) => cfg.indicator)
    .filter((name) => allIndicators.includes(name));
  
  // 3) Compute the layout percentages:
  function getChartLayout(count) {
    let pricePct;
    if (count <= 1) {
      pricePct = 100;
    } else if (count === 2) {
      pricePct = 80;
    } else if (count === 3) {
      pricePct = 60;
    } 
    else{
      pricePct = 55;
    } 
  
    const available = 100 - pricePct;
    const per       = count > 0 ? Math.floor(available / count) : 0;
    const layout2    = { price: pricePct };
  
    for (let i = 1; i <= count; i++) {
      layout2[i] = i < count
        ? per
        : available - per * (count - 1);
    }
    const positions = [];
    //console.log(layout2);
    let cumulative = pricePct;
    for (let i = 2; i <= count; i++) {
      
      positions.push(cumulative);
      //console.log((100 - layout2.price)/active.length);
      cumulative += (100 - layout2.price)/active.length; //   (100 - layout.price)/active.length
    }
    //console.log(positions);
    setBottomChartOrigins(positions);
    return layout2;
  }
  
  const [layout, setLayout] = useState({price: 100})
  
  useEffect(() => {
  setLayout(getChartLayout(active.length + 1));
  
  //console.log(layout);
  }, [indicators]);






  const stoAppearance = {
    stroke: Object.assign({},
      StochasticSeries.defaultProps.stroke)
  };

    const toggleQuarterly = (value) => {
      // Set the state based on the boolean value passed as an argument
      setIsQuarterly(value ? true : false); // true if value is true, false if value is false
    };

    useEffect(() => {
      //console.log("MULTIPLIER CHANGED");
      if (BSmultiplier !== 1) {
        setIsBSmultiplierLoaded(true);
      }
    }, [BSmultiplier]);
    const [filings, setFilings] = useState([]);
    const [filingsPopup, setFilingsPopup] = useState(false);
    useEffect(() => {
      setFinishedLoading(false);
      const fetchFinancialData = async () => {
        setLoading(true);
        setError(null);
        try {
          const stockDetailsResponse = await fetch(
            `https://stocksleuth.xyz:5000/auth/getstockdetails?symbol=${ticker}`
          );
          const stockDetails = await stockDetailsResponse.json();

          if (stockDetails.security_name) {
            setnameInfo(stockDetails.security_name); // Set the security_name
          } else {
            //console.log("No stock details found for", ticker);
          }
          setDescription(stockDetails.Description);
          setLongBio(stockDetails.longBio);
          setExecs(stockDetails.Executives || []);
          setCompRisks(stockDetails.Risks || []);
          //console.log(stockDetails);  
          if (stockDetails.logo) {
            const logoBuffer = new Uint8Array(stockDetails.logo.data); // Use Uint8Array to convert binary data
            const base64Logo = btoa(String.fromCharCode.apply(null, logoBuffer)); // Convert to base64
            setLogoimg(`data:image/png;base64,${base64Logo}`);
            setSector(stockDetails.sector);
            setIndustry(stockDetails.industry);
          } else {
            setLogoimg(null);
            //console.log("no logoooooo");
            
          }
        } catch {
          //console.log("eror");
        }
        try {
          // First, request GetHistoricalFinancials and GetRatiosAndAllThat
          const response46 = await fetch(
            `https://stocksleuth.xyz:5000/GetHistoricalFinancials?ticker=${ticker}`
          );
          const responseR = await fetch(
            `https://stocksleuth.xyz:5000/GetRatiosAndAllThat?ticker=${ticker}&rerun=1`
          );

          // Parse JSON responses
          const data46 = await response46.json();
          const ratiosResponse = await responseR.json();
          setDataValues([
            ratiosResponse.RadarValues.LiquidityScore,
            ratiosResponse.RadarValues.growthScore,
            ratiosResponse.RadarValues.valueScore,
            ratiosResponse.RadarValues.healthScore,
            ratiosResponse.RadarValues.profitabilityScore,
            ratiosResponse.RadarValues.dividendScore,
          ]);
          setRatios(ratiosResponse);
          setAllHistData(data46.financialStatements?.quarterly || []);
          setQdata(data46.financialStatements?.quarterly || []);
          setFYdata(data46.financialStatements?.annual || []);
          const latestQuarter = data46.financialStatements?.quarterly?.[0];
          const latestAnnual = data46.financialStatements?.annual?.[0];
          // The current endpoint returns raw dollars with a multiplier of 1.
          // Use thousands for small companies so useful precision is not lost.
          const findScaleBenchmark = (filing) => {
            const benchmarkKeys = new Set([
              "Assets", "Revenues", "Revenue from Contract with Customer, Excluding Assessed Tax",
              "Net Cash Provided by (Used in) Operating Activities",
            ]);
            let largest = 0;
            const visit = (node) => {
              if (!node || typeof node !== "object") return;
              Object.entries(node).forEach(([key, value]) => {
                if (benchmarkKeys.has(key) && Number.isFinite(Number(value?.numVal))) {
                  largest = Math.max(largest, Math.abs(Number(value.numVal)));
                }
                if (key !== "numVal" && value && typeof value === "object") visit(value);
              });
            };
            visit(filing?.IncomeStatement);
            visit(filing?.BalanceSheet);
            visit(filing?.CashFlows);
            return largest;
          };
          const normalizeFinancialMultiplier = (multiplier) => {
            const parsedMultiplier = Number(multiplier);
            if (parsedMultiplier > 1) return parsedMultiplier;
            const benchmark = findScaleBenchmark(latestAnnual || latestQuarter);
            return benchmark > 0 && benchmark < 1000000000 ? 1000 : 1000000;
          };
          setBSmultiplier(normalizeFinancialMultiplier(latestQuarter?.BSmultiplier));
          setISmultiplier(normalizeFinancialMultiplier(latestQuarter?.ISmultiplier));
          setlastFy(
            latestAnnual?.endDate ||
              latestAnnual?.reportDate ||
              latestAnnual?.quarterBS ||
              null
          );
          setIncomeData(data46.financialStatements?.quarterly[0].IncomeStatement);
          setSharesOutstanding(data46.financialStatements?.quarterly[0].sharesOutstanding || null);
          //setMostRecentQ();
          setcfData(data46.financialStatements?.quarterly[0].CashFlows);
          setBalanceSheetData(
            data46.financialStatements?.quarterly[0].BalanceSheet
          );
const quarterly = data46.financialStatements?.quarterly || [];
  const filingsArray = quarterly
    .filter((q) => q.filingUrl && q.form) // only those with valid data
    .map((q) => ({
      reportDate: q.reportDate || null,
      filingDate: q.filingDate || null,
      filingUrl: q.filingUrl,
      form: q.form,
    }));

  setFilings(filingsArray);
          // Check if we need to request the 3 statements
          const isDataInvalid =
            !data46.financialStatements ||
            !data46.financialStatements.quarterly ||
            data46.financialStatements.quarterly.length === 0;

          if (isDataInvalid) {
            const urls = [
              {
                key: "incomeStatement",
                url: `https://stocksleuth.xyz:5000/api/incomestatement/${ticker}`,
              },
              {
                key: "balanceSheet",
                url: `https://stocksleuth.xyz:5000/api/balancesheet/${ticker}`,
              },
              {
                key: "cashFlow",
                url: `https://stocksleuth.xyz:5000/api/cashflow/${ticker}`,
              },
            ];

            const results = await Promise.allSettled(
              urls.map(({ url }) => axios.get(url))
            );

            results.forEach((result, index) => {
              if (result.status === "fulfilled") {
                const key = urls[index].key;
                const data = result.value.data;

                if (key === "incomeStatement") {
                  setIncomeData(data.incomeStatement);
                  setISmultiplier(data.multiplier);
                }
                if (key === "balanceSheet") {
                  setBalanceSheetData(data.balanceSheet);
                  setBSmultiplier(data.multiplier);
                  setMostRecentQ(data.quarterBS);
                }
                if (key === "cashFlow") {
                  setcfData(data.cashFlow);
                }
              } else {
                console.error(
                  `Error fetching ${urls[index].key}:`,
                  result.reason
                );
              }
            });
          }

          // New API call to get security_name and logo
        } catch (error) {
          console.error("Error fetching financial data:", error);
        } finally {
          setLoading(false);
          setFinishedLoading(true);
        }
      };

      if (ticker) {
        fetchFinancialData();
      }
    }, [ticker]);

    useEffect(() => {
      const fetchFinancialData = async () => {
        setLoading(true);
        setError(null);
        const response48 = await fetch(
          `https://stocksleuth.xyz:5000/GetHistoricalFinancials?ticker=${ticker}`
        );

        // Parse the response body as JSON
        const data48 = await response48.json();

        // Log the parsed data (this is the actual financial data)

        // Set the parsed data into state
        if (isQuarterly) {
          setAllHistData(data48.financialStatements.quarterly);
        } else {
          setAllHistData(data48.financialStatements.annual);
        }
        setLoading(false);
      };

      if (ticker) {
        fetchFinancialData();
      }
    }, [isQuarterly]);
    const [sharesOutstanding, setSharesOutstanding] = useState(null);
    const [items, setItems] = useState([]);    // RSS items
const [shortInterest, setShortInterest] = useState(null);
const [siError, setSiError] = useState('');
useEffect(() => {
  if (!ticker) return;

  const fetchShortInterest = async () => {
    try {
      const { data } = await axios.post(
        'https://stocksleuth.xyz:5000/auth/shortInterest',
        {
          ticker,
          useMock: true,   // ← ask for the mock dataset
          limit: 5         // ← how many rows you’d like back
        }
      );
      setShortInterest(data);
    } catch (err) {
      setSiError('Failed to load short interest.');
    }
  };

  fetchShortInterest();
}, [ticker]);

    useEffect(() => {
      if (!ticker) return;
  
      const fetchNews = async () => {
        try {
          const { data } = await axios.get(
            `https://stocksleuth.xyz:5000/news/${ticker}`
          );
          setItems(data.items);
        } catch (err) {
          console.error(err);
          setError('Failed to load news.');
        } finally {
        }
      };
  
      fetchNews();
    }, [ticker]);
    useEffect(() => {
      const fetchSharesOutstanding = async () => {
        if (!ticker) return; // Ensure ticker is defined before making a request

        setLoading(true);
        setError(null);

        try {
          const response = await axios.get(
            `https://stocksleuth.xyz:5000/getSharesOutstanding?ticker=${ticker}`
          );
          setSharesOutstanding(response.data.sharesOutstanding);
        } catch (err) {
          console.error("Error fetching shares outstanding:", err);
          setError(err.response?.data?.error || "Failed to fetch data");
        } finally {
          setLoading(false);
        }
      };

      fetchSharesOutstanding();
    }, [ticker]);
    useEffect(() => {
      const fetchCurrentPrice = async () => {
        try {
          const proxyUrl = "https://stocksleuth.xyz:5000/call?url=";
          const apiUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${ticker}?metrics=high&interval=1d&range=1d`;
          const encodedApiUrl = encodeURIComponent(apiUrl);

          const response = await axios.get(proxyUrl + encodedApiUrl);
          const data = response.data.chart.result[0].indicators.quote[0];
          const price = parseFloat(data.close.slice(-1)[0]).toFixed(2);

          setCurrentPrice(price);
          setLastFetch(new Date(response.data.chart.result[0].meta.regularMarketTime*1000)); // Convert to milliseconds
          setExchangeName(response.data.chart.result[0].meta.fullExchangeName);
          set52weeklow(response.data.chart.result[0].meta.fiftyTwoWeekLow);
          set52weekhigh(response.data.chart.result[0].meta.fiftyTwoWeekHigh);
          setPrevPrice(response.data.chart.result[0].meta.chartPreviousClose);
          //const logoResponse = await axios.get(`https://stocksleuth.xyz:5000/auth/getwebsite?ticker=${ticker}`);
          //setLogoInfo(logoResponse.data.lastElement.text);
        } catch (error) {
          console.error("Failed to fetch current price", error);
        }
      };

      fetchCurrentPrice();
    }, [ticker]);














  const [sma50, setSma50] = useState(null)
  const [sma200, setSma200] = useState(null)
  const [rsiVal, setRsiVal] = useState(null)
  const [macdVal, setMacdVal] = useState(null)
  const [signalVal, setSignalVal] = useState(null)
  const [histVal, setHistVal] = useState(null)

  // helper for SMA array
  const calcSMAArray = (data, period) => {
    const result = []
    for (let i = 0; i < data.length; i++) {
      if (i + 1 >= period) {
        const sum = data.slice(i + 1 - period, i + 1).reduce((a, v) => a + v, 0)
        result.push(sum / period)
      } else result.push(null)
    }
    return result
  }



  // compute latest technical metrics
  
























    useEffect(() => {
      const checkIfFavorite = async () => {
        try {
          if (!user?.displayname) return; // Check if user or displayname is null
          const response = await checkFavorite(ticker);
          setIsFavorite(response.data.isFavorite);
        } catch (error) {
          console.error("Failed to check if ticker is in favorites", error);
        }
      };

      if (isLoggedIn) {
        checkIfFavorite();
      }
    }, [isLoggedIn, ticker, user?.displayname]);

    // Function to toggle favorites
    const toggleFavorite = async () => {
      try {
        if (isFavorite) {
          // Remove from favorites
          await removeFavorite(ticker);
        } else {
          // Add to favorites
          await addFavorite(ticker);
        }
        setIsFavorite(!isFavorite);
      } catch (error) {
        console.error("Failed to toggle favorite", error);
      }
    };
  const [advInterval, setAdvInterval] = useState("1d");
  function timeAgo(dateString) {
    const now = new Date();
    const then = new Date(dateString);  // your pubDate is UTC, JS Date will parse it correctly
    const diffMs      = now - then;
    const diffSecs    = Math.floor(diffMs / 1000);
    const diffMins    = Math.floor(diffSecs / 60);
    if (diffMins < 1)  return 'just now';
    if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
  
    const diffHrs = Math.floor(diffMins / 60);
    if (diffHrs < 24) return `${diffHrs} hour${diffHrs !== 1 ? 's' : ''} ago`;
  
    const diffDays = Math.floor(diffHrs / 24);
    if (diffDays < 30) return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
  
    const diffMonths = Math.floor(diffDays / 30);
    return `${diffMonths} month${diffMonths !== 1 ? 's' : ''} ago`;
  }
  const fetchStockData3 = async () => {
    try {
      const proxyUrl = "https://stocksleuth.xyz:5000/call?url=";
      let range = "5y"; // default range
      switch (advInterval) {
        case "15m":
          range = "1mo";
          break;
        case "1h":
          range = "6mo";
          break;
          case "4h":
            range = "3mo";
            break;
        case "5m":
          range = "1wk";
          break;
        case "1m":
          range = "1d";
          break;
        default:
          range = "5y"; // default range
      }

      // Construct the API URL
      const apiUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${ticker}?metrics=high&interval=${advInterval}&range=${range}`;
      const encodedApiUrl = encodeURIComponent(apiUrl);
      const response = await axios.get(proxyUrl + encodedApiUrl);
      const data = response.data.chart.result[0];
      const { timestamp } = data;
      const { open, high, low, close, volume } = data.indicators.quote[0];

      if (!timestamp || !open || !close || !high || !low || !volume) {
        console.warn("Missing data fields");
        return;
      }

      const formatted = timestamp.map((ts, i) => ({
        date: new Date(ts * 1000).toISOString().replace("T", " ").substring(0, 19),
        open: open[i],
        high: high[i],
        low: low[i],
        close: close[i],
        volume: volume[i],
        absoluteChange: close[i] - open[i],
      })).filter(d =>
        d.open != null &&
        d.high != null &&
        d.low != null &&
        d.close != null &&
        d.volume != null
      ); // filter out incomplete rows

      setAdvChartData(formatted);
      // Set the raw data state
      setRawData(formatted)
    } catch (error) {
      console.error("Error fetching stock data:", error);
    }
  };
  const [rawData, setRawData] = useState([]); 

useEffect(() => {
  if (!Array.isArray(rawData) || rawData.length === 0) return;

  // Indicators expect observations ordered from oldest to newest.
  const cleanData = rawData
    .map((item) => ({
      ...item,
      open: Number(item.open),
      high: Number(item.high),
      low: Number(item.low),
      close: Number(item.close),
      volume: Number(item.volume),
    }))
    .filter((item) => Number.isFinite(item.close));

  if (cleanData.length === 0) return;

  setTrendRating(getTrendRating(cleanData));
  setMomentumRating(getMomentumRating(cleanData));
  setVolumeRating(getVolumeRating(cleanData));
}, [rawData]);

const clamp = (value, min = -100, max = 100) =>
  Math.min(max, Math.max(min, value));

const normalizeToScore = (value, fullScale) => {
  if (
    !Number.isFinite(value) ||
    !Number.isFinite(fullScale) ||
    fullScale === 0
  ) {
    return 0;
  }

  return clamp((value / fullScale) * 100);
};

const scoreToRating = (score) => {
  if (!Number.isFinite(score)) return "Neutral";

  if (score >= 60) return "Strong Buy";
  if (score >= 20) return "Buy";
  if (score > -20) return "Neutral";
  if (score > -60) return "Sell";

  return "Strong Sell";
};

function getSMA(values, period) {
  if (!Array.isArray(values) || values.length < period) {
    return null;
  }

  const slice = values.slice(-period);

  return (
    slice.reduce((sum, value) => sum + value, 0) /
    slice.length
  );
}

function getEMA(values, period) {
  const result = new Array(values.length).fill(null);

  if (
    !Array.isArray(values) ||
    values.length < period ||
    period <= 0
  ) {
    return result;
  }

  // Seed the EMA using a real period-length SMA.
  const seed =
    values
      .slice(0, period)
      .reduce((sum, value) => sum + value, 0) / period;

  result[period - 1] = seed;

  const multiplier = 2 / (period + 1);

  for (let i = period; i < values.length; i++) {
    result[i] =
      values[i] * multiplier +
      result[i - 1] * (1 - multiplier);
  }

  return result;
}

function getRSI(values, period = 14) {
  const result = new Array(values.length).fill(null);

  if (!Array.isArray(values) || values.length <= period) {
    return result;
  }

  let totalGains = 0;
  let totalLosses = 0;

  for (let i = 1; i <= period; i++) {
    const change = values[i] - values[i - 1];

    if (change > 0) {
      totalGains += change;
    } else {
      totalLosses += Math.abs(change);
    }
  }

  let averageGain = totalGains / period;
  let averageLoss = totalLosses / period;

  const calculateRSI = () => {
    if (averageGain === 0 && averageLoss === 0) return 50;
    if (averageLoss === 0) return 100;
    if (averageGain === 0) return 0;

    const relativeStrength = averageGain / averageLoss;

    return 100 - 100 / (1 + relativeStrength);
  };

  result[period] = calculateRSI();

  for (let i = period + 1; i < values.length; i++) {
    const change = values[i] - values[i - 1];

    const gain = Math.max(change, 0);
    const loss = Math.max(-change, 0);

    averageGain =
      (averageGain * (period - 1) + gain) / period;

    averageLoss =
      (averageLoss * (period - 1) + loss) / period;

    result[i] = calculateRSI();
  }

  return result;
}

function getLatestMACD(
  values,
  fastPeriod = 12,
  slowPeriod = 26,
  signalPeriod = 9
) {
  if (values.length < slowPeriod + signalPeriod) {
    return null;
  }

  const fastEMA = getEMA(values, fastPeriod);
  const slowEMA = getEMA(values, slowPeriod);

  const macdValues = [];

  for (let i = 0; i < values.length; i++) {
    if (
      Number.isFinite(fastEMA[i]) &&
      Number.isFinite(slowEMA[i])
    ) {
      macdValues.push(fastEMA[i] - slowEMA[i]);
    }
  }

  if (macdValues.length < signalPeriod) {
    return null;
  }

  const signalValues = getEMA(macdValues, signalPeriod);

  const macd = macdValues[macdValues.length - 1];
  const signal = signalValues[signalValues.length - 1];

  if (!Number.isFinite(macd) || !Number.isFinite(signal)) {
    return null;
  }

  return {
    macd,
    signal,
    histogram: macd - signal,
  };
}

function getTrendRating(data) {
  const closes = data
    .map((item) => item.close)
    .filter(Number.isFinite);

  // A genuine EMA200 cannot be calculated from fewer than 200 sessions.
  if (closes.length < 200) {
    return "Neutral";
  }

  const ema20 = getEMA(closes, 20);
  const ema50 = getEMA(closes, 50);
  const ema200 = getEMA(closes, 200);

  const lastIndex = closes.length - 1;
  const slopeLookback = Math.min(10, lastIndex);
  const slopeIndex = lastIndex - slopeLookback;

  const close = closes[lastIndex];
  const currentEMA20 = ema20[lastIndex];
  const currentEMA50 = ema50[lastIndex];
  const currentEMA200 = ema200[lastIndex];
  const previousEMA20 = ema20[slopeIndex];
  const previousEMA50 = ema50[slopeIndex];

  if (
    !Number.isFinite(currentEMA20) ||
    !Number.isFinite(currentEMA50) ||
    !Number.isFinite(currentEMA200) ||
    !Number.isFinite(previousEMA20) ||
    !Number.isFinite(previousEMA50)
  ) {
    return "Neutral";
  }

  const priceVsEMA20 = close / currentEMA20 - 1;
  const ema20VsEMA50 = currentEMA20 / currentEMA50 - 1;
  const ema50VsEMA200 =
    currentEMA50 / currentEMA200 - 1;

  const ema20Slope =
    currentEMA20 / previousEMA20 - 1;

  const ema50Slope =
    currentEMA50 / previousEMA50 - 1;

  /*
   * Trend score composition:
   *
   * 20% current price versus EMA20
   * 20% EMA20 versus EMA50
   * 30% EMA50 versus EMA200
   * 15% EMA20 slope over 10 sessions
   * 15% EMA50 slope over 10 sessions
   */
  const score =
    normalizeToScore(priceVsEMA20, 0.04) * 0.2 +
    normalizeToScore(ema20VsEMA50, 0.03) * 0.2 +
    normalizeToScore(ema50VsEMA200, 0.08) * 0.3 +
    normalizeToScore(ema20Slope, 0.04) * 0.15 +
    normalizeToScore(ema50Slope, 0.025) * 0.15;

  return scoreToRating(score);
}

function getMomentumRating(data) {
  const closes = data
    .map((item) => item.close)
    .filter(Number.isFinite);

  if (closes.length < 35) {
    return "Neutral";
  }

  const lastClose = closes[closes.length - 1];

  const rsiValues = getRSI(closes, 14);
  const lastRSI = rsiValues[rsiValues.length - 1];

  const close10SessionsAgo =
    closes[closes.length - 11];

  const close20SessionsAgo =
    closes[closes.length - 21];

  const roc10 =
    Number.isFinite(close10SessionsAgo) &&
    close10SessionsAgo !== 0
      ? lastClose / close10SessionsAgo - 1
      : 0;

  const roc20 =
    Number.isFinite(close20SessionsAgo) &&
    close20SessionsAgo !== 0
      ? lastClose / close20SessionsAgo - 1
      : 0;

  const macd = getLatestMACD(closes);

  const macdHistogramPercent =
    macd && lastClose !== 0
      ? macd.histogram / lastClose
      : 0;

  /*
   * This is a momentum indicator, not a contrarian indicator.
   *
   * RSI above 50 contributes positively.
   * RSI below 50 contributes negatively.
   *
   * An oversold RSI therefore means weak momentum, not automatically
   * a buying signal.
   */
  const rsiScore = Number.isFinite(lastRSI)
    ? normalizeToScore(lastRSI - 50, 25)
    : 0;

  const roc10Score = normalizeToScore(roc10, 0.08);
  const roc20Score = normalizeToScore(roc20, 0.14);

  const macdScore = normalizeToScore(
    macdHistogramPercent,
    0.012
  );

  /*
   * Momentum score composition:
   *
   * 35% RSI
   * 25% 10-session rate of change
   * 20% 20-session rate of change
   * 20% MACD histogram
   */
  const score =
    rsiScore * 0.35 +
    roc10Score * 0.25 +
    roc20Score * 0.2 +
    macdScore * 0.2;

  return scoreToRating(score);
}

function getVolumeRating(data, period = 20) {
  if (!Array.isArray(data) || data.length < period) {
    return "Neutral";
  }

  const recent = data.slice(-period);

  let moneyFlowVolume = 0;
  let validTotalVolume = 0;

  for (let i = 0; i < recent.length; i++) {
    const candle = recent[i];

    const close = Number(candle.close);
    const open = Number(candle.open);
    const high = Number(candle.high);
    const low = Number(candle.low);
    const volume = Number(candle.volume);

    if (
      !Number.isFinite(close) ||
      !Number.isFinite(volume) ||
      volume <= 0
    ) {
      continue;
    }

    let moneyFlowMultiplier = 0;

    if (
      Number.isFinite(high) &&
      Number.isFinite(low) &&
      high > low
    ) {
      /*
       * Close at the high = +1.
       * Close in the middle = 0.
       * Close at the low = -1.
       */
      moneyFlowMultiplier =
        ((close - low) - (high - close)) /
        (high - low);
    } else if (
      Number.isFinite(open) &&
      open !== 0
    ) {
      /*
       * Fallback for datasets without valid high/low values.
       */
      const candleReturn = close / open - 1;

      moneyFlowMultiplier = clamp(
        candleReturn / 0.02,
        -1,
        1
      );
    } else {
      const globalIndex =
        data.length - period + i;

      const previousClose = Number(
        data[globalIndex - 1]?.close
      );

      if (
        Number.isFinite(previousClose) &&
        previousClose !== 0
      ) {
        const dailyReturn =
          close / previousClose - 1;

        moneyFlowMultiplier = clamp(
          dailyReturn / 0.02,
          -1,
          1
        );
      }
    }

    moneyFlowVolume +=
      moneyFlowMultiplier * volume;

    validTotalVolume += volume;
  }

  if (validTotalVolume === 0) {
    return "Neutral";
  }

  /*
   * Similar to Chaikin Money Flow:
   *
   * Positive = volume is concentrated near session highs.
   * Negative = volume is concentrated near session lows.
   */
  const moneyFlow =
    moneyFlowVolume / validTotalVolume;

  const flowScore = normalizeToScore(
    moneyFlow,
    0.25
  );

  /*
   * Also compare recent up-day and down-day volume.
   * This prevents the score from relying only on candle location.
   */
  let upVolume = 0;
  let downVolume = 0;

  for (let i = 0; i < recent.length; i++) {
    const current = recent[i];

    const currentClose = Number(current.close);
    const currentVolume = Number(current.volume);

    const globalIndex =
      data.length - period + i;

    const previousClose = Number(
      data[globalIndex - 1]?.close
    );

    if (
      !Number.isFinite(currentClose) ||
      !Number.isFinite(previousClose) ||
      !Number.isFinite(currentVolume) ||
      currentVolume <= 0
    ) {
      continue;
    }

    if (currentClose > previousClose) {
      upVolume += currentVolume;
    } else if (currentClose < previousClose) {
      downVolume += currentVolume;
    }
  }

  const directionalVolumeTotal =
    upVolume + downVolume;

  const directionalVolumeBalance =
    directionalVolumeTotal > 0
      ? (upVolume - downVolume) /
        directionalVolumeTotal
      : 0;

  const directionalScore = normalizeToScore(
    directionalVolumeBalance,
    0.35
  );

  /*
   * Volume score composition:
   *
   * 70% accumulation/distribution flow
   * 30% up-day versus down-day volume
   */
  const score =
    flowScore * 0.7 +
    directionalScore * 0.3;

  return scoreToRating(score);
}

const ratingToScore = {
  "Strong Buy": 2,
  "Buy": 1,
  "Neutral": 0,
  "Sell": -1,
  "Strong Sell": -2,
};










  useEffect(() => {
    if (chartType === 'ha') {
      // Initialize an array to store the Heikin-Ashi data
      let haData = [];

      // Set the first Heikin-Ashi candle to be the same as the first regular candle
      haData.push({
        date: AdvChartData[0].date,
        open: AdvChartData[0].open,
        high: AdvChartData[0].high,
        low: AdvChartData[0].low,
        close: (AdvChartData[0].open + AdvChartData[0].high + AdvChartData[0].low + AdvChartData[0].close) / 4,
        volume: AdvChartData[0].volume,
      });

      // Calculate the rest of the Heikin-Ashi candles
      for (let i = 1; i < AdvChartData.length; i++) {
        const prevHA = haData[i - 1];
        const current = AdvChartData[i];

        const haClose = (current.open + current.high + current.low + current.close) / 4;
        const haOpen = (prevHA.open + prevHA.close) / 2;
        const haHigh = Math.max(current.high, haOpen, haClose);
        const haLow = Math.min(current.low, haOpen, haClose);

        haData.push({
          date: current.date,
          open: haOpen,
          high: haHigh,
          low: haLow,
          close: haClose,
          volume: current.volume,
        });
      }

      // Set Heikin-Ashi data to the state
      setAdvChartData(haData);
    } else {
      // If chartType is not 'ha', reset to raw data
      setAdvChartData(rawData);
    }
  }, [chartType]);

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.substring(1);
    let attempts = 0;
    const maxAttempts = 15;

    const scrollToElement = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(scrollToElement, 200); // retry every 200ms
      }
    };
setActiveData(id.charAt(0).toUpperCase() + id.slice(1).toLowerCase());
    scrollToElement();
  }, [location]);

  
  useEffect(() => {
    fetchStockData3(); // Call the function inside useEffect
  }, [advInterval]);
    useEffect(() => {
      //console.log(isChart);
      const fetchStockData = async () => {
        try {
          const proxyUrl = "https://stocksleuth.xyz:5000/call?url=";
            const apiUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${ticker}?metrics=high&interval=${interval}&range=${range}`;
            const encodedApiUrl = encodeURIComponent(apiUrl);
            const response = await axios.get(proxyUrl + encodedApiUrl);
            const data = response.data.chart.result[0];
            const closePrices = data.indicators.quote[0].close;
            const lastIndex = closePrices.length - 1; // Get the last index
            const periodChange =
              ((closePrices[lastIndex] - closePrices[0]) / closePrices[0]) * 100;


















          setPeriodChange(periodChange);
          const sma50 = sma(data.indicators.quote[0].close, 50);
          const sma100 = sma(data.indicators.quote[0].close, 100);
          const sma200 = sma(data.indicators.quote[0].close, 200);

          setChartData({
            series: [
              !showCandlestick && {
                name: "candle",
                type: "candlestick",
                data: data.timestamp.map((timestamp, index) => ({
                  x: new Date(timestamp * 1000),
                  y: [
                    data.indicators.quote[0].open[index],
                    data.indicators.quote[0].high[index],
                    data.indicators.quote[0].low[index],
                    data.indicators.quote[0].close[index],
                  ],
                })),
              },
              showCandlestick && {
                name: "close",
                type: "line",
                data: data.indicators.quote[0].close.map((value, index) => ({
                  x: new Date(data.timestamp[index] * 1000),
                  y: value,
                })),
              },
              sma50Enabled && {
                name: "SMA(50)",
                type: "line",
                data: sma50.map((value, index) => ({
                  x: new Date(data.timestamp[index] * 1000),
                  y: value,
                })),
              },
              sma100Enabled && {
                name: "SMA(100)",
                type: "line",
                data: sma100.map((value, index) => ({
                  x: new Date(data.timestamp[index] * 1000),
                  y: value,
                })),
              },
              sma200Enabled && {
                name: "SMA(200)",
                type: "line",
                data: sma200.map((value, index) => ({
                  x: new Date(data.timestamp[index] * 1000),
                  y: value,
                })),
              },
            ].filter(Boolean),
            options: {
              plotOptions: {
                candlestick: {
                  colors: {
                    upward: "#2cd42c", // Color for upward (bullish) candles
                    downward: "#ff5733", // Color for downward (bearish) candles
                  },
                },
              },
              stroke: {
                width: [1.5], // Adjust the width as needed
                colors: ["#5932ea"], // Specify your desired colors
              },
              legend: {
                show: false,
              },
              tooltip: {
                enabled: false,
                marker: {
                  show: false,
                },
                onDatasetHover: {
                  highlightDataSeries: false,
                },
                followCursor: false,
                intersect: false,
                custom: function ({ seriesIndex, dataPointIndex, w }) {
                  const o = w.globals.seriesCandleO[seriesIndex][dataPointIndex];
                  const h = w.globals.seriesCandleH[seriesIndex][dataPointIndex];
                  const l = w.globals.seriesCandleL[seriesIndex][dataPointIndex];
                  const c = w.globals.seriesCandleC[seriesIndex][dataPointIndex];
                  return "";
                },
              },
              chart: {
                type: showCandlestick ? "candlestick" : "line",

                toolbar: {
                  autoSelected: "none",
                  show: false,
                },
              },
              states: {
                normal: {
                  filter: {
                    type: "none",
                    value: 0,
                  },
                },
                hover: {
                  filter: {
                    type: "none",
                    value: 0,
                  },
                },
              },
              grid: {
                position: "back",
                borderColor: "#FDFBFF",
              },
              xaxis: {
                type: "category",
                tickAmount: 4,
                axisTicks: {
                  show: false,
                },
                labels: {
                  style: {
                    cssClass: "RemoveFirstDate",
                  },
                  formatter: function (val) {
                    // Check if chartData and its options are available
                    if (
                      chartData &&
                      chartData.options &&
                      chartData.options.chart
                    ) {
                      // Customize date-time formats based on the selected range
                      if (range === "1d") {
                        // Format for 1 day
                        return dayjs(val).format("HH:mm");
                      } else if (["5d", "1mo", "3mo", "6mo"].includes(range)) {
                        // Format for 5 days, 1 month, 3 months, 6 months
                        return dayjs(val).format("DD.MM");
                      } else if (
                        ["1y", "2y", "5y", "ytd", "max"].includes(range)
                      ) {
                        // Format for 1 year, 2 years, 5 years, year-to-date, max
                        return dayjs(val).format("MMM YYYY");
                      }
                    }

                    // Default format for other cases
                    return dayjs(val).format("MMM YY");
                  },
                  rotate: 0,
                },
                crosshairs: {
                  show: false,
                },
                tooltip: {
                  enabled: false,
                },
              },
              yaxis: {
                //max: Math.max(...data.indicators.quote[0].close) * 1.05,
                opposite: true,
                tickAmount: 10,
                labels: {
                  formatter: function (val, index) {
                    return val !== null ? val.toFixed(2) : val;
                  },
                },
                forceNiceScale: true,
                tooltip: {
                  enabled: false,
                },
                crosshairs: {
                  show: false,
                },
              },
              markers: {
                size: 0,
              },
            },
          });
        } catch (error) {
          console.error(error);
        }
      };

      fetchStockData();
    }, [
      ticker,
      interval,
      range,
      sma50Enabled,
      sma100Enabled,
      sma200Enabled,
      showCandlestick,
    ]);

    /*const sma = (data, period) => {
      const result = [];
      for (let i = 0; i < data.length; i++) {
        if (i >= period - 1) {
          const sum = data
            .slice(i - period + 1, i + 1)
            .reduce((acc, val) => acc + val, 0);
          result.push(sum / period);
        } else {
          result.push(null);
        }
      }
      return result;
    };*/
    const handleFullscreen = () => {
      setDimensions({
        width: window.innerWidth - 50,
        height: window.innerHeight - 50,
      });

      setIsFullscreen(true);
    };
    const [userColors, setUserColors] = useState({});
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent the default action of the Enter key (e.g., form submission or new line in textarea)
        handleSendMessage(); // Call the function to handle sending the message
      }
    };
    useEffect(() => {
      const assignColors = () => {
        const colors = [
          "#0000FF", // blue
          "#FF0000", // red
          "#8A2BE2", // purple
          "#FF69B4", // pink
          "#1E90FF", // light blue
          "#008000", // dark green
          "#00FF7F", // spring green
          "#B22222", // wine red
          "#DAA520", // brownish orange
          "#FF4500", // orange
          "#2E8B57", // greyish green
          "#5F9EA0", // blueish grey
          "#D2691E", // dark orange
        ];
        setUserColors((currentColors) => {
          const assignedColors = { ...currentColors };
          normalizeChatMessages(messages).forEach((msg) => {
            if (msg.username && !assignedColors[msg.username]) {
              assignedColors[msg.username] = colors[Math.floor(Math.random() * colors.length)];
            }
          });
          return assignedColors;
        });
      };

      assignColors();
    }, [ticker, messages]);

    useEffect(() => {
      const fetchMessages = async () => {
        try {
          const response = await fetch(
            `https://stocksleuth.xyz:5000/api/chat/${ticker}`
          );
          const data = await response.json();
          setMessages(normalizeChatMessages(data));
          if (chatBoxRef.current) chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
        } catch (error) {
          console.error("Error fetching messages:", error);
        }
      };

      fetchMessages();
      const intervalId = setInterval(fetchMessages, 60000);

      return () => clearInterval(intervalId);
    }, [ticker]);

    const handleSendMessage = async () => {
      try {
        if (!newMessage.trim()) return;
        await axios.post("https://stocksleuth.xyz:5000/api/chat", {
          ticker,
          message: newMessage,
          username: user?.displayname,
        });
        setNewMessage("");
        setMessages((prevMessages) => [
          { username: user?.displayname, message: newMessage },
          ...normalizeChatMessages(prevMessages),
        ]);
        setTimeout(() => {
          chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
        }, 0);
      } catch (error) {
        console.error("Failed to send message", error);
      }
    };

    const handleScroll = async (e) => {
      if (e.target.scrollTop === 0 && !fetchingOlderMessages) {
        setFetchingOlderMessages(true);
        try {
          const oldestMessageId = messages[0]?.id;
          const response = await fetch(
            `https://stocksleuth.xyz:5000/api/chat/${ticker}`
          );
          const olderMessages = normalizeChatMessages(await response.json());
          setMessages((prevMessages) => [...olderMessages, ...normalizeChatMessages(prevMessages)]);
        } catch (error) {
          console.error("Error fetching older messages:", error);
        } finally {
          setFetchingOlderMessages(false);
        }
      }
    };

    const handleIntervalChange = (newInterval) => {
      setInter2val(newInterval);
    };

    const handleRangeChange = (newRange) => {
      setRange(newRange);
    };

    const handleChartTypeChange = (checked) => {
      setShowCandlestick(checked);
    };
    const handleMessageChange = (event) => {
      setNewMessage(event.target.value);
    };

    function formatDate(inputValue) {
      if (!inputValue) return "--";

      const inputString = String(inputValue).trim();
      // Legacy fields can contain a date range (start_end_FY). Use the period
      // end, while still accepting the new ISO endDate and old Date strings.
      const isoDates = inputString.match(/\d{4}-\d{2}-\d{2}/g);
      const cleanedString = isoDates?.at(-1) || inputString.replace(/_FY$/, "").trim();
      const date = new Date(cleanedString);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        return "Invalid Date";
      }

      // Format the date as M/D/YYYY
      return date.toLocaleDateString("en-US");
    }

    const handleRangeButtonClick = (selectedRange) => {
      let selectedInterval;

      switch (selectedRange) {
        case "1d":
          selectedInterval = "1m";
          break;
        case "5d":
          selectedInterval = "5m";
          break;
        case "1mo":
          selectedInterval = "1h";
          break;
        case "3mo":
        case "6mo":
          selectedInterval = "1d";
          break;
        case "1y":
          selectedInterval = "1d";
          break;
        case "2y":
        case "5y":
          selectedInterval = "1wk";
          break;
        case "max":
          selectedInterval = "1mo";
          break;
        case "ytd":
          selectedInterval = "1d";
          break;
        default:
          selectedInterval = "1d";
      }

      setRange(selectedRange);
      setInter2val(selectedInterval);
    };
    const StockPurchaseForm = ({ ticker }) => {
      const [shares, setShares] = useState("");
      const [purchasePrice, setPurchasePrice] = useState("");
      const [message, setMessage] = useState("");
      const [orderType, setOrderType] = useState("buy");
      const [selectedDate, setSelectedDate] = useState("");
      const [selectedTime, setSelectedTime] = useState("");

      const handlePurchase = async () => {
        let finalShares = orderType === "sell" ? -shares : shares;
        let finalPurchasePrice = purchasePrice;
        let finalDatetime = new Date().toISOString();

        try {
          if (!purchasePrice) {
            const proxyUrl = "https://stocksleuth.xyz:5000/call?url=";
            const apiUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${ticker}?metrics=high&interval=1d&range=1d`;
            const encodedApiUrl = encodeURIComponent(apiUrl);
            const response = await axios.get(proxyUrl + encodedApiUrl);
            const data = response.data.chart.result[0].indicators.quote[0];
            const currentPrice = parseFloat(data.close.slice(-1)[0]).toFixed(2);

            finalPurchasePrice = currentPrice;
          }

          if (selectedDate || selectedTime) {
            const date = selectedDate || new Date().toLocaleDateString();
            const time = selectedTime || new Date().toLocaleTimeString();
            finalDatetime = new Date(`${date} ${time}`).toISOString();
          }

          const data = {
            ticker,
            shares: finalShares,
            purchasePrice: finalPurchasePrice,
            datetime: finalDatetime,
          };

          await purchaseStock(data);
          setMessage("Stock purchased successfully");
        } catch (error) {
          console.error("Stock purchase failed", error);
          setMessage("Stock purchase failed");
        }
      };

      return (
        <div>
          <p>
            {ticker} | Current Price:{" "}
            {currentPrice ? `$${currentPrice}` : "Loading..."}
          </p>
          <br />
          <label>
            Shares:
            <input
              type="number"
              value={shares}
              onChange={(e) => setShares(e.target.value)}
            />
          </label>
          <br />
          <label>
            Purchase Price:
            <input
              type="number"
              value={purchasePrice}
              onChange={(e) => setPurchasePrice(e.target.value)}
            />
          </label>
          <br />
          <label>
            Date:
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </label>
          <br />
          <label>
            Time:
            <input
              type="time"
              value={selectedTime}
              onChange={(e) => setSelectedTime(e.target.value)}
            />
          </label>
          <br />
          <p style={{ color: "green", margin: "0px" }}>
            <input
              type="radio"
              value="buy"
              checked={orderType === "buy"}
              onChange={(e) => setOrderType(e.target.value)}
            />{" "}
            Buy
          </p>
          <p style={{ color: "red", margin: "0px" }}>
            <input
              type="radio"
              value="sell"
              checked={orderType === "sell"}
              onChange={(e) => setOrderType(e.target.value)}
            />{" "}
            Sell
          </p>
          <br />
          <button onClick={handlePurchase}>Submit Order</button>
          <p>{message}</p>
        </div>
      );
    };

    const handleButtonClick = (statementType) => {
      setActiveStatement(statementType);
      setShowPopup(true);
    };

    const handleClosePopup = () => {
      setShowPopup(false);
    };

    const renderTable = () => {
      switch (activeStatement) {
        case "balanceSheet":
          return renderBalanceSheet();
        // You can add additional cases for other statements (incomeStatement, cashFlow)
        case "incomeStatement":
          return renderIncomeStatement();
        case "cashFlow":
          return renderCFStatement();
        default:
          return null;
      }
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // Keep the existing table UI, but present SEC taxonomy nodes in the order
    // people expect to read a financial statement. Filing-only wrapper labels
    // are traversed without consuming a visible row.
    const financialRowPriority = {
      IncomeStatement: [
        "Revenue from Contract with Customer, Excluding Assessed Tax", "Revenues", "Gross Profit",
        "Cost of Revenue", "Operating Expenses", "Research and Development Expense",
        "Selling, General and Administrative Expense", "Operating Income (Loss)",
        "Nonoperating Income (Expense)", "Income (Loss) from Continuing Operations before Income Taxes, Noncontrolling Interest",
        "Income Tax Expense (Benefit)", "Net Income (Loss) Attributable to Parent",
        "Earnings Per Share, Basic", "Earnings Per Share, Diluted",
      ],
      BalanceSheet: [
        "Assets", "Assets, Current", "Cash and Cash Equivalents, at Carrying Value",
        "Marketable Securities, Current", "Accounts Receivable, Net, Current", "Inventory, Net",
        "Property, Plant and Equipment, Net", "Assets, Noncurrent", "Liabilities",
        "Liabilities, Current", "Accounts Payable, Current", "Long-Term Debt, Current",
        "Long-Term Debt, Noncurrent", "Stockholders' Equity",
        "Equity, Including Portion Attributable to Noncontrolling Interest",
      ],
      CashFlows: [
        "Net Cash Provided by (Used in) Operating Activities",
        "Net Income (Loss) Attributable to Parent",
        "Depreciation, Depletion and Amortization",
        "Share-Based Payment Arrangement, Expense",
        "Net Cash Provided by (Used in) Investing Activities",
        "Payments to Acquire Property, Plant, and Equipment",
        "Payments to Acquire Productive Assets",
        "Net Cash Provided by (Used in) Financing Activities",
        "Payments of Dividends", "Payments for Repurchase of Common Stock",
      ],
    };

    const financialWrapperKeys = new Set([
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect",
      "Income (Loss) from Continuing Operations, Net of Tax, Including Portion Attributable to Noncontrolling Interest",
      "Income (Loss) from Continuing Operations before Equity Method Investments, Income Taxes, Noncontrolling Interest",
      "Net Cash Provided by (Used in) Operating Activities, Continuing Operations",
      "Net Cash Provided by (Used in) Investing Activities, Continuing Operations",
      "Net Cash Provided by (Used in) Financing Activities, Continuing Operations",
      "Payments for (Proceeds from) Productive Assets",
      "Payments to Acquire Productive Assets",
    ]);

    const orderedFinancialKeys = (node, statementKey) => {
      const priority = financialRowPriority[statementKey] || [];
      return Object.keys(node || {})
        .filter((key) => key !== "numVal")
        .sort((a, b) => {
          const aIndex = priority.indexOf(a);
          const bIndex = priority.indexOf(b);
          if (aIndex === -1 && bIndex === -1) return 0;
          if (aIndex === -1) return 1;
          if (bIndex === -1) return -1;
          return aIndex - bIndex;
        });
    };

    const promotedFinancialRows = {
      IncomeStatement: [
        { label: "Revenue", keys: ["Revenue from Contract with Customer, Excluding Assessed Tax", "Revenues", "Sales Revenue, Net"] },
        { label: "Cost of Revenue", keys: ["Cost of Revenue", "Cost of Goods and Services Sold"] },
        { label: "Gross Profit", keys: ["Gross Profit"] },
        { label: "Operating Expenses", keys: ["Operating Expenses"] },
        { label: "Research & Development", keys: ["Research and Development Expense"] },
        { label: "Selling, General & Administrative", keys: ["Selling, General and Administrative Expense"] },
        { label: "Operating Income", keys: ["Operating Income (Loss)"] },
        { label: "Income Before Taxes", keys: ["Income (Loss) from Continuing Operations before Income Taxes, Noncontrolling Interest"] },
        { label: "Income Tax", keys: ["Income Tax Expense (Benefit)"] },
        { label: "Net Income", keys: ["Net Income (Loss) Attributable to Parent", "Net Income (Loss)"] },
        { label: "Basic EPS", keys: ["Earnings Per Share, Basic"] },
        { label: "Diluted EPS", keys: ["Earnings Per Share, Diluted"] },
      ],
      BalanceSheet: [
        { label: "Cash & Equivalents", keys: ["Cash and Cash Equivalents, at Carrying Value"] },
        { label: "Accounts Receivable", keys: ["Accounts Receivable, Net, Current"] },
        { label: "Inventory", keys: ["Inventory, Net"] },
        { label: "Current Assets", keys: ["Assets, Current"] },
        { label: "Total Assets", keys: ["Assets"] },
        { label: "Property & Equipment", keys: ["Property, Plant and Equipment, Net"] },
        { label: "Accounts Payable", keys: ["Accounts Payable, Current"] },
        { label: "Current Liabilities", keys: ["Liabilities, Current"] },
        { label: "Total Liabilities", keys: ["Liabilities"] },
        { label: "Long-Term Debt", keys: ["Long-Term Debt, Excluding Current Maturities", "Long-Term Debt, Noncurrent"] },
        { label: "Shareholders' Equity", keys: ["Stockholders' Equity", "Equity, Including Portion Attributable to Noncontrolling Interest"] },
      ],
      CashFlows: [
        { label: "Operating Cash Flow", keys: ["Net Cash Provided by (Used in) Operating Activities"] },
        { label: "Capital Expenditures", keys: ["Payments to Acquire Property, Plant, and Equipment", "Payments to Acquire Productive Assets"] },
        { label: "Free Cash Flow", derive: "freeCashFlow" },
        { label: "Investing Cash Flow", keys: ["Net Cash Provided by (Used in) Investing Activities"] },
        { label: "Financing Cash Flow", keys: ["Net Cash Provided by (Used in) Financing Activities"] },
        { label: "Dividends Paid", keys: ["Payments of Dividends"] },
        { label: "Share Buybacks", keys: ["Payments for Repurchase of Common Stock", "Payments for Repurchase of Equity"] },
      ],
    };

    const findFinancialRow = (tree, candidates) => {
      for (const candidate of candidates) {
        const pending = [{ node: tree, path: [] }];
        while (pending.length) {
          const { node, path } = pending.shift();
          if (!node || typeof node !== "object") continue;
          for (const [key, value] of Object.entries(node)) {
            if (key === "numVal" || !value || typeof value !== "object") continue;
            const nextPath = [...path, key];
            if (key === candidate && value.numVal !== undefined) {
              return { key, path: nextPath, value };
            }
            pending.push({ node: value, path: nextPath });
          }
        }
      }
      return null;
    };

    const getFinancialValue = (tree, candidates) => {
      const match = findFinancialRow(tree, candidates);
      const value = Number(match?.value?.numVal);
      return Number.isFinite(value) ? value : undefined;
    };

    const calculateFreeCashFlow = (tree) => {
      const operatingCashFlow = getFinancialValue(tree, ["Net Cash Provided by (Used in) Operating Activities"]);
      const capitalExpenditures = getFinancialValue(tree, ["Payments to Acquire Property, Plant, and Equipment", "Payments to Acquire Productive Assets"]);
      return Number.isFinite(operatingCashFlow) && Number.isFinite(capitalExpenditures)
        ? operatingCashFlow - Math.abs(capitalExpenditures)
        : undefined;
    };

    const getPromotedRows = (tree, statementKey) =>
      (promotedFinancialRows[statementKey] || [])
        .map((definition) => {
          if (definition.derive === "freeCashFlow") {
            const value = calculateFreeCashFlow(tree);
            return Number.isFinite(value)
              ? { key: "Free Cash Flow", path: ["Free Cash Flow"], value: { numVal: value }, label: definition.label, valueGetter: calculateFreeCashFlow }
              : null;
          }
          const match = findFinancialRow(tree, definition.keys);
          return match ? { ...match, label: definition.label } : null;
        })
        .filter(Boolean);

    useEffect(() => {
      const statementKeyByTab = {
        balanceSheet: "BalanceSheet",
        incomeStatement: "IncomeStatement",
        cashFlow: "CashFlows",
      };
      const statementKey = statementKeyByTab[activeStatement];
      const tree = AllHistData?.[0]?.[statementKey];
      if (!tree) return;
      setShowDetailedFinancials(getPromotedRows(tree, statementKey).length < 5);
    }, [activeStatement, AllHistData]);

    const [expandedRowsCF, setExpandedRowsCF] = useState([
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect",
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect.Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect",
    ]);
    const keyNameMap = {
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect":
        "Changes in Cash",
      "Net Cash Provided by (Used in) Operating Activities":
        "Operating Cash Flow",
      "Net Cash Provided by (Used in) Financing Activities":
        "Financing Cash Flow",
      "Net Cash Provided by (Used in) Investing Activities":
        "Investing Cash Flow",
      "Payments to Acquire Productive Assets": "Capital Expenditure",

      // Add more mappings as needed
    };
    const [uselessRowsCF, setUselessRowsCF] = useState([
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect",
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect.Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect",
    ]);
    const [vipCF, setVipCF] = useState([
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect.Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect.Net Cash Provided by (Used in) Financing Activities",
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect.Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect.Net Cash Provided by (Used in) Investing Activities",
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect.Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect.Net Cash Provided by (Used in) Operating Activities",
    ]);
    const [hiddenRows, setHiddenRows] = useState([
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect.Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect",
    ]);
    const [hiddenRows2, setHiddenRows2] = useState([
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect.Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect.Net Cash Provided by (Used in) Investing Activities.Net Cash Provided by (Used in) Investing Activities, Continuing Operations.Payments for (Proceeds from) Productive Assets.Payments to Acquire Productive Assets.Payments to Acquire Property, Plant, and Equipment",
    ]);
    const firstCashFlowQ = QData[0]?.CashFlows || {};
    const CashFlow2Q = QData[1]?.CashFlows || {};
    const CashFlow3Q = QData[2]?.CashFlows || {};
    const CashFlow4Q = QData[3]?.CashFlows || {};
    const CashFlow5Q = QData[4]?.CashFlows || {};
    const renderTable4 = (data, level = 0, parentKey = "") => {
      if (!data || !Array.isArray(data) || data.length === 0) return null;

      const firstCashFlow = data[0]?.CashFlows || {};
      const CashFlow2 = data[1]?.CashFlows || {};
      const CashFlow3 = data[2]?.CashFlows || {};
      const CashFlow4 = data[3]?.CashFlows || {};
      const CashFlow5 = data[4]?.CashFlows || {};
      const keys = orderedFinancialKeys(firstCashFlow, "CashFlows");

      // Slice the data to only include the last 5 periods
      const last5Periods = data.slice(0, 5);

      const toggleRow = (key) => {
        setExpandedRowsCF((prev) =>
          prev.includes(key) ? prev.filter((row) => row !== key) : [...prev, key]
        );
      };

      const formatValue = (value) => {
        const num = Number(value);
        //console.log(num);
        // Check if the number is a decimal
        if (num % 1 !== 0 && num < 10000) {
          return num.toFixed(2); // Show two decimals if it's a decimal number
        }

        // For whole numbers, format with commas and no decimals
        return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };

      const calculateTTM = (cashflowData, last5Periods, parentKey, valueGetter = null) => {
        // Sum the values of the last 4 periods, assuming they are in the last 4 positions of the data
        let sum = 0;

        // Loop through the last 4 periods
        QData.slice(0, 4).forEach((period) => {
          let nestedValue = "N/A";
          let current = valueGetter ? { numVal: valueGetter(period.CashFlows) } : period.CashFlows;

          // Split the parentKey to navigate through the nested structure
          const pathArray = parentKey.split(".");

          // Navigate the structure based on the pathArray
          for (let i = 0; !valueGetter && i < pathArray.length; i++) {
            if (current && current[pathArray[i]]) {
              current = current[pathArray[i]];
            } else {
              current = null;
              break;
            }
          }

          // If the final value is found, format it and add it to the sum
          if (current) {
            let finalValue =
              current.numVal !== undefined ? current.numVal : sumNumVals(current);
            finalValue = finalValue / BSmultiplier; // Apply multiplier (if needed)
            nestedValue = formatValue(finalValue); // Format the value
            sum += parseFloat(nestedValue.replace(/,/g, "")); // Remove commas for summing
          }
        });

        return formatValue(sum); // Return formatted TTM value
      };

      const renderRow = (key, cashflowData, level, parentKey, friendlyLabel = null, keySuffix = "", valueGetter = null) => {
        if (!cashflowData) return null;

        const fullKey = parentKey ? `${parentKey}.${key}` : key;
        const isObject =
          typeof cashflowData === "object" && !Array.isArray(cashflowData);
        const hasChildren =
          isObject && Object.keys(cashflowData).some((k) => k !== "numVal");
        const rowExpanded = expandedRowsCF.includes(fullKey);

        if (financialWrapperKeys.has(key)) {
          return orderedFinancialKeys(cashflowData, "CashFlows").map((childKey) =>
            renderRow(childKey, cashflowData[childKey], level, fullKey)
          );
        }

        return (
          <React.Fragment key={`${fullKey}${keySuffix}`}>
            {hiddenRows.includes(fullKey) ? null : (
              <tr style={{ height: 30 }} className="TableRow">
                <td
                  style={{
                    paddingLeft: vipCF.includes(fullKey)
                      ? "15px"
                      : `${level * 22 + 15}px`,
                    paddingRight: 10,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    //maxWidth: "300px",
                    textOverflow: "ellipsis",
                  }}
                >
                  {!uselessRowsCF.includes(fullKey) &&
                    hasChildren &&
                    !hiddenRows2.includes(fullKey) &&
                    level !== 0 && (
                      <button
                        onClick={() => toggleRow(fullKey)}
                        style={{
                          cursor: "pointer",
                          padding: "5px",
                          marginRight: "5px",
                          border: "none",
                          background: "none",
                          outline: "none",
                          color: "inherit",
                        }}
                      >
                        {rowExpanded ? "-" : "+"}
                      </button>
                    )}

                  {friendlyLabel || keyNameMap[key] || key}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {calculateTTM(cashflowData, last5Periods, fullKey, valueGetter)}
                </td>
                {last5Periods.map((quarterBS, index) => {
                  let nestedValue = "N/A";
                  const pathArray = fullKey.split(".");

                  let current = valueGetter ? { numVal: valueGetter(quarterBS.CashFlows) } : quarterBS.CashFlows;
                  for (let i = 0; !valueGetter && i < pathArray.length; i++) {
                    if (current[pathArray[i]]) {
                      current = current[pathArray[i]];
                    } else {
                      current = null;
                      break;
                    }
                  }

                  if (current) {
                    let finalValue =
                      current.numVal !== undefined
                        ? current.numVal
                        : sumNumVals(current);
                    finalValue = finalValue / BSmultiplier;
                    nestedValue = formatValue(finalValue);
                  }

                  return (
                    <td
                      key={index}
                      style={{
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {nestedValue}
                    </td>
                  );
                })}
              </tr>
            )}

            {isObject &&
              rowExpanded &&
              (level !== 0 ||
                (level === 0 &&
                  !hiddenRows2.includes(
                    `${fullKey}.Payments to Acquire Property, Plant, and Equipment`
                  ))) &&
              orderedFinancialKeys(cashflowData, "CashFlows").map((childKey) =>
                  renderRow(
                      childKey,
                      cashflowData[childKey],
                      vipCF.includes(fullKey) ? 1 : level + 1, // Set level to 0 if fullKey is in vipCF
                      fullKey
                    )
              )}
          </React.Fragment>
        );
      };

      return (
        <table
          style={{
            fontSize: "10px",
            textAlign: "left",
            width: "100%",
            borderRadius: 10,
            borderCollapse: "separate",
            borderSpacing: 0,
            tableLayout: "fixed", // This ensures column width stays fixed
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  paddingLeft: 15,
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  height: 30,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "46%",
                  maxWidth: "46%",
                  // To prevent content overflow affecting other columns
                }}
              >
                {/* Column Title */}
              </th>
              <th
                style={{
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  textAlign: "center",
                  fontFamily: "Lexend",
                  padding: "0px",
                  width: "9%",
                }}
              >
                TTM
              </th>
              {last5Periods.map((quarterBS, index) => (
                <th
                  key={index}
                  style={{
                    borderStyle: "solid",
                    borderColor: "rgb(145, 145, 145)",
                    borderImage: "initial",
                    textAlign: "center",
                    fontFamily: "Lexend",
                    padding: "0px",
                    width: "9%", // Equally divide the width
                  }}
                >
                  {formatDate(
                    quarterBS.endDate ||
                      quarterBS.reportDate ||
                      quarterBS.quarterCF ||
                      quarterBS.quarterBS
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!showDetailedFinancials
              ? getPromotedRows(firstCashFlow, "CashFlows").map((row) =>
                  renderRow(row.key, { numVal: row.value.numVal }, 0, row.path.slice(0, -1).join("."), row.label, "-promoted", row.valueGetter)
                )
              : keys.map((key) => renderRow(key, firstCashFlow[key], level, ""))}

            {showDetailedFinancials && <>
            {firstCashFlow?.[
              "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
            ]?.[
              "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
            ]?.["Net Cash Provided by (Used in) Investing Activities"]?.[
              "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
            ]?.["Payments for (Proceeds from) Productive Assets"]?.[
              "Payments to Acquire Productive Assets"
            ] &&
              renderRow(
                "Payments to Acquire Productive Assets",
                firstCashFlow[
                  "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                ][
                  "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                ]["Net Cash Provided by (Used in) Investing Activities"][
                  "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                ]["Payments for (Proceeds from) Productive Assets"][
                  "Payments to Acquire Productive Assets"
                ],
                0,
                "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect.Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect.Net Cash Provided by (Used in) Investing Activities.Net Cash Provided by (Used in) Investing Activities, Continuing Operations.Payments for (Proceeds from) Productive Assets"
              )}
            {firstCashFlow?.[
              "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
            ]?.[
              "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
            ]?.["Net Cash Provided by (Used in) Investing Activities"]?.[
              "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
            ]?.["Payments for (Proceeds from) Productive Assets"]?.[
              "Payments to Acquire Productive Assets"
            ] && (
              <tr style={{ height: 30 }} className="TableRow">
                <td
                  style={{
                    paddingLeft: "15px",
                    paddingRight: 10,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    //maxWidth: "300px",
                    textOverflow: "ellipsis",
                  }}
                >
                  Free Cash Flow
                </td>
                <td
                  style={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {formatValue(
                    (
                      parseFloat(
                        firstCashFlowQ[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Operating Activities"]
                          .numVal
                      ) /
                        BSmultiplier +
                      sumNumVals(
                        firstCashFlowQ[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Investing Activities"][
                          "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                        ]["Payments for (Proceeds from) Productive Assets"][
                          "Payments to Acquire Productive Assets"
                        ]
                      ) /
                        BSmultiplier +
                      parseFloat(
                        CashFlow2Q[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Operating Activities"]
                          .numVal
                      ) /
                        BSmultiplier +
                      sumNumVals(
                        CashFlow2Q[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Investing Activities"][
                          "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                        ]["Payments for (Proceeds from) Productive Assets"][
                          "Payments to Acquire Productive Assets"
                        ]
                      ) /
                        BSmultiplier +
                      parseFloat(
                        CashFlow3Q[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Operating Activities"]
                          .numVal
                      ) /
                        BSmultiplier +
                      sumNumVals(
                        CashFlow3Q[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Investing Activities"][
                          "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                        ]["Payments for (Proceeds from) Productive Assets"][
                          "Payments to Acquire Productive Assets"
                        ]
                      ) /
                        BSmultiplier +
                      parseFloat(
                        CashFlow4Q[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Operating Activities"]
                          .numVal
                      ) /
                        BSmultiplier +
                      sumNumVals(
                        CashFlow4Q[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Investing Activities"][
                          "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                        ]["Payments for (Proceeds from) Productive Assets"][
                          "Payments to Acquire Productive Assets"
                        ]
                      ) /
                        BSmultiplier
                    ).toFixed(0)
                  )}
                </td>

                <td
                  style={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {formatValue(
                    (
                      parseFloat(
                        firstCashFlow[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Operating Activities"]
                          .numVal
                      ) /
                        BSmultiplier +
                      sumNumVals(
                        firstCashFlow[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Investing Activities"][
                          "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                        ]["Payments for (Proceeds from) Productive Assets"][
                          "Payments to Acquire Productive Assets"
                        ]
                      ) /
                        BSmultiplier
                    ).toFixed(0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {formatValue(
                    (
                      parseFloat(
                        CashFlow2[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Operating Activities"]
                          .numVal
                      ) /
                        BSmultiplier +
                      sumNumVals(
                        CashFlow2[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Investing Activities"][
                          "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                        ]["Payments for (Proceeds from) Productive Assets"][
                          "Payments to Acquire Productive Assets"
                        ]
                      ) /
                        BSmultiplier
                    ).toFixed(0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {formatValue(
                    (
                      parseFloat(
                        CashFlow3[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Operating Activities"]
                          .numVal
                      ) /
                        BSmultiplier +
                      sumNumVals(
                        CashFlow3[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Investing Activities"][
                          "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                        ]["Payments for (Proceeds from) Productive Assets"][
                          "Payments to Acquire Productive Assets"
                        ]
                      ) /
                        BSmultiplier
                    ).toFixed(0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {formatValue(
                    (
                      parseFloat(
                        CashFlow4[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Operating Activities"]
                          .numVal
                      ) /
                        BSmultiplier +
                      sumNumVals(
                        CashFlow4[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Investing Activities"][
                          "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                        ]["Payments for (Proceeds from) Productive Assets"][
                          "Payments to Acquire Productive Assets"
                        ]
                      ) /
                        BSmultiplier
                    ).toFixed(0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {formatValue(
                    (
                      parseFloat(
                        CashFlow5[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Operating Activities"]
                          .numVal
                      ) /
                        BSmultiplier +
                      sumNumVals(
                        CashFlow5[
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect"
                        ][
                          "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect"
                        ]["Net Cash Provided by (Used in) Investing Activities"][
                          "Net Cash Provided by (Used in) Investing Activities, Continuing Operations"
                        ]["Payments for (Proceeds from) Productive Assets"][
                          "Payments to Acquire Productive Assets"
                        ]
                      ) /
                        BSmultiplier
                    ).toFixed(0)
                  )}
                </td>
              </tr>
            )}
            </>}
          </tbody>
        </table>
      );
    };

    // Render Cash Flow Table
    const renderCFStatement = () => (
      <>
        {AllHistData && isBSmultiplierLoaded ? (
          renderTable4(AllHistData)
        ) : (
          <tr>
            <td colSpan="2">Loading...</td>
          </tr>
        )}
      </>
    );

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // Helper function to toggle row expansion
    const toggleRowIS = (key) => {
      setExpandedRowsIS((prev) =>
        prev.includes(key) ? prev.filter((row) => row !== key) : [...prev, key]
      );
    };

    // Function to format numbers with commas and decimals
    const formatValue = (value) => {
      const num = Number(value);
      //console.log(num);
      // Check if the number is a decimal
      if (num % 1 !== 0 && num < 1000) {
        return num.toFixed(2); // Show two decimals if it's a decimal number
      }

      // For whole numbers, format with commas and no decimals
      return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // Recursive function to render deeper levels if expanded
    const renderTable3 = (data, level = 0) => {
      if (!data || typeof data !== "object") return null;

      return Object.keys(data).map((key) => {
        const value = data[key];
        const isObject =
          value && typeof value === "object" && !Array.isArray(value);
        const numVal = value?.numVal; // Extract numVal if it exists
        const childSum = sumNumVals(value); // Sum of numVal for children

        const hasChildren =
          Object.keys(value).length > 1 ||
          (Object.keys(value).length === 1 && !value.hasOwnProperty("numVal"));

        if (key === "numVal") return null;

        return (
          <React.Fragment key={key}>
            <tr style={{ height: 30 }} className="TableRow">
              <td style={{ paddingLeft: `${level * 22 + 15}px` }}>
                {key !== "numVal" ? key : null}
                {key !== "numVal" && hasChildren && (
                  <button
                    onClick={() => toggleRowIS(key)}
                    style={{
                      cursor: "pointer",
                      padding: "5px",
                      marginLeft: "20px",
                      border: "none",
                      background: "none",
                      outline: "none",
                      color: "inherit",
                    }}
                  >
                    {expandedRowsIS.includes(key) ? "-" : "+"}
                  </button>
                )}
              </td>
              <td
                style={{ textAlign: "center", borderRightWidth: 1, width: "20%" }}
              >
                {value.numVal !== undefined
                  ? (() => {
                      ////console.log('numVal:', value.numVal); // Log the value of numVal
                      return key !== "Earnings Per Share, Basic" &&
                        key !== "Earnings Per Share, Diluted"
                        ? formatValue(value.numVal / ISmultiplier)
                        : formatValue(value.numVal);
                    })()
                  : formatValue(childSum / ISmultiplier)}
              </td>
            </tr>
            {isObject &&
              expandedRowsIS.includes(key) &&
              renderTable3(value, level + 1)}
          </React.Fragment>
        );
      });
    };

    // Main component rendering the table
    const renderIncomeStatement = () => (
      <>
        {AllHistData && isBSmultiplierLoaded ? (
          renderTableIS(AllHistData)
        ) : (
          <tr>
            <td colSpan="2">Loading...</td>
          </tr>
        )}
      </>
    );

    const sumNumVals = (value) => {
      if (!value || typeof value !== "object") {
        return null;
      }

      let sum = 0;

      Object.keys(value).forEach((key) => {
        const childValue = value[key];
        if (childValue?.numVal) {
          // Convert numVal to a number before adding
          sum += Number(childValue.numVal) || 0; // If it's not a valid number, treat it as 0
        } else {
          sum += sumNumVals(childValue); // Recursively sum for child objects
        }
      });

      return sum;
    };

    ///////////////////////
    const renderTableDCF = () => {
      return (
        <table
          style={{
            fontSize: "10px",
            textAlign: "left",
            width: "100%",
            borderRadius: 10,
            borderCollapse: "separate",
            borderSpacing: 0,
            tableLayout: "fixed", // This ensures column width stays fixed
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  paddingLeft: 15,
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  height: 30,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "46%",
                  maxWidth: "46%",
                  // To prevent content overflow affecting other columns
                }}
              >
                {/* Column Title */}
              </th>
              <th
                style={{
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  textAlign: "center",
                  fontFamily: "Lexend",
                  padding: "0px",
                  width: "9%",
                }}
              >
                {formatDate(lastFYdate).replace(
                  /(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
                  (match, month, day, year) => {
                    //const newYear = parseInt(year) + 1; // Add 1 to the year
                    return `${month}/${year}`; // Return formatted as MM/YYYY
                  }
                )}
              </th>
              <th
                style={{
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  textAlign: "center",
                  fontFamily: "Lexend",
                  padding: "0px",
                  width: "9%",
                }}
              >
                {formatDate(lastFYdate).replace(
                  /(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
                  (match, month, day, year) => {
                    const newYear = parseInt(year) + 1; // Add 1 to the year
                    return `${month}/${newYear}`; // Return formatted as MM/YYYY
                  }
                )}
              </th>
              <th
                style={{
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  textAlign: "center",
                  fontFamily: "Lexend",
                  padding: "1px",
                  width: "9%",
                }}
              >
                {formatDate(lastFYdate).replace(
                  /(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
                  (match, month, day, year) => {
                    const newYear = parseInt(year) + 2; // Add 1 to the year
                    return `${month}/${newYear}`; // Return formatted as MM/YYYY
                  }
                )}
              </th>
              <th
                style={{
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  textAlign: "center",
                  fontFamily: "Lexend",
                  padding: "1px",
                  width: "9%",
                }}
              >
                {formatDate(lastFYdate).replace(
                  /(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
                  (match, month, day, year) => {
                    const newYear = parseInt(year) + 3; // Add 1 to the year
                    return `${month}/${newYear}`; // Return formatted as MM/YYYY
                  }
                )}
              </th>
              <th
                style={{
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  textAlign: "center",
                  fontFamily: "Lexend",
                  padding: "1px",
                  width: "9%",
                }}
              >
                {formatDate(lastFYdate).replace(
                  /(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
                  (match, month, day, year) => {
                    const newYear = parseInt(year) + 4; // Add 1 to the year
                    return `${month}/${newYear}`; // Return formatted as MM/YYYY
                  }
                )}
              </th>
              <th
                style={{
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  textAlign: "center",
                  fontFamily: "Lexend",
                  padding: "1px",
                  width: "9%",
                }}
              >
                {formatDate(lastFYdate).replace(
                  /(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
                  (match, month, day, year) => {
                    const newYear = parseInt(year) + 5; // Add 1 to the year
                    return `${month}/${newYear}`; // Return formatted as MM/YYYY
                  }
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ height: 30 }} className="TableRow">
              <td
                style={{
                  paddingLeft: "15px",
                  paddingRight: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Revenue
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(ratios?.basicMetrics.RevenuesFY / ISmultiplier)
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 1) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 2) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 3) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 4) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 5) /
                        ISmultiplier
                    )
                  : null}
              </td>
            </tr>
            <tr style={{ height: 30 }} className="TableRow">
              <td
                style={{
                  paddingLeft: "15px",
                  paddingRight: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Cost of Goods and Services Sold
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(ratios?.basicMetrics.cogsFY / ISmultiplier)
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                        ratios?.basicMetrics.cogsPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                        ratios?.basicMetrics.cogsPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                        ratios?.basicMetrics.cogsPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                        ratios?.basicMetrics.cogsPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                        ratios?.basicMetrics.cogsPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>
            </tr>
            <tr style={{ height: 30 }} className="TableRow">
              <td
                style={{
                  paddingLeft: "15px",
                  paddingRight: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Selling, General & Administrative
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(ratios?.basicMetrics.sgandaFY / ISmultiplier)
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                        ratios?.basicMetrics.sgandaPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                        ratios?.basicMetrics.sgandaPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                        ratios?.basicMetrics.sgandaPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                        ratios?.basicMetrics.sgandaPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                        ratios?.basicMetrics.sgandaPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>
            </tr>
            <tr style={{ height: 30 }} className="TableRow">
              <td
                style={{
                  paddingLeft: "15px",
                  paddingRight: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Research & Development
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(ratios?.basicMetrics.opexFY / ISmultiplier)
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                        ratios?.basicMetrics.randdPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                        ratios?.basicMetrics.randdPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                        ratios?.basicMetrics.randdPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                        ratios?.basicMetrics.randdPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                        ratios?.basicMetrics.randdPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>
            </tr>
            <tr style={{ height: 30 }} className="TableRow">
              <td
                style={{
                  paddingLeft: "15px",
                  paddingRight: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Net interest & other expenses
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      ratios?.basicMetrics.interestExpenses / ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                        ratios?.basicMetrics.otherPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                        ratios?.basicMetrics.otherPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                        ratios?.basicMetrics.otherPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                        ratios?.basicMetrics.otherPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                        ratios?.basicMetrics.otherPercentage) /
                        ISmultiplier
                    )
                  : null}
              </td>
            </tr>
            <tr style={{ height: 30 }} className="TableRow">
              <td
                style={{
                  paddingLeft: "15px",
                  paddingRight: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Taxes
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(ratios?.basicMetrics.lastTaxes / ISmultiplier)
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      ((ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 1 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                          ratios?.basicMetrics.otherPercentage) *
                        ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      ((ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 2 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                          ratios?.basicMetrics.otherPercentage) *
                        ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      ((ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 3 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                          ratios?.basicMetrics.otherPercentage) *
                        ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      ((ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 4 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                          ratios?.basicMetrics.otherPercentage) *
                        ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      ((ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 5 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                          ratios?.basicMetrics.otherPercentage) *
                        ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>
            </tr>
            <tr style={{ height: 30 }} className="TableRow">
              <td
                style={{
                  paddingLeft: "15px",
                  paddingRight: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Net Income
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY -
                        ratios?.basicMetrics.sgandaFY -
                        ratios?.basicMetrics.opexFY -
                        ratios?.basicMetrics.cogsFY -
                        ratios?.basicMetrics.lastTaxes +
                        ratios?.basicMetrics.interestExpenses) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 1 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                          ratios?.basicMetrics.otherPercentage -
                        (ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 1 -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                            ratios?.basicMetrics.cogsPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                            ratios?.basicMetrics.sgandaPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                            ratios?.basicMetrics.randdPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 1 *
                            ratios?.basicMetrics.otherPercentage) *
                          ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>

              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 2 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                          ratios?.basicMetrics.otherPercentage -
                        (ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 2 -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                            ratios?.basicMetrics.cogsPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                            ratios?.basicMetrics.sgandaPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                            ratios?.basicMetrics.randdPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 2 *
                            ratios?.basicMetrics.otherPercentage) *
                          ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 3 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                          ratios?.basicMetrics.otherPercentage -
                        (ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 3 -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                            ratios?.basicMetrics.cogsPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                            ratios?.basicMetrics.sgandaPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                            ratios?.basicMetrics.randdPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 3 *
                            ratios?.basicMetrics.otherPercentage) *
                          ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 4 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                          ratios?.basicMetrics.otherPercentage -
                        (ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 4 -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                            ratios?.basicMetrics.cogsPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                            ratios?.basicMetrics.sgandaPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                            ratios?.basicMetrics.randdPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 4 *
                            ratios?.basicMetrics.otherPercentage) *
                          ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>
              <td
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ratios
                  ? formatValue(
                      (ratios?.basicMetrics.RevenuesFY *
                        (1 + ratios?.basicMetrics.cagr / 100) ** 5 -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                          ratios?.basicMetrics.cogsPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                          ratios?.basicMetrics.sgandaPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                          ratios?.basicMetrics.randdPercentage -
                        ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                          ratios?.basicMetrics.otherPercentage -
                        (ratios?.basicMetrics.RevenuesFY *
                          (1 + ratios?.basicMetrics.cagr / 100) ** 5 -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                            ratios?.basicMetrics.cogsPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                            ratios?.basicMetrics.sgandaPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                            ratios?.basicMetrics.randdPercentage -
                          ratios?.basicMetrics.RevenuesFY *
                            (1 + ratios?.basicMetrics.cagr / 100) ** 5 *
                            ratios?.basicMetrics.otherPercentage) *
                          ratios?.basicMetrics.taxRate) /
                        ISmultiplier
                    )
                  : null}
              </td>
            </tr>
          </tbody>
        </table>
      );
    };

    const [expandedRowsIS, setExpandedRowsIS] = useState([
      "Costs and Expenses",
      "Assets",
      "Liabilities and Equity.Equity, Including Portion Attributable to Noncontrolling Interest",
      "Liabilities and Equity.Liabilities",
    ]);
    const keyNameMapIS = {
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect":
        "Changes in Cash",
      "Equity, Including Portion Attributable to Noncontrolling Interest":
        "Total Equity (Incl. Noncontrolling Interest)",
    };
    const [uselessRowsIS, setUselessRowsIS] = useState([
      "Liabilities and Equity",
    ]);
    const [vipIS, setVipIS] = useState([
      "Liabilities and Equity.Liabilities",
      "Liabilities and Equity.Commitments and Contingencies",
      "Liabilities and Equity.Equity, Including Portion Attributable to Noncontrolling Interest",
    ]);
    const [hiddenRowsIS, setHiddenRowsIS] = useState([]);
    const [hiddenRowsIS2, setHiddenRowsIS2] = useState([]);
    const firstIncomeStatementQ = QData[0]?.IncomeStatement || {};
    const IncomeStatement2Q = QData[1]?.IncomeStatement || {};
    const IncomeStatement3Q = QData[2]?.IncomeStatement || {};
    const IncomeStatement4Q = QData[3]?.IncomeStatement || {};
    const IncomeStatement5Q = QData[4]?.IncomeStatement || {};
    const renderTableIS = (data, level = 0, parentKey = "") => {
      if (!data || !Array.isArray(data) || data.length === 0) return null;

      const firstIncomeStatement = data[0]?.IncomeStatement || {};
      const IncomeStatement2 = data[1]?.IncomeStatement || {};
      const IncomeStatement3 = data[2]?.IncomeStatement || {};
      const IncomeStatement4 = data[3]?.IncomeStatement || {};
      const IncomeStatement5 = data[4]?.IncomeStatement || {};
      const keys = orderedFinancialKeys(firstIncomeStatement, "IncomeStatement");

      let CommitmentsMissing = false;

      // Slice the data to only include the last 5 periods
      const last5Periods = data.slice(0, 5);
      //console.log(last5Periods);
      const toggleRow = (key) => {
        setExpandedRowsIS((prev) =>
          prev.includes(key) ? prev.filter((row) => row !== key) : [...prev, key]
        );
        ////console.log(expandedRowsBS);
      };

      const formatValue = (value) => {
        const num = Number(value);
        //console.log(num);

        // Check if the number is a decimal
        if (num % 1 !== 0 || Math.abs(num) < 1000) {
          return num.toFixed(2); // Show two decimals if it's a decimal number
        }

        // For whole numbers, format with commas and no decimals
        return (num / BSmultiplier)
          .toFixed(0)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };

      const calculateTTM = (IncomeStatementData, last5Periods, parentKey) => {
        // Sum the values of the last 4 periods, assuming they are in the last 4 positions of the data
        let sum = 0;

        // Loop through the last 4 periods
        QData.slice(0, 4).forEach((period) => {
          let nestedValue = "N/A";
          let current = period.IncomeStatement;

          // Split the parentKey to navigate through the nested structure
          const pathArray = parentKey.split(".");
          ////console.log(pathArray);
          // Navigate the structure based on the pathArray
          for (let i = 0; i < pathArray.length; i++) {
            if (current && current[pathArray[i]]) {
              current = current[pathArray[i]];
              ////console.log(current);
            } else {
              current = null;
              break;
            }
          }

          // If the final value is found, format it and add it to the sum
          if (current) {
            ////console.log(current);
            let finalValue =
              current.numVal !== undefined ? current.numVal : sumNumVals(current);
            finalValue = finalValue; // Apply multiplier (if needed)
            //nestedValue = formatValue(finalValue);  // Format the value
            sum += parseFloat(Number(finalValue)); // Remove commas for summing
          }
        });
        if (Number.isNaN(sum)) {
          sum = "--";
          return sum;
        } else {
          return formatValue(sum);
        }

        // Return formatted TTM value
      };

      const renderRow = (key, IncomeStatementData, level, parentKey, friendlyLabel = null, keySuffix = "") => {
        if (!IncomeStatementData) return null;

        const fullKey = parentKey ? `${parentKey}.${key}` : key;
        const isObject =
          typeof IncomeStatementData === "object" &&
          !Array.isArray(IncomeStatementData);
        const hasChildren =
          isObject &&
          Object.keys(IncomeStatementData).some((k) => k !== "numVal");
        const rowExpanded = expandedRowsIS.includes(fullKey);

        if (financialWrapperKeys.has(key)) {
          return orderedFinancialKeys(IncomeStatementData, "IncomeStatement").map((childKey) =>
            renderRow(childKey, IncomeStatementData[childKey], level, fullKey)
          );
        }
        ////console.log(key, fullKey);

        return (
          <React.Fragment key={`${fullKey}${keySuffix}`}>
            {hiddenRowsIS.includes(fullKey) ? null : (
              <tr style={{ height: 30 }} className="TableRow">
                <td
                  style={{
                    paddingLeft: vipIS.includes(fullKey)
                      ? "15px"
                      : `${level * 22 + 15}px`,
                    paddingRight: 10,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    //maxWidth: "300px",
                    textOverflow: "ellipsis",
                  }}
                >
                  {!uselessRowsIS.includes(fullKey) &&
                    hasChildren &&
                    !hiddenRowsIS2.includes(fullKey) /* && level !== 0*/ && (
                      <button
                        onClick={() => toggleRow(fullKey)}
                        style={{
                          cursor: "pointer",
                          padding: "5px",
                          marginRight: "5px",
                          border: "none",
                          background: "none",
                          outline: "none",
                          color: "inherit",
                        }}
                      >
                        {rowExpanded ? "-" : "+"}
                      </button>
                    )}

                  {friendlyLabel || keyNameMapIS[key] || key}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {calculateTTM(IncomeStatementData, last5Periods, fullKey)}
                </td>
                {last5Periods.map((quarterBS, index) => {
                  let nestedValue = "N/A";

                  const pathArray = fullKey.split(".");

                  let current = quarterBS.IncomeStatement;
                  for (let i = 0; i < pathArray.length; i++) {

                    if (current[pathArray[i]]) {
                      current = current[pathArray[i]];
                      ////console.log(current);
                    } else {
                      current = null;
                      break;
                    }
                  }
                  let finalValue = "";
                  if (current) {
                    ////console.log(current.numVal);
                    if (current.numVal == undefined) {
                      ////console.log(sumNumVals(current), fullKey);
                    }
                    finalValue =
                      current.numVal !== undefined
                        ? current.numVal
                        : sumNumVals(current);
                    finalValue = finalValue;

                    if (Number.isNaN(finalValue)) {
                      nestedValue = "--";
                    } else {
                      nestedValue = formatValue(finalValue);
                    }
                    ////console.log(nestedValue)
                  }
                  ////console.log(key, nestedValue);
                  return (
                    <td
                      key={index}
                      style={{
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {nestedValue}
                    </td>
                  );
                })}
              </tr>
            )}

            {isObject &&
              rowExpanded &&
              (level !== 0 ||
                (level === 0 &&
                  !hiddenRowsIS2.includes(
                    `${fullKey}.Payments to Acquire Property, Plant, and Equipment`
                  ))) &&
              orderedFinancialKeys(IncomeStatementData, "IncomeStatement").map((childKey) =>
                  renderRow(
                      childKey,
                      IncomeStatementData[childKey],
                      vipIS.includes(fullKey) ? 1 : level + 1, // Set level to 0 if fullKey is in vipCF
                      fullKey
                    )
              )}
          </React.Fragment>
        );
      };

      return (
        <table
          style={{
            fontSize: "10px",
            textAlign: "left",
            width: "100%",
            borderRadius: 10,
            borderCollapse: "separate",
            borderSpacing: 0,
            tableLayout: "fixed", // This ensures column width stays fixed
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  paddingLeft: 15,
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  height: 30,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "46%",
                  maxWidth: "46%",
                  // To prevent content overflow affecting other columns
                }}
              >
                {/* Column Title */}
              </th>
              <th
                style={{
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  textAlign: "center",
                  fontFamily: "Lexend",
                  padding: "1px",
                  width: "9%",
                }}
              >
                TTM
              </th>
              {last5Periods.map((quarterBS, index) => (
                <th
                  key={index}
                  style={{
                    borderStyle: "solid",
                    borderColor: "rgb(145, 145, 145)",
                    borderImage: "initial",
                    textAlign: "center",
                    fontFamily: "Lexend",
                    padding: "1px",
                    width: "9%", // Equally divide the width
                  }}
                >
                  {formatDate(
                    quarterBS.endDate ||
                      quarterBS.reportDate ||
                      quarterBS.quarterIS ||
                      quarterBS.quarterBS
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!showDetailedFinancials
              ? getPromotedRows(firstIncomeStatement, "IncomeStatement").map((row) =>
                  renderRow(row.key, { numVal: row.value.numVal }, 0, row.path.slice(0, -1).join("."), row.label, "-promoted")
                )
              : keys.map((key) => renderRow(key, firstIncomeStatement[key], level, ""))}
          </tbody>
        </table>
      );
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const [expandedRows, setExpandedRows] = useState([
      "Assets",
      "Liabilities and Equity",
    ]);
    const renderTable2 = (data, level = 0) => {
      if (!data || typeof data !== "object") {
        return null;
      }

      const toggleRow = (key) => {
        setExpandedRows((prev) =>
          prev.includes(key) ? prev.filter((row) => row !== key) : [...prev, key]
        );
      };

      return Object.keys(data).map((key) => {
        const value = data[key];
        const isObject =
          value && typeof value === "object" && !Array.isArray(value);
        const numVal = value?.numVal; // Extract numVal if it exists
        const childSum = sumNumVals(value); // Calculate the sum of numVal for children
        const hasChildren =
          Object.keys(value).length > 1 ||
          (Object.keys(value).length === 1 && !value.hasOwnProperty("numVal"));

        if (key === "numVal") return null;
        return (
          <React.Fragment key={key}>
            <tr style={{ height: 30 }} className="TableRow">
              <td style={{ paddingLeft: `${level * 22 + 15}px` }}>
                {key !== "numVal" ? key : null}
                {key !== "numVal" &&
                  hasChildren && ( // Only render button if the object has children
                    <button
                      onClick={() => toggleRow(key)}
                      style={{
                        cursor: "pointer",
                        padding: "5px",
                        marginLeft: "20px",
                        border: "none",
                        background: "none",
                        outline: "none",
                        color: "inherit",
                      }}
                    >
                      {expandedRows.includes(key) ? "-" : "+"}
                    </button>
                  )}
              </td>
              <td
                style={{ textAlign: "center", borderRightWidth: 1, width: "20%" }}
              >
                {
                  numVal !== undefined && !isNaN(Number(numVal))
                    ? (Number(numVal) / BSmultiplier)
                        .toFixed(0)
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") // Adding commas without spaces
                    : numVal === "NaN"
                    ? "--"
                    : (childSum / BSmultiplier)
                        .toFixed(0)
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") // Adding commas without spaces
                }
              </td>
            </tr>
            {isObject &&
              expandedRows.includes(key) &&
              renderTable2(value, level + 1)}
          </React.Fragment>
        );
      });
    };
    ///////////////////////////////////////////////////////////////////////////////////////////////

    const renderBalanceSheet = () => (
      <>
        {AllHistData && isBSmultiplierLoaded ? (
          renderTableBS(AllHistData)
        ) : (
          <tr>
            <td colSpan="2">Loading...</td>
          </tr>
        )}
      </>
    );

    const getColorFromValue = (value) => {
      let red, green;

      if (value <= 50) {
        // 🔴 Red (255, 0, 0) → 🟡 Dark Yellow (200, 150, 0)
        red = 255;
        green = Math.round((value / 50) * 150); // Increase green up to 150
      } else {
        // 🟡 Dark Yellow (200, 150, 0) → 🟢 Green (0, 255, 0)
        red = Math.round(200 - ((value - 50) / 50) * 200); // Decrease red
        green = Math.round(150 + ((value - 50) / 50) * 105); // Increase green to 255
      }

      return `rgba(${red}, ${green}, 0, 1)`;
    };

    const [dataValues, setDataValues] = useState([85, 75, 65, 80, 90, 50]);
    const [chartColor, setChartColor] = useState("rgba(255, 99, 132, 1)");
    useEffect(() => {
      if (dataValues.length === 0) return;

      // Calculate the average score
      const averageValue =
        dataValues.reduce((sum, val) => sum + val, 0) / dataValues.length;

      // Set chart color based on average score
      setChartColor(getColorFromValue(averageValue));
    }, [dataValues]);

    // Chart data
    const chartDataRS = {
      labels: [
        "Liquidity",
        "Growth",
        "Value",
        "Health",
        "Profitability",
        "Dividends",
      ],
      datasets: [
        {
          label: "Stock A",
          data: dataValues,
          backgroundColor: chartColor.replace("1)", "0.2)"), // Adjust opacity
          borderColor: chartColor,
          borderWidth: 2,
          pointBackgroundColor: "transparent", // Hide points
          pointBorderColor: "transparent",
          pointHoverBackgroundColor: "transparent",
          pointHoverBorderColor: "transparent",
          tension: 0.4,
        },
      ],
    };

    const chartOptionsRS = {
      responsive: true, // Disable responsiveness
      maintainAspectRatio: false, // Disable aspect ratio
      plugins: {
        legend: {
          display: false, // Hide the legend
        },
        tooltip: {
          enabled: false, // Hide tooltips on hover
        },
      },
      scales: {
        r: {
          angleLines: { display: false }, // Hides axis lines for cleaner look
          suggestedMin: 0,
          suggestedMax: 100,
          ticks: {
            display: false,
            stepSize: 100/6,  // Hide ticks/values
          },
        },
      },
    };

    const [expandedRowsBS, setExpandedRowsBS] = useState([
      "Liabilities and Equity",
      "Assets",
      "Liabilities and Equity.Equity, Including Portion Attributable to Noncontrolling Interest",
      "Liabilities and Equity.Liabilities",
    ]);

    const keyNameMapBS = {
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect":
        "Changes in Cash",
      "Equity, Including Portion Attributable to Noncontrolling Interest":
        "Total Equity (Incl. Noncontrolling Interest)",
    };
    const [uselessRowsBS, setUselessRowsBS] = useState([
      "Liabilities and Equity",
    ]);
    const [vipBS, setVipBS] = useState([
      "Liabilities and Equity.Liabilities",
      "Liabilities and Equity.Commitments and Contingencies",
      "Liabilities and Equity.Equity, Including Portion Attributable to Noncontrolling Interest",
    ]);
    const [hiddenRowsBS, setHiddenRowsBS] = useState(["Liabilities and Equity"]);
    const [hiddenRowsBS2, setHiddenRowsBS2] = useState([
      "Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Including Exchange Rate Effect.Cash, Cash Equivalents, Restricted Cash, and Restricted Cash Equivalents, Period Increase (Decrease), Excluding Exchange Rate Effect.Net Cash Provided by (Used in) Investing Activities.Net Cash Provided by (Used in) Investing Activities, Continuing Operations.Payments for (Proceeds from) Productive Assets.Payments to Acquire Productive Assets.Payments to Acquire Property, Plant, and Equipment",
    ]);
    const firstBalanceSheetQ = QData[0]?.BalanceSheet || {};
    const BalanceSheet2Q = QData[1]?.BalanceSheet || {};
    const BalanceSheet3Q = QData[2]?.BalanceSheet || {};
    const BalanceSheet4Q = QData[3]?.BalanceSheet || {};
    const BalanceSheet5Q = QData[4]?.BalanceSheet || {};
    const renderTableBS = (data, level = 0, parentKey = "") => {
      if (!data || !Array.isArray(data) || data.length === 0) return null;

      const firstBalanceSheet = data[0]?.BalanceSheet || {};
      const BalanceSheet2 = data[1]?.BalanceSheet || {};
      const BalanceSheet3 = data[2]?.BalanceSheet || {};
      const BalanceSheet4 = data[3]?.BalanceSheet || {};
      const BalanceSheet5 = data[4]?.BalanceSheet || {};
      const keys = orderedFinancialKeys(firstBalanceSheet, "BalanceSheet");

      let CommitmentsMissing = false;
      if (
        Number.isNaN(
          Number(
            QData[0]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        ) &&
        Number.isNaN(
          Number(
            QData[1]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        ) &&
        Number.isNaN(
          Number(
            QData[2]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        ) &&
        Number.isNaN(
          Number(
            QData[3]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        ) &&
        Number.isNaN(
          Number(
            QData[4]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        ) &&
        Number.isNaN(
          Number(
            FYData[0]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        ) &&
        Number.isNaN(
          Number(
            FYData[1]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        ) &&
        Number.isNaN(
          Number(
            FYData[2]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        ) &&
        Number.isNaN(
          Number(
            FYData[3]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        ) &&
        Number.isNaN(
          Number(
            FYData[4]?.BalanceSheet?.["Liabilities and Equity"]?.[
              "Commitments and Contingencies"
            ]?.numVal
          )
        )
      ) {
        CommitmentsMissing = true;
      }

      // Slice the data to only include the last 5 periods
      const last5Periods = data.slice(0, 5);

      const toggleRow = (key) => {
        setExpandedRowsBS((prev) =>
          prev.includes(key) ? prev.filter((row) => row !== key) : [...prev, key]
        );
        ////console.log(expandedRowsBS);
      };

      const formatValue = (value) => {
        const num = Number(value);

        // Check if the number is a decimal
        if (num % 1 !== 0) {
          return num.toFixed(2); // Show two decimals if it's a decimal number
        }

        // For whole numbers, format with commas and no decimals
        return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };

      const calculateTTM = (BalanceSheetData, last5Periods, parentKey) => {
        // Sum the values of the last 4 periods, assuming they are in the last 4 positions of the data
        let sum = 0;

        // Loop through the last 4 periods
        QData.slice(0, 4).forEach((period) => {
          let nestedValue = "N/A";
          let current = period.BalanceSheet;

          // Split the parentKey to navigate through the nested structure
          const pathArray = parentKey.split(".");

          // Navigate the structure based on the pathArray
          for (let i = 0; i < pathArray.length; i++) {
            if (current && current[pathArray[i]]) {
              current = current[pathArray[i]];
            } else {
              current = null;
              break;
            }
          }

          // If the final value is found, format it and add it to the sum
          if (current) {
            let finalValue =
              current.numVal !== undefined ? current.numVal : sumNumVals(current);
            finalValue = finalValue / BSmultiplier; // Apply multiplier (if needed)
            nestedValue = formatValue(finalValue); // Format the value
            sum += parseFloat(nestedValue.replace(/,/g, "")); // Remove commas for summing
          }
        });
        if (Number.isNaN(sum)) {
          sum = "--";
          return sum;
        } else {
          return formatValue(sum);
        }

        // Return formatted TTM value
      };

      const renderRow = (key, BalanceSheetData, level, parentKey, friendlyLabel = null, keySuffix = "") => {
        if (!BalanceSheetData) return null;

        const fullKey = parentKey ? `${parentKey}.${key}` : key;
        const isObject =
          typeof BalanceSheetData === "object" &&
          !Array.isArray(BalanceSheetData);
        const hasChildren =
          isObject && Object.keys(BalanceSheetData).some((k) => k !== "numVal");
        const rowExpanded = expandedRowsBS.includes(fullKey);

        if (financialWrapperKeys.has(key)) {
          return orderedFinancialKeys(BalanceSheetData, "BalanceSheet").map((childKey) =>
            renderRow(childKey, BalanceSheetData[childKey], level, fullKey)
          );
        }

        return (
          <React.Fragment key={`${fullKey}${keySuffix}`}>
            {hiddenRowsBS.includes(fullKey) ||
            (CommitmentsMissing &&
              key == "Commitments and Contingencies") ? null : (
              <tr style={{ height: 30 }} className="TableRow">
                <td
                  style={{
                    paddingLeft: vipBS.includes(fullKey)
                      ? "15px"
                      : `${level * 22 + 15}px`,
                    paddingRight: 10,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    //maxWidth: "300px",
                    textOverflow: "ellipsis",
                  }}
                >
                  {!uselessRowsBS.includes(fullKey) &&
                    hasChildren &&
                    !hiddenRowsBS2.includes(fullKey) /* && level !== 0*/ && (
                      <button
                        onClick={() => toggleRow(fullKey)}
                        style={{
                          cursor: "pointer",
                          padding: "5px",
                          marginRight: "5px",
                          border: "none",
                          background: "none",
                          outline: "none",
                          color: "inherit",
                        }}
                      >
                        {rowExpanded ? "-" : "+"}
                      </button>
                    )}

                  {friendlyLabel || keyNameMapBS[key] || key}
                </td>

                {last5Periods.map((quarterBS, index) => {

  let nestedValue = "N/A";
  const pathArray = fullKey.split(".");

  // Drill down into the BalanceSheet
  let current = quarterBS.BalanceSheet;
  for (let i = 0; i < pathArray.length; i++) {
    const part = pathArray[i];
    if (current != null && current[part] !== undefined) {
      current = current[part];
    } else {
      current = null;
      break;
    }
  }

  // Compute the final value if we got something
  if (current) {
    let finalValue = current.numVal !== undefined
      ? current.numVal
      : sumNumVals(current);

    finalValue = finalValue / BSmultiplier;

    if (Number.isNaN(finalValue)) {
      nestedValue = "--";
    } else {
      nestedValue = formatValue(finalValue);
    }
  } else {
    console.info('No valid data – nestedValue stays as "N/A"');
  }

  console.groupEnd();

  return (
    <td
      key={index}
      style={{
        textAlign: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {nestedValue}
    </td>
  );
})}

              </tr>
            )}

            {isObject &&
              rowExpanded &&
              (level !== 0 ||
                (level === 0 &&
                  !hiddenRowsBS2.includes(
                    `${fullKey}.Payments to Acquire Property, Plant, and Equipment`
                  ))) &&
              orderedFinancialKeys(BalanceSheetData, "BalanceSheet").map((childKey) =>
                  renderRow(
                      childKey,
                      BalanceSheetData[childKey],
                      vipBS.includes(fullKey) ? 1 : level + 1, // Set level to 0 if fullKey is in vipCF
                      fullKey
                    )
              )}
          </React.Fragment>
        );
      };

      return (
        <table
          style={{
            fontSize: "10px",
            textAlign: "left",
            width: "100%",
            borderRadius: 10,
            borderCollapse: "separate",
            borderSpacing: 0,
            tableLayout: "fixed", // This ensures column width stays fixed
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  paddingLeft: 15,
                  borderStyle: "solid",
                  borderColor: "rgb(145, 145, 145)",
                  borderImage: "initial",
                  height: 30,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "46%",
                  maxWidth: "46%",
                  // To prevent content overflow affecting other columns
                }}
              >
                {/* Column Title */}
              </th>

              {last5Periods.map((quarterBS, index) => (
                <th
                  key={index}
                  style={{
                    borderStyle: "solid",
                    borderColor: "rgb(145, 145, 145)",
                    borderImage: "initial",
                    textAlign: "center",
                    fontFamily: "Lexend",
                    padding: "1px",
                    width: "9%", // Equally divide the width
                  }}
                >
                  {formatDate(
                    quarterBS.endDate ||
                      quarterBS.reportDate ||
                      quarterBS.quarterBS
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!showDetailedFinancials
              ? getPromotedRows(firstBalanceSheet, "BalanceSheet").map((row) =>
                  renderRow(row.key, { numVal: row.value.numVal }, 0, row.path.slice(0, -1).join("."), row.label, "-promoted")
                )
              : keys.map((key) => renderRow(key, firstBalanceSheet[key], level, ""))}
          </tbody>
        </table>
      );
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    
    const handleResize = ({ width, height }) => {
      setDimensions({ width, height });
    };
    const modifySecurityName = (name) => {
  return name
    // share-type labels
    .replace(/\s*-\s*Common Stock$/i, "")
    .replace(/\s*Common Stock$/i, "")
    .replace(/\s*Capital Stock$/i, "")
    .replace(/\s*Ordinary Shares$/i, "")
    .replace(/\s*-\s*Common Shares$/i, "")

    // share classes
    .replace(/\s*-\s*Class [A-C]$/i, "")
    .replace(/\s*Class [A-C]$/i, "")

    // corporate designators
    .replace(/\s*-\s*Inc(?:orporated)?\.?$/i, "")
    .replace(/\s*Inc(?:orporated)?\.?$/i, "")
    .replace(/\s*-\s*Corp(?:oration)?\.?$/i, "")
    .replace(/\s*Corp(?:oration)?\.?$/i, "")
    .replace(/\s*-\s*Co\.?$/i, "")
    .replace(/\s*Co\.?$/i, "")
    .replace(/\s*-\s*Company$/i, "")
    .replace(/\s*Company$/i, "")
    .replace(/\s*-\s*Limited$/i, "")
    .replace(/\s*Limited$/i, "")
    .replace(/\s*-\s*Ltd\.?$/i, "")
    .replace(/\s*Ltd\.?$/i, "")

    // clean up any stray dashes or extra spaces
    .replace(/\s*-\s*$/g, "")
    .trim();
};

    const formatPreviewSecurityName = (name, maxLength = 20) => {
      const cleanedName = modifySecurityName(name || "");
      if (cleanedName.length <= maxLength) return cleanedName;
      const candidate = cleanedName.slice(0, maxLength + 1);
      const lastSpace = candidate.lastIndexOf(" ");
      const cutoff = lastSpace >= Math.floor(maxLength * 0.6) ? lastSpace : maxLength;
      return `${cleanedName.slice(0, cutoff).replace(/[,&\s-]+$/, "")}…`;
    };

    const formatMarketCap = (marketCap) => {
      if (marketCap >= 1e12) {
        return (marketCap / 1e12).toFixed(2) + "T"; // Format as billions
      } else if (marketCap >= 1e9) {
        return (marketCap / 1e9).toFixed(2) + "B"; // Format as billions
      } else if (marketCap >= 1e6) {
        return (marketCap / 1e6).toFixed(2) + "M"; // Format as millions
      }
      return marketCap; // If less than a million, return the number as is
    };
 const formatMarketCap2 = (value) => {
  const abs = Math.abs(value);
  const prefix = value < 0 ? '-$' : '$';

  if (abs >= 1e9) return `${prefix}${(abs / 1e9).toFixed(0)}B`;
  if (abs >= 1e6) return `${prefix}${(abs / 1e6).toFixed(0)}M`;
  if (abs >= 1e3) return `${prefix}${(abs / 1e3).toFixed(0)}K`;
  return `${prefix}${abs}`;
};





    const [selectedIndicator, setSelectedIndicator] = useState(null);

    const closeSettings = () => {
      setSelectedIndicator(null);
      //console.log(indicatorPipeline[indicators.findIndex((i) => i.indicator === "bb")].options());
    };




    const [editData, setEditData] = useState({});
  const openSettings = (id, data) => {
    setEditData(data);
    setSelectedIndicator({ id, data });
    
  }





  const [showMACDChart, setShowMACDChart] = useState(false);

  useEffect(() => {
    const hasMACD = indicators.some((ind) => ind.indicator === "macd");
  
    if (hasMACD) {
      const timer = setTimeout(() => {
        setShowMACDChart(true);
      }, 200);
      return () => clearTimeout(timer); // cleanup on unmount or indicator change
    } else {
      setShowMACDChart(false);
    }
  }, [indicators]);


  const handleResetZoom = () => {
    //console.log("RESET");
  }
  const widthOptions = [
    { value: 1, label: "1px", icon: w1 },
    { value: 2, label: "2px", icon: w2 },
    { value: 3, label: "3px", icon: w3 },
    { value: 4, label: "4px", icon: w4 },
  ];
  
  const dashOptions = [
    { value: "Solid", label: "Solid", icon: full },
    { value: "Dash",  label: "Dash",  icon: dashed },
    { value: "Dot",   label: "Dot",   icon: dotted },
  ];
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// TRENDLINES ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const [openDrawing, setOpenDrawing] = useState("");
  const [trendlineType, setTrendlineType] = useState("XLINE");

  const [query, setQuery] = useState("");
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);

  const filteredIndicators = indicatorsList.filter((item) =>
  `${item.label} ${item.indicator}`.toLowerCase().includes(query.toLowerCase())
);

const maColors = [
  "#1f78b4",
  "#ff7f00",
  "#6a3d9a",
  "#b15928",
  "#fb9a99",
  "#fdbf6f",
  "#cab2d6",
  "#a6cee3",
];
let nextIndicatorId = 1;
const [activeSelected, setActiveSelected] = useState(null);
const handleSelectI = (indicator) => {
  const maTypes = ["sma", "ema", "wma", "tma"];
  const newId = nextIndicatorId++;
  if (maTypes.includes(indicator.indicator)) {
    setIndicators((prev) => {
      const usedColors = prev
      .filter((i) => maTypes.includes(i.indicator) && i.color)
      .map((i) => i.color);

    // 2) Pick the first color from our palette that isn't used yet
    const available = maColors.filter((c) => !usedColors.includes(c));
    const color = available.length ? available[0] : maColors[0];
      const lastMAIndex = [...prev]
        .map((i) => i.indicator)
        .reverse()
        .findIndex((ind) => maTypes.includes(ind));

      const insertIndex =
        lastMAIndex === -1 ? 0 : prev.length - lastMAIndex;

      const newItem = { indicator: indicator.indicator, value: 26, color };

      return [
        ...prev.slice(0, insertIndex),
        newItem,
        ...prev.slice(insertIndex),
      ];
    });
  }

  if (indicator.indicator === "bb") {
    setIndicators(prev => [...prev, { indicator: "bb", value: 20, source: "close", maType: "sma", id: newId}]);
  }
  if (indicator.indicator === "elder") {
    setLastChart("elderRay");
    setIndicators(prev => [...prev, { indicator: "elder", id: newId }]);
  }
  if (indicator.indicator === "rsi") {
    setLastChart("elderRay");
    setIndicators(prev => [...prev, { indicator: "rsi", id: newId, value: 14 }]);
  }
  if (indicator.indicator === "stoch") {
    setLastChart("elderRay");
    setIndicators(prev => [...prev, { indicator: "stoch", id: newId, value: 14, k: 4, d: 3 }]);
  }
  if (indicator.indicator === "fi") {
    setLastChart("elderRay");
    setIndicators(prev => [...prev, { indicator: "fi", id: newId}]);
  }
  if (indicator.indicator === "fiEMA") {
    setLastChart("elderRay");
    setIndicators(prev => [...prev, { indicator: "fiEMA", id: newId, value: 13}]);
  }
  if (indicator.indicator === "atr") {
    setLastChart("elderRay");
    //console.log("yipee");
    setIndicators(prev => [...prev, { indicator: "atr", id: newId, value: 14 }]);
    //console.log(indicators);
  }
  if (indicator.indicator === "volumeProfile") {
    setIndicators(prev => [...prev, { indicator: "volumeProfile", id: newId}]);
  }
  if (indicator.indicator === "sar") {
    setIndicators(prev => [...prev, { indicator: "sar", id: newId, maxAccelerationFactor: 0.2, accelerationFactor: 0.02}]);
  }
  if (indicator.indicator === "macd") {
    setLastChart("elderRay");
    setIndicators(prev => [...prev, { indicator: "macd", id: newId, macdSlow: 26, macdFast: 12, macdSignal: 9}]);
  }

if(indicator.indicator === "volume") {
  setShowVolume(true);
}
  //console.log("Selected:", indicator.indicator, "-", indicator.label);
  setQuery("");
  setActiveSelected(indicator);
  setFocused(false);
};



  const interactiveNodesRef = useRef({
  Trendline: [],
  FibonacciRetracement: [],
  EquidistantChannel: [],
  StandardDeviationChannel: []
});

  const [enableTrendLine, setEnableTrendLine] = useState(false);
    const [trends1, setTrends1] = useState([
      
    ]);
    const selectedIdx = trends1.findIndex(t => t.selected);
    const selectedTrend = trends1[selectedIdx];
    const [appearanceForm, setAppearanceForm] = useState({
      strokeStyle: "#000000",
      strokeWidth: 1,
      strokeDasharray: "Solid",
      edgeStrokeWidth: 1,
      edgeFill: "#FFFFFF",
      edgeStroke: "#000000",
      r: 6,
    });
    useEffect(() => {
      if (selectedIdx === -1) return;
      const updated = [...trends1];
      updated[selectedIdx] = {
        ...updated[selectedIdx],
        appearance: appearanceForm,
      };
      setTrends1(updated);
    }, [appearanceForm]);
    useEffect(() => {
      if (selectedTrend) {
        setAppearanceForm(selectedTrend.appearance);
      }
    }, [selectedIdx]);
  
    // Handle input change
    const updateAppearanceField = (key, value) => {
      setAppearanceForm((prev) => ({
        ...prev,
        [key]: value,
      }));
    };
    const confirmAppearanceChanges = () => {
      if (selectedIdx === -1) return;
  
      const updatedTrends = [...trends1];
      updatedTrends[selectedIdx] = {
        ...updatedTrends[selectedIdx],
        appearance: appearanceForm,
      };
      setTrends1(updatedTrends);
    };




    const [trends3, setTrends3] = useState([]);

    const canvasNodeRef = useRef(null);
    const node1Ref = useRef(null);
    const node3Ref = useRef(null);
    
    

  const handleSelection = (type, interactives, prevState, setState) => {


  if (!Array.isArray(interactives)) {
    console.warn("Expected 'interactives' to be an array.");
    return;
  }

  // 🔎 Find the object with type 'Trendline'
  const trendlineInteractive = interactives.find(
    item => item.type === "Trendline"
  );

  if (trendlineInteractive) {
    const { chartId, objects } = trendlineInteractive;
    //console.log(`🎯 Chart ID: ${chartId}`);
    //console.log("📈 Trendlines:", objects);

    setTrends1(objects); // ✅ THIS is your new trends1 state
  } else {
    //console.log("⚠️ No Trendline object found.");
  }
};


  useEffect(() => {
    //console.log("Trends 1 state updated:", trends1);
  }, [trends1]);
  const onDrawCompleteChart1 = (_e, newTrends) => {
    //console.log("Draw complete:", newTrends);

    // Deselect all trendlines by setting selected to false
    const deselectedTrends = newTrends.map((trend, idx, arr) => ({
  ...trend,
  selected: idx === arr.length - 1, // only the last one is selected
}));

    setEnableTrendLine(false);
    
    // Replace the trends with the deselected versions
    if (Array.isArray(deselectedTrends)) {
      //console.log("Deselected trends:", deselectedTrends);
        setTrends1(deselectedTrends); // Replace trends instead of appending
    }
  };


useEffect(() => {

  if (trends1.length === 1) {

    setTimeout(() => {
      const canvas = document.querySelector(".ChartCanvas4124 canvas");

      if (!canvas) {
        console.error("🚫 Canvas not found! Check your DOM or selector.");
        return;
      }

      const rect = canvas.getBoundingClientRect();
      const clickX = rect.left + 200;
      const clickY = rect.top + 200;


      const event = new MouseEvent("mousedown", {
        clientX: clickX,
        clientY: clickY,
        bubbles: true,
        cancelable: true,
        view: window,
      });

      const dispatchResult = canvas.dispatchEvent(event);

    }, 300);
  }
}, [trends1]);




















  
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// FIBONACCI ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const [isFullscreen, setIsFullscreen] = useState(false);

useEffect(() => {
  const updateDimensions = () => {
    if (isFullscreen) {
      //console.log("fullScreen");
      setDimensions({
        width: window.innerWidth - 50,
        height: window.innerHeight - 50
      });
    } else if (chartContainerRef.current) {
      setDimensions({
        width: Math.max(chartContainerRef.current.clientWidth, 100),
        height: (window.innerHeight - 64 - 185 - 12 - 33)
      });
    } else {
      const content = document.querySelector(".content");
      const sidebar = parseFloat(
        content ? getComputedStyle(content).getPropertyValue("--sidebar-width") : "306"
      ) || 306;
      setDimensions({
        width: Math.max((window.innerWidth - sidebar - 93) * (5 / 6), 100),
        height: (window.innerHeight - 64 - 185 - 12 - 33)
      });
    }
  };

  const chartResizeObserver =
    typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(updateDimensions)
      : null;

  if (chartContainerRef.current) {
    chartResizeObserver?.observe(chartContainerRef.current);
  }

  const timeoutId = setTimeout(() => {
    updateDimensions();
  }, 100);

  window.addEventListener("resize", updateDimensions);

  return () => {
    clearTimeout(timeoutId);
    window.removeEventListener("resize", updateDimensions);
    chartResizeObserver?.disconnect();
  };
}, [isFullscreen]);

const defaultFibAppearance = {
  strokeStyle: "#000000",
  strokeWidth: 1,
  strokeDasharray: "Solid",
  edgeStrokeWidth: 1,
  edgeFill: "#FFFFFF",
  edgeStroke: "#000000",
  r: 5,
  fontFamily: "-apple-system, system-ui, Roboto, 'Helvetica Neue', Ubuntu, sans-serif",
  fontFill: "#000000",
  fontSize: 11,
  nsEdgeFill: "#000000",
};


const [fibType, setFibType] = useState("BOUND");
const [enableFib, setEnableFib] = useState(false);
  const [retracements1, setRetracements1] = useState([]);
  const [retracements3, setRetracements3] = useState([]);


  const [appearanceFibForm, setAppearanceFibForm] = useState(defaultFibAppearance );

  // When a retracement is selected
  const selectedFibIdx = retracements1.findIndex(r => r.selected);
  const selectedFib = retracements1[selectedFibIdx];
  
  useEffect(() => {
    if (selectedFib) {
      setAppearanceFibForm(selectedFib.appearance ?? defaultFibAppearance );
    }
  }, [selectedFibIdx]);
  
  const updateFibAppearanceField = (key, value) => {
    setAppearanceFibForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  
  const confirmFibAppearanceChanges = () => {
    if (selectedFibIdx === -1) return;
  
    const updated = [...retracements1];
    updated[selectedFibIdx] = {
      ...updated[selectedFibIdx],
      appearance: appearanceFibForm,
    };
    setRetracements1(updated);
  };

  


  
  const handleSelectionFib = (type, interactives, prevState, setState) => {


  if (!Array.isArray(interactives)) {
    console.warn("Expected 'interactives' to be an array.");
    return;
  }

  // 🔎 Find the object with type 'Trendline'
  const trendlineInteractive = interactives.find(
    item => item.type === "FibonacciRetracement"
  );

  if (trendlineInteractive) {
    const { chartId, objects } = trendlineInteractive;
    //console.log(`🎯 Chart ID: ${chartId}`);
    //console.log("📈 FibonacciRetracement:", objects);

    setRetracements1(objects); // ✅ THIS is your new trends1 state
  } else {
    //console.log("⚠️ No fib object found.");
  }
};



  const onFibComplete1 = (_e, newRetracements) => {
    //console.log("Draw complete fib:", newRetracements);
    
    const deselectedTrends = newRetracements.map((trend, idx, arr) => ({
  ...trend,
  selected: idx === arr.length - 1, // only the last one is selected
}));
    
    setEnableFib(false);
    
  //console.log("Deselected trends:", deselectedTrends);
  // Replace the trends with the deselected versions
  
    setRetracements1(deselectedTrends);
  };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// EUIDISTANT ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const getPercent = i =>
  bottomChartOrigins[i] ?? bottomChartOrigins[bottomChartOrigins.length - 1];


const indicatorPanelRef = useRef(null);

const [indicatorPanelPosition, setIndicatorPanelPosition] = useState({ x: 500, y: 400 });
const [draggingIndicatorPanel, setDraggingIndicatorPanel] = useState(false);
const [dragOffsetIndicator, setDragOffsetIndicator] = useState({ x: 0, y: 0 });

const startIndicatorDrag = (e) => {
  setDraggingIndicatorPanel(true);
  const rect = indicatorPanelRef.current?.getBoundingClientRect();
  setDragOffsetIndicator({
    x: e.clientX - rect.left,
    y: e.clientY - rect.top,
  });
};

useEffect(() => {
  const handleMouseMove = (e) => {
    if (draggingIndicatorPanel) {
      setIndicatorPanelPosition({
        x: e.clientX - dragOffsetIndicator.x,
        y: e.clientY - dragOffsetIndicator.y,
      });
    }
  };

  const handleMouseUp = () => {
    setDraggingIndicatorPanel(false);
  };

  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [draggingIndicatorPanel, dragOffsetIndicator]);




const defaultEQCAppearance = {
  strokeStyle: "#000000",
  strokeWidth: 1,
  strokeDasharray: "Solid",
  edgeStrokeWidth: 1,
  edgeFill: "#FFFFFF",
  edgeStroke: "#000000",
  r: 5,
  fontFamily: "-apple-system, system-ui, Roboto, 'Helvetica Neue', Ubuntu, sans-serif",
  fontFill: "#000000",
  fontSize: 11,
  nsEdgeFill: "#000000",
};


const [EQCType, setEQCType] = useState("BOUND");
const [enableEQC, setEnableEQC] = useState(false);
  const [EQC1, setEQC1] = useState([]);
  const [EQC3, setEQC3] = useState([]);


  const [appearanceEQCForm, setAppearanceEQCForm] = useState(defaultEQCAppearance );

  // When a retracement is selected
  const selectedEQCIdx = EQC1.findIndex(r => r.selected);
  const selectedEQC = EQC1[selectedEQCIdx];
  
  useEffect(() => {
    if (selectedEQC) {
      setAppearanceEQCForm(selectedEQC.appearance ?? defaultEQCAppearance );
    }
  }, [selectedEQCIdx]);
  
  const updateEQCAppearanceField = (key, value) => {
    setAppearanceEQCForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  
  const confirmEQCAppearanceChanges = () => {
    if (selectedEQCIdx === -1) return;
  
    const updated = [...EQC1];
    updated[selectedEQCIdx] = {
      ...updated[selectedEQCIdx],
      appearance: appearanceEQCForm,
    };
    setEQC1(updated);
  };

  


  const handleSelectionEQC = (type, interactives, prevState, setState) => {


  if (!Array.isArray(interactives)) {
    console.warn("Expected 'interactives' to be an array.");
    return;
  }

  // 🔎 Find the object with type 'Trendline'
  const trendlineInteractive = interactives.find(
    item => item.type === "EquidistantChannel"
  );

  if (trendlineInteractive) {
    const { chartId, objects } = trendlineInteractive;
    //console.log(`🎯 Chart ID: ${chartId}`);
    //console.log("📈 eqc:", objects);

    setEQC1(objects); // ✅ THIS is your new trends1 state
  } else {
    //console.log("⚠️ No eqc object found.");
  }
};
  
  
  
  




  const onEQCComplete1 = (_e, newRetracements) => {
    //console.log("Draw complete fib:", newRetracements);
    
    const deselectedTrends = newRetracements.map((trend, idx, arr) => ({
  ...trend,
  selected: idx === arr.length - 1, // only the last one is selected
}));
    
    setEnableEQC(false);
    
  //console.log("Deselected trends:", deselectedTrends);
  // Replace the trends with the deselected versions
  
    setEQC1(deselectedTrends);
  };





//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// STDDEV ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// 1) Determine which tooltips are active:
// inside your component body:

// 1) Flags for which tooltips are active:
const hasMA     = indicators.some(ind => ["ema","sma","wma","tma"].includes(ind.indicator));
const hasVolume = showVolume;
const hasBB     = indicators.some(ind => ind.indicator === "bb");
const hasSAR    = indicators.some(ind => ind.indicator === "sar");
const hasVP     = indicators.some(ind => ind.indicator === "volumeProfile");

// 2) Heights (pixels) for each row:
const HEIGHTS = {
  ohlc:   16,
  volume: 16,
  ma:     44,
  bb:     16,
  sar:    16,
  vp:     16,
};

// 3) Walk in *fixed order* and assign origins:
let y = 16;
const origins = {};

// OHLCTooltip is always shown
origins.ohlc = y;          y += HEIGHTS.ohlc;
// Volume always *has* a slot next
if (hasVolume) {
  origins.volume = y;      y += HEIGHTS.volume;
}

// Moving Average
if (hasMA) {
  origins.ma = y - 10;          y += HEIGHTS.ma - 10;
}

// Bollinger Band
if (hasBB) {
  origins.bb = y;          y += HEIGHTS.bb;
}

// SAR
if (hasSAR) {
  origins.sar = y;         y += HEIGHTS.sar;
}

// Volume Profile
if (hasVP) {
  origins.vp = y;          y += HEIGHTS.vp;
}











const defaultSTDAppearance = {
  strokeStyle: "#000000",
  strokeWidth: 1,
  strokeDasharray: "Solid",
  edgeStrokeWidth: 1,
  edgeFill: "#FFFFFF",
  edgeStroke: "#000000",
  r: 5,
  fontFamily: "-apple-system, system-ui, Roboto, 'Helvetica Neue', Ubuntu, sans-serif",
  fontFill: "#000000",
  fontSize: 11,
  nsEdgeFill: "#000000",
};


const [STDType, setSTDType] = useState("BOUND");
const [enableSTD, setEnableSTD] = useState(false);
  const [STD1, setSTD1] = useState([]);
  const [STD3, setSTD3] = useState([]);


  const [appearanceSTDForm, setAppearanceSTDForm] = useState(defaultSTDAppearance );

  // When a retracement is selected
  const selectedSTDIdx = STD1.findIndex(r => r.selected);
  const selectedSTD = STD1[selectedSTDIdx];
  
  useEffect(() => {
    if (selectedSTD) {
      setAppearanceSTDForm(selectedSTD.appearance ?? defaultSTDAppearance );
    }
  }, [selectedSTDIdx]);
  
  const updateSTDAppearanceField = (key, value) => {
    setAppearanceSTDForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  
  const confirmSTDAppearanceChanges = () => {
    if (selectedSTDIdx === -1) return;
  
    const updated = [...STD1];
    updated[selectedSTDIdx] = {
      ...updated[selectedSTDIdx],
      appearance: appearanceSTDForm,
    };
    setSTD1(updated);
  };

  


  const handleSelectionSTD = (type, interactives, prevState, setState) => {

  if (!Array.isArray(interactives)) {
    console.warn("Expected 'interactives' to be an array.");
    return;
  }

  // 🔎 Find the object with type 'Trendline'
  const trendlineInteractive = interactives.find(
    item => item.type === "StandardDeviationChannel"
  );

  if (trendlineInteractive) {
    const { chartId, objects } = trendlineInteractive;

    setSTD1(objects); // ✅ THIS is your new trends1 state
  } else {
    //console.log("⚠️ No std object found.");
  }
};
  




  const onSTDComplete1 = (_e, newRetracements) => {
    //console.log("Draw complete fib:", newRetracements);
    
    const deselectedTrends = newRetracements.map((trend, idx, arr) => ({
  ...trend,
  selected: idx === arr.length - 1, // only the last one is selected
}));

    
    setEnableSTD(false);
    
  // Replace the trends with the deselected versions
  
    setSTD1(deselectedTrends);
  };





  

  const handleKeyPress = useCallback((e) => {
    const keyCode = e.which;
    //console.log(keyCode);
    switch (keyCode) {
      case 46: { // DEL
        setRetracements1(prev => prev.filter(each => !each.selected));
        setSTD1(prev => prev.filter(each => !each.selected));
         setEQC1(prev => prev.filter(each => !each.selected));
        setRetracements3(prev => prev.filter(each => !each.selected));

        const newTrends1 = trends1.filter(each => !each.selected);
        const newTrends3 = trends3.filter(each => !each.selected);
        canvasNodeRef.current?.cancelDrag?.();
        setTrends1(newTrends1);
        setTrends3(newTrends3);
        break;
      }
      case 27: { // ESC
        node1Ref.current?.terminate?.();
        node3Ref.current?.terminate?.();
        canvasNodeRef.current?.cancelDrag?.();
        setEnableSTD(false);
        setEnableEQC(false);
        setEnableFib(false);
        setEnableTrendLine(false);
        break;
      }
     /* case 68: // D
      case 69: { // E
        setEnableTrendLine(true);
        break;
      }
        case 68: // D - Draw Fib
        case 69: // E - Enable Fib
          setEnableFib(true);
          break;*/
      default:
        break;
    }
  }, [trends1, trends3, retracements1]);

  useEffect(() => {
    document.addEventListener("keyup", handleKeyPress);
    return () => {
      document.removeEventListener("keyup", handleKeyPress);
    };
  }, [handleKeyPress]);













  const [panelPosition, setPanelPosition] = useState({ x: 500, y: 400 });
const [isDragging, setIsDragging] = useState(false);
const [offset, setOffset] = useState({ x: 0, y: 0 });
const panelRef = useRef(null);

const startDrag = (e) => {
  const rect = panelRef.current.getBoundingClientRect();
  setOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  setIsDragging(true);
};

const stopDrag = () => setIsDragging(false);

const handleDrag = (e) => {
  if (!isDragging) return;

  // You can scale these down slightly to make drag feel "slower"
  const targetX = e.clientX - offset.x;
  const targetY = e.clientY - offset.y;

  setPanelPosition({
    x: targetX,
    y: targetY,
  });
};

// Add listeners
useEffect(() => {
  window.addEventListener("mousemove", handleDrag);
  window.addEventListener("mouseup", stopDrag);
  return () => {
    window.removeEventListener("mousemove", handleDrag);
    window.removeEventListener("mouseup", stopDrag);
  };
}, [isDragging, offset]);









 const [query_2, setQuery_2] = useState("");
  const [focused_2, setFocused_2] = useState(false);
  const [results_2, setResults_2] = useState([]);
  const inputRef_2 = useRef();
  const navigate = useNavigate();

  const fetchTickers_2 = async (q_2) => {
    if (!q_2) {
      setResults_2([]);
      return;
    }
    try {
      const { data } = await axios.get("https://stocksleuth.xyz:5000/auth/search", {
        params: { query: q_2 },
      });

      const formatted_2 = data.results.map((item_2) => ({
        symbol: item_2.symbol,
        name: item_2.security_name,
      }));
      setResults_2(formatted_2);
    } catch (err_2) {
      console.error("Ticker fetch error:", err_2);
    }
  };

  const debouncedFetch_2 = useCallback(debounce(fetchTickers_2, 300), []);

  useEffect(() => {
    debouncedFetch_2(query_2);
    return debouncedFetch_2.cancel;
  }, [query_2]);

  const handleSelect_2 = (symbol_2) => {
    navigate(`/stock/${symbol_2}#chart`);
  };

  const handleKeyDown_2 = (e_2) => {
    if (e_2.key === "Enter" && results_2.length > 0) {
      handleSelect_2(results_2[0].symbol);
    }
  };














  const kagiCalculator = kagi();
  const ha = heikinAshi();
  const renkoCalculator = renko();
  const pAndF = pointAndFigure();
    const ScaleProvider = discontinuousTimeScaleProviderBuilder().inputDateAccessor(
      (d) => new Date(d.date)
    );

    const margin = {
      left: isFullscreen ? 100 : 60,
      right: 90,
      top: 8,
      bottom: 24,
    };

    const smaData = rsi().options({ windowSize: 10, sourcePath: "close" })(
      AdvChartData
    );
    
    const bbFill = "#4682B4";
    
    const bbStroke = {
      top: "#964B00",
      middle: "#000000",
      bottom: "#964B00",
    };

    const indicatorFunctions = {
      stoch: (value, k, d) =>
      stochasticOscillator()
      .options({ windowSize: value, kWindowSize: k, dWindowSize: d })
      .merge((d, c) => {d.stoch = c;})
      .accessor(d => d.stoch),
      rsi: (value) =>
      rsi()
      .options({ windowSize: value })
      .merge((d, c) => {d.rsi = c;})
      .accessor(d => d.rsi),
      atr: (value) =>
      atr()
      .options({ windowSize: value })
      .merge((d, c) => {d.atr = c;})
      .accessor(d => d.atr),
      macd: (macdFast, macdSlow, macdSignal) =>
        macd()
          .options({
            fast: macdFast,
            slow: macdSlow,
            signal: macdSignal,
          })
          .merge((d, c) => {d.macd = c;})
          .accessor(d => d.macd),
    macd2: (macdFast, macdSlow, macdSignal) =>
            macd()
              .options({
                fast: macdFast,
                slow: macdSlow,
                signal: macdSignal,
              })
              .merge((d, c) => {d.macd2 = c;})
              .accessor(d => d.macd2),
    macd3: (macdFast, macdSlow, macdSignal) =>
                macd()
                  .options({
                    fast: macdFast,
                    slow: macdSlow,
                    signal: macdSignal,
                  })
                  .merge((d, c) => {d.macd3 = c;})
                  .accessor(d => d.macd3),
      sar: (accelerationFactor, maxAccelerationFactor) =>
        sar()
          .options({
            accelerationFactor, maxAccelerationFactor
          })
          .merge((d, c) => {d.sar = c;})
          .accessor(d => d.sar),
      bb: (value, source, maType) =>
        bollingerBand()
          .merge((d, c) => { d.bb = c; })
          .accessor(d => d.bb)
          .options({windowSize: value, sourcePath: source, movingAverageType: maType}),

      ema: (value, id, color) => {
            
            let indicator = ema()
              .id(id)
              .options({ windowSize: value })
              .merge((d, c) => { d[`ema${id}`] = c; })
              .accessor(d => d[`ema${id}`]);
          
            
            if (color) {
              indicator = indicator.stroke(color);
            }
          
            return indicator;
          },
          tma: (value, id, color) => {
            let ind = tma()
              .id(id)
              .options({ windowSize: value })
              .merge((d, c) => { d[`tma${id}`] = c; })
              .accessor(d => d[`tma${id}`]);
            if (color) {
              ind = ind.stroke(color);
            }
            return ind;
          },
        
          wma: (value, id, color) => {
            let ind = wma()
              .id(id)
              .options({ windowSize: value })
              .merge((d, c) => { d[`wma${id}`] = c; })
              .accessor(d => d[`wma${id}`]);
            if (color) {
              ind = ind.stroke(color);
            }
            return ind;
          },
        
          sma: (value, id, color) => {
            let ind = sma()
              .id(id)
              .options({ windowSize: value })
              .merge((d, c) => { d[`sma${id}`] = c; })
              .accessor(d => d[`sma${id}`]);
            if (color) {
              ind = ind.stroke(color);
            }
            return ind;
          },
      elder: () =>
            elderRay(),
      fi: () =>
        forceIndex()
      .merge((d, c) => {d.fi = c;})
      .accessor(d => d.fi),
      fiEMA: (value) => 
      ema()
      .id(1)
      .options({ windowSize: value, sourcePath: "fi" })
      .merge((d, c) => {d.fiEMA = c;})
      .accessor(d => d.fiEMA)
    };
    let idCounter = 1;
    const elder = elderRay();
    const fi = forceIndex()
      .merge((d, c) => {d.fi = c;})
      .accessor(d => d.fi);
    const indicatorPipeline = indicators.map((ind) => {
      const { indicator, value, source, maType, accelerationFactor, maxAccelerationFactor, macdFast, macdSlow, macdSignal, color, id, k, d } = ind;
      if (!indicatorFunctions[indicator]) return null;
    
      if (indicator === 'bb') {
        return indicatorFunctions[indicator](value, source, maType); // No value or id needed
      }
      if (indicator === 'sar') {
        return indicatorFunctions[indicator](accelerationFactor, maxAccelerationFactor); // No value or id needed
      }
      
      if (indicator === 'fiEMA') {
        return indicatorFunctions[indicator](value); // No value or id needed
      }
      if (indicator === 'rsi' || indicator === 'atr') {
        return indicatorFunctions[indicator](value); // No value or id needed
      }
      if (indicator === 'macd') {
        return indicatorFunctions[indicator](macdFast, macdSlow, macdSignal); // No value or id needed
      }
      
      if (indicator === 'stoch') {
        return indicatorFunctions[indicator](value, k, d); // No value or id needed
      }
      
      const fn = indicatorFunctions[indicator](value, idCounter, color);
      
      idCounter += 1;
      return fn;
    }).filter(Boolean);
    
    const handleSelect = (type) => {
      setChartType(type);
      setOpen(false);
    };
    // Apply all in sequence
  const handleChartTypeChange2 = (type) => {
      setChartType(type);
    };

    // Apply the appropriate calculation to the data based on the selected chart type
    const calculateData = () => {
      let calculatedData = indicatorPipeline.reduce((data, fn) => fn(data), AdvChartData);

      switch (chartType) {
        case "ha":
          calculatedData = ha(calculatedData);
          //console.log("heikin");
          break;
        case "candlestick":
          // Candlestick, no changes
          break;
        case "kagi":
          calculatedData = kagiCalculator((calculatedData));
          ////console.log(calculatedData);
          break;
        case "renko":
          calculatedData = renkoCalculator((calculatedData));
          break;
        case "pAndF":
          calculatedData = pAndF((calculatedData));
          break;
        default:
          // Default case (could log an error or handle it differently)
          break;
      }
      return fi((calculatedData));
    };

    const calculatedData = calculateData();


    



    //const calculatedData = elder(ema3o(ema2o(ema1o(bb(AdvChartData)))));
    const { data, xScale, xAccessor, displayXAccessor } = ScaleProvider(
      AdvChartData
    );
    const pricesDisplayFormat = format(".2f");
    const max = xAccessor(data[data.length - 1]);
    const min = xAccessor(data[Math.max(0, data.length - 100)]);
    const xExtents = [min, max + 5];

    const gridHeight = height - margin.top - margin.bottom;

    const elderRayHeight = 100;
    const showElder = indicators.some((ind) => ind.indicator === "elder") || indicators.some((ind) => ind.indicator === "macd");
  const actualElderRayHeight = showElder ? elderRayHeight : 0;
  const bottomChartMargin = gridHeight * ((100 - layout.price)/100);
   ////console.log(height, bottomChartMargin, layout.price);
  //const elderRayOrigin = (_, h) => [0, h - actualElderRayHeight];
  const elderRayOrigin = (_, h) => [0, h - (height * ((100 - layout.price)/100))];
  const [bottomChartOrigins, setBottomChartOrigins] = useState([80])
  //(height * ((100 - layout.price)/100))/(active.length)
  const barChartHeight = gridHeight / 4;
  const barChartOrigin = (_, h) => [0, h - barChartHeight - bottomChartMargin];
  const chartHeight = gridHeight - bottomChartMargin;

    const yExtents = (data) => {
      return [data.high, data.low];
    };
    const dateTimeFormat = "%d %b";
    const timeDisplayFormat = timeFormat(dateTimeFormat);

    const barChartExtents = (data) => {
      return data.volume;
    };

    const candleChartExtents = (data) => {
      return [data.high, data.low];
    };

    const yEdgeIndicator = (data) => {
      return data.close;
    };

    const volumeColor = (data) => {
      return data.close > data.open
        ? "rgba(38, 166, 154, 0.3)"
        : "rgba(239, 83, 80, 0.3)";
    };

    const volumeSeries = (data) => {
      return data.volume;
    };

    const openCloseColor = (data) => {
      return data.close > data.open ? "#26a69a" : "#ef5350";
    };


    const [windowDimensions, setWindowDimensions] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    function useWindowDimensions() {
      const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: (window.innerHeight - 64 - 185 - 12 - 33 - 80)
      });
    
      useEffect(() => {
        function handleResize() {
          
          if(isFullscreen){
            setWindowDimensions({
              width: window.innerWidth,
              height: (window.innerHeight - 50 )
            });
          }
          else{
            setWindowDimensions({
              width: window.innerWidth,
              height: (window.innerHeight - 64 - 185 - 12 - 33 - 80 )
            });
          }
        }
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);
    
      return windowDimensions;
    }

    const handleChange = (event) => {
      const selectedOption = event.target.value;
      let newInterval;

      switch (selectedOption) {
        case "1m":
          newInterval = "1m";
          break;
        case "5m":
          newInterval = "5m";
          break;
          case "15m":
          newInterval = "15m";
          break;
        case "1h":
          newInterval = "1h";
          break;
          case "4h":
          newInterval = "4h";
          break;
        case "1d":
          newInterval = "1d";
          break;
        case "1wk":
          newInterval = "1wk";
          break;
        case "1mo":
          newInterval = "1mo";
          break;
        default:
          newInterval = "1d";
      }

      setAdvInterval(newInterval);
    };

    const chartTypes = [
      { id: "candlestick", label: "Candlestick", icon: candleStick },
      { id: "ha", label: "Heikin Ashi", icon: heikin },
      { id: "ohlc", label: "OHLC", icon: ohlc },
      { id: "line", label: "Line", icon: line },
    ];


    const [open, setOpen] = useState(false);

    const removeIndicator = (index) => {
      const updatedIndicators = indicators.filter((_, i) => i !== index);
      setIndicators(updatedIndicators);
    };

    const strokeColors = {
      yang: 'green',  // Color for 'yang' (upward movement)
      yin: 'red',    // Color for 'yin' (downward movement)
    };
    
    const fillColors = {
      yang: 'lightgreen',  // Fill color for 'yang' (upward movement)
      yin: 'lightcoral',   // Fill color for 'yin' (downward movement)
    };
const chartRef = useRef(null);
const handleDownload = () => {
      if (chartRef.current) {
        html2canvas(chartRef.current).then((canvas) => {
          const link = document.createElement('a');
          link.download = 'chart.png';
          link.href = canvas.toDataURL('image/png');
          link.click();
        });
      }
    };

    const [showSettings, setShowSettings] = useState(false);

    const handleShowSettings = () => {
      setShowSettings(!showSettings);
    };


    const floatingDiv = isFullscreen ? (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.8)",
          color: "#fff",
          zIndex: 99999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "24px",
        }}
      >
        <div
                  className="body-Chart"
                  ref={chartContainerRef}
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    
                    height: "100%",
                    borderRadius: "0px",
                    flexGrow: 1,
                  }}
                >
                  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    width: "100%"
  }}>
    <div className="topChartBar">
        

<div style={{ width: "170px", height: 36, position: "relative" }}>
      <input
      className="topChartElement"
        ref={inputRef_2}
        type="text"
        placeholder={ticker || "Search ticker..."}
        value={query_2}
        onChange={(e_2) => setQuery_2(e_2.target.value)}
        onFocus={() => setFocused_2(true)}
        onBlur={() => setTimeout(() => setFocused_2(false), 150)}
        onKeyDown={handleKeyDown_2}
        style={{
          width: "100%",
          height: "100%",
          padding: "8px",
          boxSizing: "border-box",
          //borderRadius: "6px",
          //border: "none",
          outline: "none",
          //boxShadow: "inset 0 0 3px rgba(0,0,0,0.1)",
        }}
      />
      {focused_2 && results_2.length > 0 && (
        <ul
          style={{
            position: "relative",
            width: "220px",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid rgba(0, 0, 0, 0.25)",
            color: "rgb(65, 63, 63)",
            borderRadius: "5px",
            textAlign: "left",
            fontSize: "14px",
            marginTop: "4px",
            maxHeight: "200px",
            overflowY: "auto",
            
          }}
        >
          {results_2.map((item_2) => (
            <li
              key={item_2.symbol}
              onClick={() => handleSelect_2(item_2.symbol)}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                marginBottom: 0,
              }}
            >
              <strong>{item_2.symbol}</strong> — { modifySecurityName(item_2.name)}
            </li>
          ))}
        </ul>
      )}
    </div>







        <select className="topChartElement" id="interval" style={{height: "36px" }} value={advInterval} onChange={handleChange}>
        <option value="" disabled hidden>
    Select interval...
  </option>
          <option value="1m" style={{marginTop: 4}}>1m</option>
          <option value="5m">5m</option>
          <option value="15m">15m</option>
          <option value="1h">1h</option>
          <option value="4h">4h</option>
          <option value="1d">1d</option>
          <option value="1wk">1wk</option>
          <option value="1mo">1mo</option>
        </select>
        
        <div>
        <button
        className="topChartElement"
          onClick={() => setOpen(!open)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            //background: "#fff",
            //border: "1px solid #ccc",
            //borderRadius: "6px",
            padding: "6px 10px",
            fontSize: "14px",
            height: "36px",
            cursor: "pointer",
          }}
        >
        <img
    src={
      chartType === "candlestick"
        ? candleStick
        : chartType === "ha"
        ? heikin
        : chartType === "ohlc"
        ? ohlc
        : chartType === "line"
        ? line
        : ""
    }
    alt="chart type"
    style={{ width: 24, height: 24 }}
  />

          
        </button>






        {open && (
    <div
      style={{
        position: "absolute",
        
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "5px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        zIndex: 10,
        marginTop: 4,
        fontSize: "14px",
        minWidth: "160px",
      }}
    >
      <div
        onClick={() => {
          handleChartTypeChange2("candlestick");
          setOpen(false);
        }}
        style={{ display: "flex", alignItems: "center", padding: "8px", cursor: "pointer" }}
      >
        <img src={candleStick} alt="Candlestick" style={{ width: 24, height: 24, marginRight: 8 }} />
        Candlestick
      </div>
      <div
        onClick={() => {
          handleChartTypeChange2("ha");
          setOpen(false);
        }}
        style={{ display: "flex", alignItems: "center", padding: "8px", cursor: "pointer" }}
      >
        <img src={heikin} alt="Heikin Ashi" style={{ width: 24, height: 24, marginRight: 8 }} />
        Heikin Ashi
      </div>
      <div
        onClick={() => {
          handleChartTypeChange2("ohlc");
          setOpen(false);
        }}
        style={{ display: "flex", alignItems: "center", padding: "8px", cursor: "pointer" }}
      >
        <img src={ohlc} alt="OHLC" style={{ width: 24, height: 24, marginRight: 8 }} />
        OHLC
      </div>
      <div
        onClick={() => {
          handleChartTypeChange2("line");
          setOpen(false);
        }}
        style={{ display: "flex", alignItems: "center", padding: "8px", cursor: "pointer" }}
      >
        <img src={line} alt="Line" style={{ width: 24, height: 24, marginRight: 8 }} />
        Line
      </div>
    </div>
  )}
  
</div>




        <div style={{ width: "200px", background: "#f9f9f9", height: 36 }}>
        <input
        ref={inputRef}
        type="text"
        className="topChartElement"
        placeholder=" ƒ Search indicators..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setTimeout(() => setFocused(false), 150)} // delay so click still registers
        style={{
          width: "100%",
          padding: "8px",
          height: "36px",
          boxSizing: "border-box",
          zIndex: 9999,
          position: "relative",
        }}
      />
      {focused && filteredIndicators.length > 0 && (
        <ul
          style={{
            position: "relative",
            width: "220px",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid rgba(0, 0, 0, 0.25)",
            color: "rgb(65, 63, 63)",
            borderRadius: "5px",
            textAlign: "left",
            fontSize: "14px",
            marginTop: "4px",
            maxHeight: "200px",
            overflowY: "auto",
            
          }}
        >
          {filteredIndicators.map((item) => (
            <li
              key={item.indicator}
              onClick={() => handleSelectI(item)}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid rgba(0, 0, 0, 0.25)",
                marginBottom: 0,
              }}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
    <div style={{display: "flex", gap: 1}}>
    
    
<div          className="download topChartElement"
                onClick={handleShowSettings}
                style={{ position: "relative", cursor: "pointer", height: "34px"}}
              >
                <div className="search" style={{width: "auto", height: "31px"}}>
                  <div className="overlap-group" style={{ width: "100%", height: "100%" }}>
                    
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
<svg
fill="rgb(181, 183, 192)" // Change to white or another contrasting color
                          height="20px" // Define the size of the SVG icon
                          width="20px"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M256,192c-35.285,0-64,28.715-64,64s28.715,64,64,64s64-28.715,64-64S291.285,192,256,192z" />
      <path d="M494.699,212.48l-28.245-5.44c-12.651-2.411-22.571-10.688-27.285-22.635c-4.715-12.011-3.051-24.832,4.587-35.221 
        l17.728-24.192c6.229-8.469,5.312-20.245-2.133-27.669l-38.293-38.293c-7.211-7.232-18.603-8.299-27.029-2.581l-23.829,16.107 
        c-10.624,7.232-23.467,8.405-35.307,3.285c-11.797-5.163-19.712-15.403-21.653-28.139l-4.565-29.611 
        C307.072,7.68,298.112,0,287.573,0h-54.144c-10.219,0-19.008,7.253-20.949,17.301l-7.019,36.48 
        c-2.368,12.352-10.389,22.208-22.016,27.008c-11.627,4.843-24.299,3.541-34.709-3.52l-30.763-20.821 
        c-8.427-5.717-19.776-4.651-27.029,2.581L52.651,97.323c-7.445,7.424-8.363,19.2-2.133,27.669l17.728,24.213 
        c7.637,10.368,9.301,23.189,4.587,35.2c-4.715,11.947-14.635,20.224-27.307,22.635l-28.224,5.44 
        C7.253,214.421,0,223.211,0,233.429v54.144c0,10.539,7.68,19.499,18.091,21.099l29.611,4.565 
        c12.736,1.941,22.976,9.856,28.139,21.653c5.141,11.797,3.947,24.661-3.285,35.328l-16.107,23.808 
        c-5.739,8.448-4.651,19.797,2.581,27.029l38.293,38.293c7.445,7.467,19.2,8.32,27.669,2.133l24.213-17.728 
        c10.368-7.616,23.168-9.259,35.2-4.587c11.947,4.715,20.224,14.635,22.635,27.307l5.44,28.224 
        C214.421,504.747,223.211,512,233.429,512h54.144c10.539,0,19.499-7.68,21.099-18.091l3.2-20.821 
        c2.005-13.035,10.133-23.381,22.293-28.395c12.075-5.035,25.195-3.477,35.84,4.331l17.003,12.459 
        c8.427,6.187,20.224,5.333,27.669-2.133l38.293-38.293c7.232-7.232,8.32-18.581,2.581-27.029l-16.107-23.829 
        c-7.232-10.645-8.427-23.509-3.285-35.307c5.163-11.797,15.403-19.712,28.139-21.653l29.611-4.565 
        c10.411-1.6,18.091-10.56,18.091-21.099v-54.144C512,223.211,504.747,214.421,494.699,212.48z 
        M256,362.667c-58.816,0-106.667-47.851-106.667-106.667S197.184,149.333,256,149.333S362.667,197.184,362.667,256 
        S314.816,362.667,256,362.667z" />
    </g>
  </svg>                      </div>
                    
                  </div>
                </div>
                <div className="settingsPopup" style={{ borderRadius: "5px", color: "rgba(65, 63, 63, 1)", fontFamily: 'Lexend', border: "1px solid rgba(0, 0, 0, 0.25)", backgroundColor: "white", flexDirection: "column", position: "absolute", top: 40, left: -350, width: "500px", height: "500px", display: showSettings ? "flex" : "none", justifyContent: "center", alignItems: "center", zIndex: 10000 }}>
                  <h3>Candle Appearance Settings</h3>

      <label>
        Stroke:
        <input
          type="color"
          value={candlesAppearance.stroke}
          onChange={(e) => handleChange6("stroke", e.target.value)}
        />
      </label>
      <br />

      <label>
        Candle Stroke Width:
        <input
          type="number"
          step="0.1"
          value={candlesAppearance.candleStrokeWidth}
          onChange={(e) => handleChange6("candleStrokeWidth", parseFloat(e.target.value))}
        />
      </label>
      <br />

      <label>
        Width Ratio:
        <input
          type="range"
          min="0.1"
          max="1"
          step="0.05"
          value={candlesAppearance.widthRatio}
          onChange={(e) => handleChange6("widthRatio", parseFloat(e.target.value))}
        />
        <span>{candlesAppearance.widthRatio}</span>
      </label>
      <br />

      <label>
        Fill Color (Up Candle):
        <input
          type="color"
          value={rgbaToHex(fillColors6.up)}
          onChange={(e) => handleFillColorChange("up", hexToRgba(e.target.value, 0.8))}
        />
      </label>
      <br />

      <label>
        Fill Color (Down Candle):
        <input
          type="color"
          value={rgbaToHex(fillColors6.down)}
          onChange={(e) => handleFillColorChange("down", hexToRgba(e.target.value, 0.8))}
        />
      </label>
      <label>
        Fill Color Wick (Up Candle):
        <input
          type="color"
          value={rgbaToHex(fillColors62.up)}
          onChange={(e) => handleFillColorChange2("up", hexToRgba(e.target.value, 0.8))}
        />
      </label>
      <br />

      <label>
        Fill Color Wick (Down Candle):
        <input
          type="color"
          value={rgbaToHex(fillColors62.down)}
          onChange={(e) => handleFillColorChange2("down", hexToRgba(e.target.value, 0.8))}
        />
      </label>
              </div>
              </div>
              
              
              
              <div          className="download topChartElement"
                onClick={handleDownload}
                style={{ position: "relative", cursor: "pointer", height: "34px"}}
              >
                <div className="search" style={{width: "auto", height: "31px"}}>
                  <div className="overlap-group" style={{ width: "100%", height: "100%" }}>
                    
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <svg
                          fill="rgb(181, 183, 192)" // Change to white or another contrasting color
                          height="20px" // Define the size of the SVG icon
                          width="20px" // Define the size of the SVG icon
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 512 512" // This is the only required attribute
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <g>
                              <path d="M440.125,0H0v512h512V71.875L440.125,0z M281.6,31.347h31.347v94.041H281.6V31.347z M136.359,31.347h113.894v125.388 h94.041V31.347h32.392v156.735H136.359V31.347z M417.959,480.653H94.041V344.816h323.918V480.653z M417.959,313.469H94.041 v-31.347h323.918V313.469z M480.653,480.653h-31.347V250.775H62.694v229.878H31.347V31.347h73.665v188.082h303.02V31.347h19.108 l53.512,53.512V480.653z"></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                    
                  </div>
                </div>
              </div>

<button className="topChartElement" style={{ height: "36px", cursor: "pointer" }} onClick={() => setIsFullscreen(false)}>Exit Fullscreen</button>

   
  </div>
        </div>
        {/*indicators.map((ind, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px",
              border: "1px solid #ccc",
              margin: "5px",
              borderRadius: "5px"
            }}
          >
            <div style={{ flex: 1 }}>
              <span>{ind.indicator} - Value: {ind.value}</span>
            </div>
            <button
              onClick={() => removeIndicator(index)}
              style={{
                backgroundColor: "red",
                color: "white",
                border: "none",
                borderRadius: "50%",
                cursor: "pointer",
                padding: "5px",
                fontSize: "16px"
              }}
            >
              🗑️
            </button>
          </div>
        ))*/}
        <div style={{ position: "relative", display: "inline-block" }}>
        
        

{/*------------------------------------------------------------------------------- START OF CUSTOMIZATION ---------------------------------------------------------------------- */}
{/* selectedFib, selectedTrend */}



  


{/*------------------------------------------------------------------------------- END OF CUSTOMIZATION ---------------------------------------------------------------------- */}






        
        

      </div>





      <div className="DrawButtons" style={{ marginTop: 64, borderRight: "3px solid #f1f4f7", position: "absolute", left: 43,  width: 54, display: "flex", flexDirection: "column", gap: 10, zIndex: 1000}}>
      
      <div style={{ height: 46, display: "flex", flexDirection: "row"}}><button onClick={() => { setEnableTrendLine(true); setTrendlineType("LINE"); }}><img style= {{width: "86%", height:"86%"}}src={line2} /></button><button style={{width: 8, display: "flex", justifyContent: "center", alignContent: "center"}}onClick={() =>
  setOpenDrawing((prev) => (prev === "Trendline" ? "" : "Trendline"))
}
>{openDrawing != "Trendline" ? '>' : '<'}</button>
      {openDrawing == "Trendline" ? ( <div className="openTab"><button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}} onClick={() => { setEnableTrendLine(true); setTrendlineType("LINE");setOpenDrawing(""); }}><img style={{width: 46, height: 46}}src={line2} />Trend Line</button>
      <button  style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}} onClick={() => { setEnableTrendLine(true); setTrendlineType("RAY"); setOpenDrawing(""); }}><img style={{width: 46, height: 46}} src={line1} />Ray</button>
<button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}}onClick={() => { setEnableTrendLine(true); setTrendlineType("XLINE");setOpenDrawing(""); }}><img style={{width: 46, height: 46}} src={line3} />Extended Line</button></div>) : (<></>)}
      </div>


      <div style={{height: 46, display: "flex", flexDirection: "row"}}><button onClick={() => { setEnableFib(true); setFibType("BOUND")}}><img style= {{width: "86%", height:"86%"}} src={fib1} /></button>
<button style={{width: 8, display: "flex", justifyContent: "center", alignContent: "center"}}onClick={() =>
  setOpenDrawing((prev) => (prev === "Fib" ? "" : "Fib"))
}
>{openDrawing != "Fib" ? '>' : '<'}</button>
{openDrawing == "Fib" ? ( <div className="openTab">
<button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}} onClick={() => { setEnableFib(true); setFibType("BOUND")}}><img style= {{height:"86%", width: "auto"}} src={fib1} />Fibonacci Retracement</button>
<button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}}onClick={() => { setEnableFib(true); setFibType("RAY")}}><img style= {{height:"86%", width: "auto"}} src={fib3} />Ray</button>
<button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}}onClick={() => { setEnableFib(true); setFibType("EXTEND")}}><img style= {{height:"86%", width: "auto"}} src={fib2} />Extended</button>
</div>) : (<></>)}</div>



<div style={{height: 46, display: "flex", flexDirection: "row"}}><button onClick={() => { setEnableEQC(true);}}><img style= {{width: "86%", height:"86%"}} src={channel} /></button>
    <button style={{width: 8, display: "flex", justifyContent: "center", alignContent: "center"}}onClick={() =>
      setOpenDrawing((prev) => (prev === "channels" ? "" : "channels"))
    }
    >{openDrawing != "channels" ? '>' : '<'}</button>
    {openDrawing == "channels" ? ( <div className="openTab">
    <button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}} onClick={() => { setEnableEQC(true);}}><img style= {{width: "86%", height:"86%"}} src={channel} />Equidistant</button>
    <button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}} onClick={() => { setEnableSTD(true);}}>Standard Deviation</button>
    </div>) : (<></>)}</div>






<div style={{height: 46, display: "flex", flexDirection: "row"}}><button onClick={() => { setTrends1([]);setEQC1([]);setSTD1([]);setRetracements1([])}}><img style= {{width: "86%", height:"86%"}} src={bin} /></button>
    <button style={{width: 8, display: "flex", justifyContent: "center", alignContent: "center"}}onClick={() =>
      setOpenDrawing((prev) => (prev === "bin" ? "" : "bin"))
    }
    >{openDrawing != "bin" ? '>' : '<'}</button>
    {openDrawing == "bin" ? ( <div className="openTab">
    <button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}} onClick={() => { setTrends1([]);setEQC1([]);setSTD1([]);setRetracements1([])}}>Clear Drawings</button>
    <button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}} onClick={() => { setIndicators([]);}}>Remove Indicators</button>
    <button style={{height: 46, width: 110, display: "flex", justifyContent: "flex-start"}} onClick={() => { setTrends1([]);setEQC1([]);setSTD1([]);setRetracements1([]);setIndicators([]);setShowVolume(false);}}>Clear All</button>
    </div>) : (<></>)}</div>



</div>





      </div>

                  {dimensions.width > 0 && dimensions.height > 0 && (
                    <div ref={chartRef}>
                      <div style={{position: "absolute", width: dimensions.width, height: height, display: "flex", justifyContent: "flex-end"}}>
                        <div style={{position: "relative", right: 100, top: 10}}> 
                          <img src={watermark} style={{width: 120, opacity: 0.1}}/>
                          </div></div>
                <ChartCanvas
                ref={chartRef}
        className="ChartCanvas4124"
        ratio={3}
        width={dimensions.width}
        height={height}
        margin={margin}
        data={data}
        displayXAccessor={displayXAccessor}
        seriesName="Data"
        xScale={xScale}
        xAccessor={xAccessor}
        xExtents={xExtents}
        zoomAnchor={lastVisibleItemBasedZoomAnchor}
      >
        {showVolume && (
        <ChartRF
          id={2}
          height={barChartHeight}
          origin={barChartOrigin}
          yExtents={barChartExtents}
        >
          <BarSeries fillStyle={volumeColor} yAccessor={volumeSeries} />
          
        </ChartRF>)}






        <ChartRF id={3} height={chartHeight} yExtents={candleChartExtents} >
        <XAxis showGridLines showTicks={lastChart == "price" ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={lastChart == "price" ? true : false}/>
          {lastChart == "price" && <MouseCoordinateX displayFormat={timeDisplayFormat} />}
          <YAxis showGridLines tickFormat={pricesDisplayFormat} />
          {(chartType === "candlestick" && (
      <CandlestickSeries data={calculatedData} {...candlesAppearance}/>
    ))}
  {(chartType === "ha") && (
      <CandlestickSeries data={calculatedData} />
    )}



 {(chartType == "line") && (
  <AreaSeries
  yAccessor={d => d.close}
  strokeWidth={2}
  fillStyle="rgba(89, 50, 234, 0.1)"
  strokeStyle="#5932ea"
  interpolation={curveMonotoneX}

/>
 )}



    {/* Kagi Series */}
    {chartType === "kagi" && (
    <KagiSeries
      data={calculatedData}
      stroke={strokeColors}
      fill={fillColors}
      currentValueStroke={"#a46fd9"}
      strokeWidth={2} // Optional: customize stroke width if needed
    />
  )}

  {chartType === "ohlc" && <OHLCSeries data={calculatedData} />}

    {chartType === "renko" && <RenkoSeries data={calculatedData} fill={{
    up: '#26a69a',
    down: '#ef5350',
    partial: '#a46fd9'
  }}/>}

    {/* Point and Figure Series */}
    {chartType === "pAndF" && <PointAndFigureSeries data={calculatedData} />}
          {indicatorPipeline.map((indicatorFn, i) => {
    const name = indicators[i].indicator;
    const width = indicators[i].width || 1;
    const id = i + 1;  // The 'id' here should start from 1
    const options = indicators[i];
    if (name == "rsi" || name =="atr" || name == "elder" || name == "macd" || name == "stoch" || name == "fi" || name == "fiEMA"){
      return;
    }
    if (name === "bb") {
      return (
        <BollingerSeries
          key={`bb-${i}`}
          yAccessor={(d) => d.bb}
          stroke={bbStroke}
          fill={bbFill}
        />
      );
    }

    const accessorKey = `${name}${id}`;
    const accessor = (d) => d[accessorKey];

    return (
      <React.Fragment key={`${name}-${id}`}>
        <LineSeries yAccessor={accessor} strokeStyle={indicatorFn.stroke()} strokeWidth={width}/>
        <CurrentCoordinate yAccessor={accessor} fillStyle={indicatorFn.stroke()} />
      </React.Fragment>
    );
  })}




{indicators.some((ind) => ind.indicator === "sar") && (<SARSeries yAccessor={d => d.sar}/>)}
{indicators.some((ind) => ind.indicator === "volumeProfile") && (<VolumeProfileSeries />)}
          <MouseCoordinateY
            
            displayFormat={pricesDisplayFormat}
          />
          <EdgeIndicator
            itemType="last"
            
            fill={openCloseColor}
            lineStroke={openCloseColor}
            displayFormat={pricesDisplayFormat}
            yAccessor={yEdgeIndicator}
          />
          {indicators.some((ind) => ind.indicator === "ema" || ind.indicator === "sma" || ind.indicator === "tma" || ind.indicator === "wma") && (
      <MovingAverageTooltip
        origin={[8, origins.ma]}
        onClick={() => openSettings("ma", null)}
        options={indicators
          .map((ind, i) => {
            if (ind.indicator !== "ema" && ind.indicator !== "sma" && ind.indicator !== "wma" && ind.indicator !== "tma") return null;
            const id = i + 1;
            const key = `${ind.indicator}${id}`;
            return {
              yAccessor: (d) => d[key],
              type: ind.indicator.toUpperCase(),
              stroke: indicatorPipeline[i].stroke(),
              windowSize: ind.value,
            };
          })
          .filter(Boolean)}
      />
      
    )}
    {/*<VolumeProfileSeries bySession orient="right" showSessionBackground />*/}
    {showVolume && (
      <SingleValueTooltip
      yAccessor={volumeSeries}
      onClick={() => setShowVolume(!showVolume)}
      yLabel="Vol"
      //yDisplayFormat={(d) => `${vol}`}
      origin={[8, origins.volume]}
    />
    )}

    {indicators.some((ind) => ind.indicator === "bb") && (
      <BollingerBandTooltip
        origin={[8, origins.bb]}
        onClick={() => openSettings("bb", indicatorPipeline[indicators.findIndex((i) => i.indicator === "bb")].options())}
        yAccessor={(d) => d.bb}
        options={indicatorPipeline[indicators.findIndex((i) => i.indicator === "bb")].options()}
      />
    )}
    {
  (() => {
    const sarIndicator = indicators.find((ind) => ind.indicator === "sar");
    return sarIndicator ? (
      <SingleValueTooltip
        yLabel={`SAR (${sarIndicator.accelerationFactor}, ${sarIndicator.maxAccelerationFactor})`}
        yAccessor={(d) => d.sar}
        origin={[8, origins.sar]}
        onClick={() =>
          setIndicators((prev) =>
            prev.filter((ind) => ind.indicator !== "sar")
          )
        }
      />
    ) : null;
  })()
}

            
    {indicators.some((ind) => ind.indicator === "volumeProfile") && (
      <SingleValueTooltip
      //yAccessor={volumeSeries}
      onClick={() =>
        setIndicators((prev) =>
          prev.filter((ind) => ind.indicator !== "volumeProfile")
        )
      }
      yLabel="Volume Profile"
      yDisplayFormat={(d) => ``}
      origin={[8, origins.vp]}
    />
    )}
          

         {/*} <ZoomButtons onReset={handleResetZoom}/>*/}
          <OHLCTooltip origin={[8, origins.ohlc]} />
          <TrendLine
    ref={saveInteractiveNodes(interactiveNodesRef, "Trendline", 3)}
    enabled={enableTrendLine}
    type={trendlineType}
    snap={false}
    snapTo={d => [d.high, d.low]}
    onStart={() => console.log("START")}
    onComplete={onDrawCompleteChart1}
    trends={trends1}
  />
<FibonacciRetracement
  ref={saveInteractiveNodes(interactiveNodesRef, "FibonacciRetracement", 3)}
  enabled={enableFib}
  type={fibType}
  retracements={retracements1}
  onComplete={onFibComplete1}
/>
<EquidistantChannel
            ref={saveInteractiveNodes(interactiveNodesRef, "EquidistantChannel", 3)}
            enabled={enableEQC}
            onStart={() => console.log("START")}
            onComplete={onEQCComplete1}
            channels={EQC1}
          /><StandardDeviationChannel
          ref={saveInteractiveNodes(interactiveNodesRef, "StandardDeviationChannel", 3)}
          enabled={enableSTD}
          onStart={() => console.log("START")}
          onComplete={onSTDComplete1}
          channels={STD1}
        />
          
        </ChartRF>


        {active.map((ind, i) => {
          //const Ycords[i] = layout.price + height * ((100 - layout.price)/100))/(active.length)
      const pct     = getPercent(i);
      const isLast = i === active.length - 1;
      // originY = totalHeight * (pct / 100)
      const originY = (gridHeight * pct) / 100;
      //console.log(ind, i, height, gridHeight, originY, pct);
      if (ind == "elder"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, elder.accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={pricesDisplayFormat} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={pricesDisplayFormat}
          />
    
          <ElderRaySeries yAccessor={elder.accessor()} />
    
          <SingleValueTooltip
            yAccessor={elder.accessor()}
            onClick={() => openSettings("elderRay", null)}
            yLabel="Elder Ray"
            yDisplayFormat={(d) =>
              `${pricesDisplayFormat(d.bullPower)}, ${pricesDisplayFormat(d.bearPower)}`
            }
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };
      if (ind == "macd"){
        const ind = indicators.find((ind) => ind.indicator === "macd");
        return (
          <ChartRF id={i+4} height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
        yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "macd")].accessor()]}
        origin={[0, originY]}
        //padding={{ top: 8, bottom: 8 }}
      >
        <XAxis showGridLines showTicks={isLast  ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ?  true : false}/>
        <YAxis ticks={4} tickFormat={pricesDisplayFormat} />

        {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
        <MouseCoordinateY
          at="right"
          orient="right"
          displayFormat={format(".2f")}
        />

        

        <MACDSeries yAccessor={(d) => d.macd} />

        
        <SingleValueTooltip 
  origin={[8, 16]}
  yAccessor={(d) => d}
  onClick={() => openSettings("macd", indicatorPipeline[indicators.findIndex((i) => i.indicator === "macd")].options())}
  yLabel=""
  yDisplayFormat={(d) => {
    const macd = d?.macd;
    return macd
      ? `MACD (${ind.macdSlow},${ind.macdFast}): ${macd.macd.toFixed(2)}, Signal (${ind.macdSignal}): ${macd.signal.toFixed(2)}, Divergence: ${macd.divergence.toFixed(2)}`
      : "MACD: n/a";
  }}
/>

      </ChartRF>
        )
        
      };
      if (ind == "rsi"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "rsi")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={pricesDisplayFormat} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={pricesDisplayFormat}
          />
    
    <RSISeries yAccessor={d => d.rsi} />
    
          
          <RSITooltip origin={[8, 16]}
            yAccessor={d => d.rsi}
            options={indicatorPipeline[indicators.findIndex((i) => i.indicator === "rsi")].options()} />
        </ChartRF>
        )
        
      };
      if (ind == "atr"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "atr")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={pricesDisplayFormat} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={pricesDisplayFormat}
          />
    
    <LineSeries yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "atr")].accessor()} />
    
          <SingleValueTooltip
            yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "atr")].accessor()}
            //onClick={() => openSettings("elderRay", null)}
            yLabel={`ATR (${indicatorPipeline[indicators.findIndex((i) => i.indicator === "atr")].options().windowSize})`}
            yDisplayFormat={format(".2f")}
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };
      if (ind == "stoch"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "stoch")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={pricesDisplayFormat} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={pricesDisplayFormat}
          />
    
    <StochasticSeries
            yAccessor={d => d.stoch} {...stoAppearance}/>
    
    <StochasticTooltip
            yAccessor={d => d.stoch}
            //onClick={() => openSettings("elderRay", null)}
            label="Stoch"
            options={indicatorPipeline[indicators.findIndex((i) => i.indicator === "stoch")].options()}
            appearance={stoAppearance}
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };
      if (ind == "fi"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "fi")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={format(".2s")}/>
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={format(".2s")}
          />
    
    <AreaSeries baseAt={scale => scale(0)} yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fi")].accessor()} />
    <StraightLine yValue={0} />
    
    <SingleValueTooltip
           yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fi")].accessor()}
            //onClick={() => openSettings("elderRay", null)}
            yLabel="ForceIndex (1)"
            yDisplayFormat={format(".4s")}
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };
      if (ind == "fiEMA"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={format(".2s")} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={format(".2s")}
          />
    
    <AlternatingFillAreaSeries
            baseAt={0}
            yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].accessor()}
          />
          <StraightLine yValue={0} />
    
          <SingleValueTooltip
            yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].accessor()}
            //onClick={() => openSettings("elderRay", null)}
            yLabel={`ForceIndex (${indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].options().windowSize})`}
            options={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].options()}
            //appearance={stoAppearance}
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };




    
  })}





        


        <CrossHairCursor />
        <DrawingObjectSelector
          enabled={!enableSTD}
          getInteractiveNodes={() => {
            // Access the current node from the reference
            const interactiveNode = interactiveNodesRef.current;
          //console.log("interactiveNode", interactiveNode);
        
            return interactiveNode;
          }}
          drawingObjectMap={{
            StandardDeviationChannel: "channels"
          }}
          onSelect={handleSelectionSTD}
        />
        <DrawingObjectSelector
          enabled={!enableEQC}
          getInteractiveNodes={() => {
            // Access the current node from the reference
            const interactiveNode = interactiveNodesRef.current;
          //console.log("interactiveNode", interactiveNode);
        
            return interactiveNode;
          }}
          drawingObjectMap={{
            EquidistantChannel: "channels"
          }}
          onSelect={handleSelectionEQC}
        />

        <DrawingObjectSelector
  enabled={!enableFib}
  getInteractiveNodes={() => {
    // Access the current node from the reference
    const interactiveNode = interactiveNodesRef.current;
  //console.log("interactiveNode", interactiveNode);

    return interactiveNode;
  }}
  drawingObjectMap={{
    FibonacciRetracement: "retracements"
  }}
  onSelect={handleSelectionFib}
/>

        <DrawingObjectSelector
    enabled={!enableTrendLine}
    getInteractiveNodes={() => {
      // Access the current node from the reference
      const interactiveNode = interactiveNodesRef.current;
    //console.log("interactiveNode", interactiveNode);

      return interactiveNode;
    }}
    
    drawingObjectMap={{
      Trendline: "trends"
    }}
    onSelect={handleSelection}
  />

      </ChartCanvas></div>)}
                </div>
        
      </div>
    ) : null;


    

   const [quarterLabels, setQuarterLabels] = useState([]);
     const [quarterLabels10, setQuarterLabels10] = useState([]);
  const [fiscalYearLabels, setFiscalYearLabels] = useState([]);
function cleanDateString(raw) {
  if (typeof raw === 'string') {
    const cleaned = raw.replace(/_FY$/, '');
    return cleaned;
  } else {
    return raw;
  }
}
const [revenueChartTime, setRevenueChartTime] = useState("year");
useEffect(() => {
    if (Array.isArray(QData) && QData.length > 0) {
      const lastFiveQuarters = QData.slice(0, 5).map(item =>
        convertToMonthYear(item.endDate || item.reportDate || item.quarterBS || item.quarterIS || item.quarterCF)
      );
      setQuarterLabels(lastFiveQuarters.reverse()); 
      const lastFiveQuarters2 = QData.slice(0, QData.length).map(item =>
        convertToMonthYear(item.endDate || item.reportDate || item.quarterBS || item.quarterIS || item.quarterCF)
      );
      // Keep the full label series in the same newest-to-oldest order as the
      // quarterly EPS and cash arrays. Each chart selects the newest N periods
      // first, then reverses both values and labels for chronological display.
      setQuarterLabels10(lastFiveQuarters2);
    }

    if (Array.isArray(FYData) && FYData.length > 0) {
      const lastFiveYears = FYData.slice(0, 5).map(item =>
        convertToYear(item.endDate || item.reportDate || item.quarterBS || item.quarterIS || item.quarterCF)
      );
      setFiscalYearLabels(lastFiveYears.reverse());
    }
  }, [QData, FYData]);

    const config = selectedIndicator;


const scrollPositionRef = useRef(0);

  useEffect(() => {
    const scrollableDiv = document.querySelector('.content');
    if (!scrollableDiv) {
      console.warn("[Scroll Lock] ❌ .content element not found");
      return;
    }


    if (financialsTableVisible) {
      // Save current scroll position
      scrollPositionRef.current = scrollableDiv.scrollTop;

      // Lock scroll
      scrollableDiv.classList.add('no-scroll');

      // Scroll to top
      scrollableDiv.scrollTop = 0;
    } else {
      // Unlock scroll
      scrollableDiv.classList.remove('no-scroll');

      // Restore previous scroll position
      scrollableDiv.scrollTop = scrollPositionRef.current;
    }

    // Clean up when component unmounts
    return () => {
      scrollableDiv.classList.remove('no-scroll');
    };
  }, [financialsTableVisible]);

















const [revData, setRevData] = useState([])
  const [incData, setIncData] = useState([])
  const [labelsYear, setLabelsYear] = useState([])
  const [revQData, setRevQData] = useState([])
  const [incQData, setIncQData] = useState([])
  const [labelsQuarter, setLabelsQuarter] = useState([])
  const [epsAData, setEpsAData] = useState([])
  const [epsAYears, setEpsAYears] = useState([])
  const [epsQData, setEpsQData] = useState([])
  const [epsQLabels, setEpsQLabels] = useState([])
  const [cashChangeQdata, setCashChangeQdata] = useState([])
  const [cashChangeQLabels, setCashChangeQLabels] = useState([])
  const [cashChangeAdata, setCashChangeAdata] = useState([])
  const [cashChangeALabels, setCashChangeALabels] = useState([])
  const [assetsLT, setAssetsLT] = useState(null)
  const [liabLT, setLiabLT] = useState(null)
  const [assetsST, setAssetsST] = useState(null)
  const [liabST, setLiabST] = useState(null)

  // compute financials
  useEffect(() => {
    if (!ratios?.forCharts) return

    const MAX_ANNUAL = 5
    const MAX_QUARTER = 5
    const MAX_EPS_ANNUAL = 5
    const MAX_EPS_QUARTER = 10

    const isUsableChartValue = (value) =>
      value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value))
    const isUsableChartLabel = (label) =>
      Boolean(label) && !String(label).toLowerCase().includes("invalid")
    const roundChartValue = (value) =>
      Math.round((Number(value) + Number.EPSILON) * 100) / 100
    const compactSingleSeries = (values, labels) => {
      const periods = values
        .map((value, index) => ({ value, label: labels[index] }))
        .filter(({ value, label }) => isUsableChartValue(value) && isUsableChartLabel(label))
      return {
        values: periods.map(({ value }) => roundChartValue(value)),
        labels: periods.map(({ label }) => label),
      }
    }
    const compactPairedSeries = (first, second, labels) => {
      const periods = labels
        .map((label, index) => ({ first: first[index], second: second[index], label }))
        .filter(({ first, second, label }) =>
          isUsableChartLabel(label) &&
          (isUsableChartValue(first) || isUsableChartValue(second))
        )
      return {
        first: periods.map(({ first }) => isUsableChartValue(first) ? roundChartValue(first) : null),
        second: periods.map(({ second }) => isUsableChartValue(second) ? roundChartValue(second) : null),
        labels: periods.map(({ label }) => label),
      }
    }

    // annual rev & inc (reverse slice to chronological oldest→newest)
    const rawRev = ratios?.forCharts.AnnualRevenues || []
    const rawInc = ratios?.forCharts.AnnualIncome   || []
    const countAnn = Math.min(MAX_ANNUAL, rawRev.length)
    const sliceRev = rawRev.slice(-countAnn).reverse()
    const sliceInc = rawInc.slice(-countAnn).reverse()
    const annualRevenue = compactPairedSeries(sliceRev, sliceInc, fiscalYearLabels.slice(-countAnn))
    setRevData(annualRevenue.first)
    setIncData(annualRevenue.second)
    setLabelsYear(annualRevenue.labels)

    // quarterly rev & inc
    const rawRevQ = ratios?.forCharts.quarterlyRevenues || []
    const rawIncQ = ratios?.forCharts.QuarterlyIncome   || []
    const countQ = Math.min(MAX_QUARTER, rawRevQ.length)
    const sliceRevQ = rawRevQ.slice(-countQ).reverse()
    const sliceIncQ = rawIncQ.slice(-countQ).reverse()
    const quarterlyRevenue = compactPairedSeries(sliceRevQ, sliceIncQ, quarterLabels.slice(-countQ))
    setRevQData(quarterlyRevenue.first)
    setIncQData(quarterlyRevenue.second)
    setLabelsQuarter(quarterlyRevenue.labels)

    // annual EPS
    const rawEpsA = ratios?.forCharts.EPS_annual    || []
    const countEpsA = Math.min(MAX_EPS_ANNUAL, rawEpsA.length)
    const annualEps = compactSingleSeries(rawEpsA.slice(-countEpsA).reverse(), fiscalYearLabels.slice(-countEpsA))
    setEpsAData(annualEps.values)
    setEpsAYears(annualEps.labels)

const rawcshA = ratios?.forCharts.AnnualCashChange    || []
    const countcdhA = Math.min(MAX_ANNUAL, rawcshA.length)
    const annualCash = compactSingleSeries(rawcshA.slice(-countcdhA).reverse(), fiscalYearLabels.slice(-countcdhA))
    setCashChangeAdata(annualCash.values)
    setCashChangeALabels(annualCash.labels)


const rawcshQ = ratios?.forCharts.quarterlyCashChange || [];
const countcshQ = Math.min(MAX_QUARTER, rawcshQ.length);

// take newest N from the START, then reverse to show oldest→newest
const quarterlyCash = compactSingleSeries(
  rawcshQ.slice(0, countcshQ).reverse(),
  [...quarterLabels10].slice(0, countcshQ).reverse()
);
setCashChangeQdata(quarterlyCash.values);

// keep labels aligned with the same ordering assumption (newest→oldest source)
setCashChangeQLabels(quarterlyCash.labels);



    // quarterly EPS
// quarterly EPS — EPS_quarterly is newest→oldest, so take first N then reverse
const rawEpsQ = ratios?.forCharts.EPS_quarterly || [];
const countEpsQ = Math.min(MAX_EPS_QUARTER, rawEpsQ.length);

// take newest N from the START, then reverse to show oldest→newest
const quarterlyEps = compactSingleSeries(
  rawEpsQ.slice(0, countEpsQ).reverse(),
  [...quarterLabels10].slice(0, countEpsQ).reverse()
);
setEpsQData(quarterlyEps.values);

// keep labels aligned with the same ordering assumption (newest→oldest source)
setEpsQLabels(quarterlyEps.labels);
    // assets & liabilities
    const chartArr = ratios?.forCharts.AssetsChart || []
    setAssetsLT(chartArr[1] ?? null)
    setLiabLT(chartArr[0] ?? null)
    setAssetsST(chartArr[3] ?? null)
    setLiabST(chartArr[2] ?? null)
  }, [ratios, fiscalYearLabels, quarterLabels, quarterLabels10])

  const hasAnyFinancialChartData = [
    ...revData,
    ...incData,
    ...revQData,
    ...incQData,
    ...epsAData,
    ...epsQData,
    ...cashChangeAdata,
    ...cashChangeQdata,
    assetsLT,
    liabLT,
    assetsST,
    liabST,
  ].some((value) => value !== null && value !== undefined && Number.isFinite(Number(value)))

  const financialChartsUnavailable = ratios?.forCharts && !hasAnyFinancialChartData
  const financialChartsUnavailableMessage = (
    <div
      role="status"
      style={{
        minHeight: 180,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#6b6b76",
        fontSize: 13,
        background: "#fff",
        borderRadius: 12,
      }}
    >
      Financial chart data is not available for this security. There may be insufficient filings or unsupported 20-F data.
    </div>
  )





















useEffect(() => {
    if (!rawData.length) return
    const closes = rawData.map(d => d.close)

    // SMA50 & SMA200 (take last non-null)
    const sma50Arr  = calcSMAArray(closes, 50)
    const sma200Arr = calcSMAArray(closes, 200)
    setSma50(sma50Arr[sma50Arr.length - 1]?.toFixed(2) ?? null)
    setSma200(sma200Arr[sma200Arr.length - 1]?.toFixed(2) ?? null)

    // RSI14
    const period = 14
    const deltas = closes.slice(1).map((v,i) => v - closes[i])
    const gains = deltas.map(d => (d > 0 ? d : 0))
    const losses= deltas.map(d => (d < 0 ? -d : 0))
    let avgGain = gains.slice(0,period).reduce((a,v)=>a+v,0)/period
    let avgLoss = losses.slice(0,period).reduce((a,v)=>a+v,0)/period
    for (let i = period; i < deltas.length; i++) {
      avgGain = (avgGain * (period - 1) + gains[i]) / period
      avgLoss = (avgLoss * (period - 1) + losses[i]) / period
    }
    const rs = avgLoss === 0 ? 100 : avgGain / avgLoss
    setRsiVal((100 - 100/(1+rs)).toFixed(2))

    // MACD: EMA12, EMA26 => difference
    const emaCalc = (data, span) => {
      const k = 2/(span+1)
      return data.map((v,i,arr) =>
        i===0 ? v : arr[i]*k + data[i-1]*(1-k)
      )
    }
    const ema12 = emaCalc(closes, 12)
    const ema26 = emaCalc(closes, 26)
    const macdArr = closes.map((_,i) =>
      i<26 ? null : (ema12[i] - ema26[i])
    )
    const lastMacd = macdArr[macdArr.length-1]
    setMacdVal(lastMacd?.toFixed(2) ?? null)

    // Signal line (9-period EMA of MACD)
    const validMacd = macdArr.filter(v=>v!=null)
    const signalArr = emaCalc(validMacd, 9)
    setSignalVal(signalArr[signalArr.length-1]?.toFixed(2) ?? null)

    // Histogram = MACD - Signal
    if (lastMacd != null && signalArr.length) {
      setHistVal((lastMacd - signalArr[signalArr.length-1]).toFixed(2))
    } else setHistVal(null)
  }, [rawData])




function pctDiff(fairValue, marketPrice) {
  if (
    !Number.isFinite(fairValue) ||
    !Number.isFinite(marketPrice) ||
    marketPrice <= 0
  ) {
    return null;
  }

  return (fairValue - marketPrice) / marketPrice;
}

function computeDCFRating(fairValue, marketPrice) {
  const difference = pctDiff(fairValue, marketPrice);

  if (!Number.isFinite(difference)) return "Neutral";
  if (difference >= 0.30) return "Strong Buy";
  if (difference >= 0.10) return "Buy";
  if (difference > -0.10) return "Neutral";
  if (difference > -0.30) return "Sell";

  return "Strong Sell";
}

const formatUSD = (value) => {
  if (!Number.isFinite(value)) return "—";

  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatPercent = (value) => {
  if (!Number.isFinite(value)) return "—";

  return `${(value * 100).toFixed(2)}%`;
};

const dcfMC = ratios?.dcf_mc ?? null;

// Deterministic base-case DCF result.
const baseFairValue = toFiniteNumber(
  dcfMC?.scenarios?.base?.fairValuePerShare
);

// Use the Monte Carlo median only as a fallback.
const monteCarloMedian = toFiniteNumber(dcfMC?.median);
const monteCarloMean = toFiniteNumber(dcfMC?.mean);
const monteCarloP10 = toFiniteNumber(dcfMC?.p10);
const monteCarloP90 = toFiniteNumber(dcfMC?.p90);

const dcfPrice = baseFairValue ?? monteCarloMedian;

// Prefer the fresh Yahoo price shown elsewhere on the page.
// Fall back to the price returned by the ratios endpoint.
const current =
  toFiniteNumber(currentPrice) ??
  toFiniteNumber(ratios?.basicMetrics?.closePrice);

const valuationDifference =
  Number.isFinite(dcfPrice) && Number.isFinite(current)
    ? dcfPrice - current
    : null;

const valuationPercent = pctDiff(dcfPrice, current);

const valuationStatus =
  Number.isFinite(valuationDifference)
    ? valuationDifference >= 0
      ? "undervalued"
      : "overvalued"
    : null;

const dcfLabel = computeDCFRating(dcfPrice, current);
const dcfScore = ratingToScore[dcfLabel] ?? 0;

// Your valuation gauge has green on the left and red on the right,
// so bullish values need to be negated.
const needle = -dcfScore * 0.8;

const simulationCount =
  toFiniteNumber(dcfMC?.n) ??
  toFiniteNumber(dcfMC?.requestedSimulations) ??
  0;


// ✅ Scroll-spy (dynamic) using the "closest-to-top" scroll handler
// ✅ Uses the scroll container ref PASSED from App.js: `scrollRootRef`
// Put this inside StockPage.js (inside your StockPage component)

// Accept prop at top of component:
// const StockPage = ({ match, scrollRootRef }) => { ... }

const [activeSection, setActiveSection] = useState("Summary");

const isProgrammaticScroll = useRef(false);
const timerRef = useRef(null);

const itemsN = [
  "Summary",
  "Financials",
  "Chart",
  "Technicals",
  "Valuation",
  "Profile",
  //"Discussion",
  "News",
  //"Options",
  //"StockSleuth AI",
];

const toId = (s) =>
  s
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// click -> scroll (scrolls inside the parent `.content` because it's the scroll container)
const scrollToItem = (item) => {
  setActiveSection(item);

  isProgrammaticScroll.current = true;
  clearTimeout(timerRef.current);

  const el = document.getElementById(toId(item));
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });

  timerRef.current = setTimeout(() => {
    isProgrammaticScroll.current = false;
  }, 700);
};

useEffect(() => {
  const rootEl = scrollRootRef?.current; // ✅ comes from App.js
  //console.log("[spy-scroll] effect fired. FinishedLoading:", FinishedLoading);
  //console.log("[spy-scroll] rootEl (from App):", rootEl);

  if (!rootEl) {
    //console.log("[spy-scroll] rootEl is null — prop not passed or ref not attached in App.js");
    return;
  }

  // ---------- BASIC ROOT DIAGNOSTICS ----------
  const logRootMetrics = (tag = "") => {
    const maxScroll = rootEl.scrollHeight - rootEl.clientHeight;
    
  };

  logRootMetrics("INIT");

  // ---------- FIND SECTIONS ----------
  const sectionEls = itemsN
    .map((label) => {
      const id = toId(label);
      const el = document.getElementById(id);
      //console.log("[spy-scroll] lookup", label, "->", id, ":", el ? "FOUND" : "MISSING");
      return el;
    })
    .filter(Boolean);

  //console.log("[spy-scroll] sections found:", sectionEls.map((s) => s.id));
  if (!sectionEls.length) {
    //console.log("[spy-scroll] No sections found — ids mismatch.");
    return;
  }

  // Verify sections are actually inside the scroll container
  sectionEls.forEach((sec) => {
    //console.log("[spy-scroll] root contains", sec.id, "?", rootEl.contains(sec));
  });

  // ---------- COMPUTE TOPS RELATIVE TO ROOT ----------
  const FOCUS_OFFSET_PX = 120;

  const getSectionTopInRoot = (sec) => {
    let y = 0;
    let el = sec;
    let safety = 0;

    while (el && el !== rootEl && safety < 200) {
      y += el.offsetTop || 0;
      el = el.offsetParent;
      safety++;
    }

    if (el !== rootEl) {
      console.warn("[spy-scroll] Section is NOT inside rootEl:", sec.id);
      return null;
    }

    return y;
  };

  let sectionTops = sectionEls
    .map((sec) => {
      const top = getSectionTopInRoot(sec);
      return top == null ? null : { id: sec.id, el: sec, top };
    })
    .filter(Boolean)
    .sort((a, b) => a.top - b.top);



  // ---------- ACTIVE COMPUTATION + LOGGING ----------
  const computeActive = (reason = "unknown") => {
    if (isProgrammaticScroll.current) {
      //console.log("[spy-scroll] computeActive skipped (programmatic)", reason);
      return;
    }

    const scrollTop = rootEl.scrollTop;
    const scrollY = scrollTop + FOCUS_OFFSET_PX;

    // pick the last section whose top is <= scrollY
    let best = sectionTops[0];
    for (const s of sectionTops) {
      if (s.top <= scrollY) best = s;
      else break;
    }

    const matched = itemsN.find((label) => toId(label) === best.id) || best.id;


    setActiveSection((prev) => {
      if (prev !== matched) {
        //console.log("[spy-scroll] ACTIVE CHANGE:", prev, "->", matched);
      }
      return matched;
    });
  };

  // ---------- SCROLL EVENT LOGGING ----------
  let rafPending = false;
  const onRootScroll = () => {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      computeActive("rootEl scroll");
    });
  };

  rootEl.addEventListener("scroll", onRootScroll, { passive: true });

  // Capture-phase scroll listener: shows if some OTHER element is scrolling
  const onAnyScrollCapture = (e) => {
    const t = e.target;
    if (t === rootEl) return;
  };
  


  // Resize can change offsets -> recompute tops
  const onResize = () => {
    //console.log("[spy-scroll] RESIZE -> recompute tops + active");
    sectionTops = sectionEls
      .map((sec) => {
        const top = getSectionTopInRoot(sec);
        return top == null ? null : { id: sec.id, el: sec, top };
      })
      .filter(Boolean)
      .sort((a, b) => a.top - b.top);


    computeActive("resize");
  };
  window.addEventListener("resize", onResize);

  // Initial compute after paint
  requestAnimationFrame(() => computeActive("init"));

  return () => {
    clearTimeout(timerRef.current);
    rootEl.removeEventListener("scroll", onRootScroll);
    window.removeEventListener("resize", onResize);
  };
}, [FinishedLoading, scrollRootRef]);




    return (
      <div>
        {!isMobile ? (
          <>
        {FinishedLoading ? (
          <>
            
            <div className="whiteBarTop"></div>

            <div className="ContentContainer">
              {(selectedFib || selectedTrend) && (
    <div
      ref={panelRef}
      style={{
        position: "fixed",
        top: panelPosition.y + ymoved,
        left: panelPosition.x - 307,
        width: "auto",
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        zIndex: 99999,
        display: "flex"
      }}
    >
      {/* 👇 Drag handle only */}
      <div style={{
          cursor: "move",  userSelect: "none", width: 30,  display: "flex",
          alignItems: "center",
          justifyContent: "center"}} onMouseDown={startDrag}>
        <img style={{userSelect: "none", pointerEvents: "none", width: 17}}src={drag}/>
      </div>
      

      <div style={{ padding: 5, display: "flex", flexDirection: "row", alignItems: "stretch"}}>
        
        {selectedTrend ? (<>
          <div
  style={{
    position: "relative",
    width: "32px",
    height: "32px",
    borderRadius: "4px",
    overflow: "hidden",
    cursor: "pointer",
    backgroundColor: appearanceForm.strokeStyle, // show current color
    border: "1px solid #ccc"
  }}
  onClick={() => document.getElementById("hiddenColorInput").click()}
>
  <input
    id="hiddenColorInput"
    type="color"
    value={appearanceForm.strokeStyle}
    onChange={(e) => {
      updateAppearanceField("strokeStyle", e.target.value);
      updateAppearanceField("edgeStroke", e.target.value);
      confirmAppearanceChanges();
    }}
    style={{
      position: "absolute",
      opacity: 0,
      pointerEvents: "none",
      width: "100%",
      height: "100%",
    }}
  />
</div>

<IconSelect
    value={appearanceForm.strokeWidth}
    onChange={(v) => {
      updateAppearanceField("strokeWidth", v);
      confirmAppearanceChanges();
    }}
    options={widthOptions}
  />

  {/* Dash Style Picker */}
  <IconSelect
    value={appearanceForm.strokeDasharray}
    onChange={(v) => {
      updateAppearanceField("strokeDasharray", v);
      confirmAppearanceChanges();
    }}
    options={dashOptions}
  />
            <button style={{background: "none", border: "none", cursor: "pointer"}} onClick={() => setTrends1(trends1.filter(each => !each.selected))}><img style={{ width: 21}} src={bin}/></button>
          

        
        </>) : (<>
          
    <div
  style={{
    position: "relative",
    width: "32px",
    height: "32px",
    borderRadius: "4px",
    overflow: "hidden",
    cursor: "pointer",
    backgroundColor: appearanceFibForm.strokeStyle, // show current color
    border: "1px solid #ccc"
  }}
  onClick={() => document.getElementById("hiddenColorInput2").click()}
>
  <input
    id="hiddenColorInput2"
    type="color"
    value={appearanceFibForm.strokeStyle}
    onChange={(e) => {
      updateFibAppearanceField("strokeStyle", e.target.value);
      updateFibAppearanceField("edgeStroke", e.target.value);
      confirmFibAppearanceChanges();
    }}
    style={{
      position: "absolute",
      opacity: 0,
      pointerEvents: "none",
      width: "100%",
      height: "100%",
    }}
  />
</div>
text:
<div
  style={{
    position: "relative",
    width: "32px",
    height: "32px",
    borderRadius: "4px",
    overflow: "hidden",
    cursor: "pointer",
    backgroundColor: appearanceFibForm.fontFill, // show current color
    border: "1px solid #ccc"
  }}
  onClick={() => document.getElementById("hiddenColorInput3").click()}
>
  <input
    id="hiddenColorInput3"
    type="color"
    value={appearanceFibForm.fontFill}
    onChange={(e) => {
      updateFibAppearanceField("fontFill", e.target.value);
      confirmFibAppearanceChanges();
    }}
    style={{
      position: "absolute",
      opacity: 0,
      pointerEvents: "none",
      width: "100%",
      height: "100%",
    }}
  />
</div>
    
      
      <input type="number" min="0" value={appearanceFibForm.strokeWidth} onChange={e => {updateFibAppearanceField("strokeWidth", +e.target.value);confirmFibAppearanceChanges();}} />
   

    
      <input type="number" min="6" value={appearanceFibForm.fontSize} onChange={e => {updateFibAppearanceField("fontSize", +e.target.value);confirmFibAppearanceChanges();}} />
    

        </>)}


        
      </div>
    </div>
  )}


{selectedIndicator && (
  <div
    ref={indicatorPanelRef}
    style={{
      position: "fixed",
      top: indicatorPanelPosition.y  + ymoved,
      left: indicatorPanelPosition.x - 307,
      width: "auto",
      background: "#fff",
      border: "1px solid #ccc",
      borderRadius: 6,
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      zIndex: 99999,
    }}
  >
    {/* Drag handle */}
    <div
      onMouseDown={startIndicatorDrag}
      style={{
        cursor: "grab",
        padding: "6px 10px",
        background: "#f1f1f1",
        borderBottom: "1px solid #ccc",
        userSelect: "none",
        fontWeight: 500,
      }}
    >
      Indicator Settings
    </div>
    {["sma", "ema", "tma", "wma", "ma"].includes(config.id) ? (
  <>
    {indicators
      .filter((cfg) =>
        ["sma", "ema", "tma", "wma", "ma"].includes(cfg.indicator)
      )
      .map((cfg, idx) => {
        // use cfg for the inner loop to avoid shadowing
        const index = indicators.findIndex((i) => i === cfg);
        return (
          <div
            key={idx}
            style={{
              //marginBottom: "0.5rem",
              display: "flex",
              alignItems: "stretch",
              gap: "3px",
              padding: "6px",
            }}
          >
            {/* MA Type */}
            <select
              value={cfg.indicator}
              onChange={(e) =>
                updateTemp(index, "indicator", e.target.value)
              }
              className="topChartElement"
            >
              <option value="sma">SMA</option>
              <option value="ema">EMA</option>
              <option value="tma">TMA</option>
              <option value="wma">WMA</option>
            </select>

            {/* Window Size */}
            <input
              type="number"
              className="topChartElement"
              value={cfg.value}
              onChange={(e) => updateTemp(index, "value", e.target.value)}
              style={{ width: "60px" }}
            />

            {/* Line Color */}
            <div
              style={{
                position: "relative",
                width: "32px",
                height: "32px",
                borderRadius: "4px",
                overflow: "hidden",
                cursor: "pointer",
                backgroundColor: cfg.color,
                border: "1px solid #ccc",
              }}
              onClick={() =>
                document
                  .getElementById(`hiddenColorInput${idx}`)
                  .click()
              }
            >
              <input
                id={`hiddenColorInput${idx}`}
                type="color"
                value={cfg.color}
                className="topChartElement"
                onChange={(e) =>
                  updateTemp(index, "color", e.target.value)
                }
                style={{
                  position: "absolute",
                  opacity: 0,
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>

            {/* Line Width */}
            <input
              type="number"
              min={1}
              className="topChartElement"
              value={cfg.width || 1}
              onChange={(e) =>
                updateTemp(index, "width", e.target.value)
              }
              style={{ width: "50px" }}
            />

            {/* Delete */}
            <button
              onClick={() => removeIndicator(index)}
              className="topChartElement"
              style={{
                //backgroundColor: "red",
                //color: "white",
                //border: "none",
                //borderRadius: "50%",
                cursor: "pointer",
                //width: "24px",
                //height: "24px",
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              🗑️
            </button>
          </div>
        );
      })}
  </>
) : (<>

  <div style={{ padding: "0.5rem" }}>
  {selectedIndicator
      ? JSON.stringify(selectedIndicator)
      : "No indicator selected"}
  </div>


</>)}



  </div>
)}
              <div className="ContentContainer-Left"  style={activeData == "StockSleuth AI" ? { height: "calc(100vh - 64px - 43px)" } : {}}>
              <div className="header">
                <div style={{backgroundColor: "#f2f5f7", position: "absolute", height: "110%"}}></div>
                {/*}
              <div className="logo-container">
              <div className="header-logo" style={{display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'center'}}>
    
    { logoim ? ( <img
      src={logoim}
      alt={ticker}
      style={{
        maxWidth: '80px',   // Set maximum width
        maxHeight: '80px',  // Set maximum height
        objectFit: 'contain' // Ensure the image scales without distorting
      }}
    />) : (<p style={{fontSize: 60, color: "#9c9c9c", fontWeight: 600}}>{ticker ? ticker[0] : ''}</p>)}

  </div></div>
  <div className="otherdetails-container">
    <div className="firstRow">
    <div className="header-Name" style={{ right: 'calc(95px + var(--sidebar-width, 306px))', fontSize: '20px', fontFamily: 'Poppins-Medium', display: 'flex', alignContent: 'left', alignItems: 'center', justifyContent: "space-between", paddingLeft: '44px', paddingRight: 20}}>
      {nameInfo && modifySecurityName(nameInfo)}
      
      <FavoriteStar isFavorite={isFavorite} toggleFavorite={toggleFavorite} />
    </div></div>
    <div className="secondRow">
    <div className="header-Price" style={{display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'center'}}>
      {currentPrice > prevPrice ? (<>
        {currentPrice ? `$${currentPrice} ` : 'Loading...'}<span style = {{paddingTop: 3, fontSize: 12, marginLeft: 8, color: "#299133"}}>{`+${((currentPrice - prevPrice) / prevPrice * 100).toFixed(2)}%`}</span>
      </>):(<>
        {currentPrice ? `$${currentPrice} ` : 'Loading...'}<span style = {{paddingTop: 3, fontSize: 12, marginLeft: 8, color: "#912929" }}>{`${((currentPrice - prevPrice) / prevPrice * 100).toFixed(2)}%`}</span>
      </>)}
    </div>
    
    <div className="header-IdkWhatYet" style={{display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'center', justifyContent: 'flex-start', paddingLeft: 20}}>
      {`${sector} / ${industryt}`}
    </div>
    <div className="header-IdkWhatYet2" style={{right: 'calc(95px + var(--sidebar-width, 306px))', display: 'flex', alignContent: 'center', alignItems: 'center'}}>

    </div></div></div>*/}
    <div className="logo-container">
              </div>
  <div className="otherdetails-container">
    <div className="firstRow">
      <div className="header-logo" style={{display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'center', paddingLeft: '20px'}}>
    
    { logoim  && logoim != null ? ( <img
      src={logoim}
      alt={ticker}
      style={{
        maxWidth: '50px',   // Set maximum width
        maxHeight: '50px',  // Set maximum height
        objectFit: 'contain' // Ensure the image scales without distorting
      }}
    />) : (<p style={{fontSize: 40, color: "#9c9c9c", fontWeight: 600, margin: 0}}>{ticker ? ticker[0] : ''}</p>)}

  </div>
    <div className="header-Name" style={{ right: 'calc(95px + var(--sidebar-width, 306px))', fontSize: '26px', display: 'flex', alignContent: 'left', alignItems: 'center', justifyContent: "space-between", paddingLeft: '20px', paddingRight: 20}}>
      <div style={{display: "flex", gap: 3,flexDirection: "column", alignItems: "flex-start"}}><div>{nameInfo && modifySecurityName(nameInfo)} ({ticker})</div>
      <p style={{margin: 0, fontSize: 12, color: "rgb(156 156 156)"}}>{exchangeName} - Real Time Price. Currency in USD</p></div>
      
      
      <FavoriteStar isFavorite={isFavorite} toggleFavorite={toggleFavorite} />
    </div></div>
    <div className="secondRow">
    <div className="header-Price" style={{display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'flex-start', fontSize: 24, paddingLeft: 20, marginBottom: 12}}>
      {currentPrice > prevPrice ? (<>
        {currentPrice ? `$${currentPrice} ` : 'Loading...'}<span style = {{paddingTop: 3, fontSize: 15, marginLeft: 8, color: "#299133"}}>+{(currentPrice - prevPrice).toFixed(2)} ({`${((currentPrice - prevPrice) / prevPrice * 100).toFixed(2)}%`})</span>
      </>):(<>
        {currentPrice ? `$${currentPrice} ` : 'Loading...'}<span style = {{paddingTop: 3, fontSize: 15, marginLeft: 8, color: "#912929" }}>{(currentPrice - prevPrice).toFixed(2)} ({`${(((currentPrice - prevPrice)*(-1)) / prevPrice * 100).toFixed(2)}%`})</span>
      </>)}
      <span style={{margin: 0, fontSize: 10, color: "rgb(156 156 156)", paddingTop: 7, paddingLeft: 10}}>{displayText}</span>
    </div>
    
    {/*<div className="header-IdkWhatYet" style={{display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'center', justifyContent: 'flex-start', paddingLeft: 20}}>
      {`${sector} / ${industryt}`}
    </div>*/}
    <div className="header-IdkWhatYet2" style={{right: 'calc(95px + var(--sidebar-width, 306px))', display: 'flex', alignContent: 'center', alignItems: 'center'}}>

    </div></div></div>
    </div>

    <div className="bodyContent"  >
      <section id="summary" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
<h2
      
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      1. Summary{" "}
      <span
         onClick={() => handleCopyLink('summary')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2>      <div style={{order: -2}}>
      <div className="chartSection body-Chart" id="chart2" style={{height: 400, display: "inherit", pointerEvents: "none"}}>
        {chartData && chartData.series.length > 0 && (
                <Chart
                  options={chartData.options}
                  series={chartData.series}
                  type={showCandlestick ? "candlestick" : "line"}
                  height={"100%"}
                  width={"100%"}
                />
              )}
</div>
      </div>


            <div>
            </div>

            
              <><div className="firstRow" style={{order: -1, flex: "none", marginTop: 0}}>
                <div
                  className="body-RangeSelector mobileRangeSelector"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 30px",
                  }}
                >
                  <button
                    className={`range-button ${range === "1d" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("1d")}
                  >
                    1d
                  </button>
                  <button
                    className={`range-button ${range === "5d" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("5d")}
                  >
                    5d
                  </button>
                  <button
                    className={`range-button ${range === "1mo" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("1mo")}
                  >
                    1mo
                  </button>
                  <button
                    className={`range-button ${range === "3mo" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("3mo")}
                  >
                    3mo
                  </button>
                  <button
                    className={`range-button ${range === "6mo" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("6mo")}
                  >
                    6mo
                  </button>
                  <button
                    className={`range-button ${range === "1y" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("1y")}
                  >
                    1y
                  </button>
                  <button
                    className={`range-button ${range === "2y" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("2y")}
                  >
                    2y
                  </button>
                  <button
                    className={`range-button ${range === "5y" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("5y")}
                  >
                    5y
                  </button>
                  <button
                    className={`range-button ${range === "max" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("max")}
                  >
                    max
                  </button>
                  <button
                    className={`range-button ${range === "ytd" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("ytd")}
                  >
                    ytd
                  </button>
                </div>
                <div
                  className="ChartTypeProlly"
                  style={{
                    color:
                      periodChange > 0
                        ? "#299133"
                        : periodChange < 0
                        ? "#912929"
                        : "#757575",
                  }}
                >{`${periodChange.toFixed(2)}%`}</div>
                </div>

                <div
                  
                  style={{
                    flex: "0 0 auto",
                     display: "flex",
                     gap: 12
                  }}
                >
                  <div className="body-idk" style={{display: "flex",
                  flex: 1,
                    flexDirection: "row", // Changed from 'column' to 'row'
                    justifyContent: "space-between",
                    fontSize: 11,
                    fontWeight: 200,
                    flexWrap: "wrap",
                    paddingLeft: 16,
                    paddingRight: 16,}}>
                  {ratios?.basicMetrics && (
                    <>
                      {/* First Column */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            Market Cap:
                          </p>
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            {formatMarketCap(ratios?.basicMetrics.marketCap)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>P/E:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios ? ratios?.basicMetrics.priceToEarnings?.toFixed(2) : "N/A"}
                          </p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>P/S:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios ? ratios?.basicMetrics.priceToSales?.toFixed(2) : "N/A"}
                          </p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>P/B:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.priceToBooks.toFixed(2)}
                          </p>
                        </div>
                      </div>

                      {/* Second Column */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            52 week range:
                          </p>
                          <p
                            style={{ marginTop: 0, marginBottom: 0 }}
                          >{`${periodlow} - ${periodhigh}`}</p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>ROA:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.ROA.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>BVPS:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios &&
                              ratios?.basicMetrics.BookValuePerShare?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            Graham Number:
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.grahamNumber?.toFixed(2)}
                          </p>
                        </div>
                      </div>

                      {/* Third Column
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>Beta</p>
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            {Number(ratios?.ratios?.beta)?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>D/E:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.debtToequity?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            Op margin:
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.OperatingMargin?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>ROE</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.ROE?.toFixed(2)}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>EPS:</p>
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            {ratios?.basicMetrics.TTMeps?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            Current Ratio
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.CurrentRatio?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            EV/Revenue
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.evtoRevenue?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            EV/EBITDA
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.evtoebitda?.toFixed(2)}
                          </p>
                        </div>
                      </div>*/}
                    </>
                  )}</div>
                  <div className="body-idk" style={{display: "flex",
                  flex: 1,
                    flexDirection: "row", // Changed from 'column' to 'row'
                    justifyContent: "space-between",
                    fontSize: 11,
                    fontWeight: 200,
                    flexWrap: "wrap",
                    textAlign: "justify",
                    paddingLeft: 16,
                    paddingRight: 16,}}>
{description ? description : "No description available for this security."}
                  </div>
                </div>
              </></section>
      <section id="financials" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
            <h2
      id="financials"
      style={{
        
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      2. Financials{" "}
      <span
         onClick={() => handleCopyLink('financials')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2>  
              <>
              {financialChartsUnavailable && financialChartsUnavailableMessage}
              {hasAnyFinancialChartData && (<>
              <div style={{display: "flex", flexDirection: "row", width: "100%", gap: 12, }}>
                <div
                  className="body-Chart"
                  style={{
                    height: "95%",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{display: "flex", justifyContent: "space-between", marginBottom: "2px", padding: "0 26px", marginTop: 20}}>
                    <p style={{margin: 0, display: "flex", alignItems: "center", fontSize: 14, justifyContent: "flex-start"}}>Revenue & Earnings {isHovering("revenue") && (
    <span style={{ display: "flex", gap: 8, marginLeft: 12 }}>
      <span style={{ color: "#5830b6", fontSize: 16 }}>
        {formatMarketCap2(revenueChartTime === "year" ? revData[hover.index] : revQData[hover.index])}
      </span>
      <span style={{ color: "#ffcc00", fontSize: 16 }}>
        {formatMarketCap2(revenueChartTime === "year" ? incData[hover.index] : incQData[hover.index])}
      </span>
    </span>
  )}</p>
                    <div><div
                  className="body-RangeSelector mobileRangeSelector"
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    borderRadius: 0,
                    overflowX: "auto",
                    boxShadow: "none",
                  }}
                >
                  <button
                    className={`range-button ${revenueChartTime === "year" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("year")}
                  >
                    Annual
                  </button>
                  <button
                    className={`range-button ${revenueChartTime === "quarter" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("quarter")}
                  >
                    Quarterly
                  </button></div></div>
                  </div>
                  {revenueChartTime === "year" ? (
  <BarChart
    tooltip={{
      trigger: "none",
      render: () => null,
    }}
    slots={{ tooltip: () => null }}
    xAxis={[
      {
        data: labelsYear,
        disableTicks: true,
        disableLine: true,
      },
    ]}
    yAxis={[
      {
        width: 60,
        valueFormatter: (val) => formatMarketCap2(val),
        disableTicks: true,
        disableLine: true,
      },
    ]}
    series={[
      { id: "revenue", data: revData, color: "#5830b6" },
      { id: "income", data: incData, color: "#ffcc00" },
    ]}
    height={300}
    borderRadius={10}
    onHighlightChange={onHover("revenue")}
  />
) : (  <BarChart
    tooltip={{
      trigger: "none",
      render: () => null,
    }}
    slots={{ tooltip: () => null }}
    xAxis={[
      {
        data: labelsQuarter,
        disableTicks: true,
        disableLine: true,
      },
    ]}
    yAxis={[
      {
        width: 60,
        valueFormatter: (val) => formatMarketCap2(val),
        disableTicks: true,
        disableLine: true,
      },
    ]}
    series={[
      { id: "revenueQ", data: revQData, color: "#5830b6" },
      { id: "incomeQ", data: incQData, color: "#ffcc00" },
    ]}
    height={300}
    borderRadius={10}
    onHighlightChange={onHover("revenue")}
  />
)}

                  

                </div>
                <div
                  className="body-Chart"
                  style={{
                    height: "95%",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{display: "flex", justifyContent: "space-between", marginBottom: "2px", padding: "0 26px", marginTop: 20}}>
                    <p style={{margin: 0, display: "flex", alignItems: "center", fontSize: 14, justifyContent: "flex-start"}}>EPS  {isHovering("eps") && (
    <span style={{ display: "flex", gap: 8, marginLeft: 12 }}>
      <span style={{ color: "#5830b6", fontSize: 16 }}>
        {revenueChartTime === "year" ? epsAData[hover.index] : epsQData[hover.index]}
      </span>
    </span>
  )}</p>
                    <div><div
                  className="body-RangeSelector mobileRangeSelector"
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    borderRadius: 0,
                    overflowX: "auto",
                    boxShadow: "none",
                  }}
                >
                  <button
                    className={`range-button ${revenueChartTime === "year" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("year")}
                  >
                    Annual
                  </button>
                  <button
                    className={`range-button ${revenueChartTime === "quarter" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("quarter")}
                  >
                    Quarterly
                  </button></div></div>
                  </div>
                  {revenueChartTime === "year" ? <BarChart
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
 slots={{ tooltip: () => null }}
  xAxis={[
    {
      data: epsAYears,
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 30,
      //valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
   series={[{ data: epsAData, color: '#5830b6' }]}
  height={300}
  borderRadius={10}
  onHighlightChange={onHover("eps")}
/> : <BarChart
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
 slots={{ tooltip: () => null }}
  xAxis={[
    {
      data: epsQLabels,
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 30,
      //valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
   series={[{ data: epsQData, color: '#5830b6' }]}
  height={300}
  borderRadius={10}
  onHighlightChange={onHover("eps")}
/> }
                  

                </div>
                </div>
                 <div style={{display: "flex", flexDirection: "row", width: "100%", gap: 12, }}>
                <div
                  className="body-Chart"
                  style={{
                    height: "95%",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{display: "flex", justifyContent: "space-between", marginBottom: "2px", padding: "0 26px", marginTop: 20}}>
                    <p style={{margin: 0, display: "flex", alignItems: "center", fontSize: 14, justifyContent: "flex-start", height: 41, alignItems: "center"}}>Assets & Liabilities {isHovering("assetsLiab") && (
    <span style={{ display: "flex", gap: 8, marginLeft: 12 }}>
      <span style={{ color: "#008080", fontSize: 16 }}>
        {formatMarketCap2(hover.index === 0 ? assetsLT : assetsST)}
      </span>
      <span style={{ color: "#ff7043", fontSize: 16 }}>
        {formatMarketCap2(hover.index === 0 ? liabLT : liabST)}
      </span>
    </span>
  )}</p>
                    
                  </div>
                  <BarChart
                  
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
  
 slots={{ tooltip: () => null }}
 
  xAxis={[
    {
      data: ["Long Term", "Short Term"],
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 60,
      valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
    
  ]}
  slotProps={{
  legend: {
    direction: 'horizontal',
    position: { vertical: 'bottom', horizontal: 'center' },
  },
}}
  series={[
            { data: [assetsLT, assetsST], label: 'Assets', color: '#008080' },
            { data: [liabLT, liabST], label: 'Liabilities', color: '#ff7043' }
          ]}
  height={300}
  onHighlightChange={onHover("assetsLiab")}
  borderRadius={10}
/>
                  

                </div>
                <div
                  className="body-Chart"
                  style={{
                    height: "95%",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{display: "flex", justifyContent: "space-between", marginBottom: "2px", padding: "0 26px", marginTop: 10}}>
                    <p style={{margin: 0, display: "flex", alignItems: "center", fontSize: 14, justifyContent: "flex-start"}}>Change in Cash {isHovering("cash") && (
    <span style={{ display: "flex", gap: 8, marginLeft: 12 }}>
      <span style={{ color: "#5830b6", fontSize: 16 }}>
        {formatMarketCap2(revenueChartTime === "year" ? cashChangeAdata[hover.index] : cashChangeQdata[hover.index])}
      </span>
    </span>
  )}</p>
                    <div><div
                  className="body-RangeSelector mobileRangeSelector"
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    borderRadius: 0,
                    overflowX: "auto",
                    boxShadow: "none",
                  }}
                >
                  <button
                    className={`range-button ${revenueChartTime === "year" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("year")}
                  >
                    Annual
                  </button>
                  <button
                    className={`range-button ${revenueChartTime === "quarter" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("quarter")}
                  >
                    Quarterly
                  </button></div></div>
                  </div>
                  {revenueChartTime === "year" ? <BarChart
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
 slots={{ tooltip: () => null }}
  xAxis={[
    {
      data: cashChangeALabels,
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 30,
      valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
   series={[{ data: cashChangeAdata, color: '#5830b6' }]}
  height={300}
  borderRadius={10}
  onHighlightChange={onHover("cash")}
/> : <BarChart
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
 slots={{ tooltip: () => null }}
  xAxis={[
    {
      data: cashChangeQLabels,
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 30,
      valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
   series={[{ data: cashChangeQdata, color: '#5830b6' }]}
  height={300}
  borderRadius={10}
  onHighlightChange={onHover("cash")}
/> }
                  

                </div>
</div>




              </>)}
                <div
                  className="body-Chart"
                  style={{
                    height: "440px",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      order: 3,
                      display: "flex",
      flex: 0.2,
                      zIndex: 3000,
                      bottom: 8,
                      margin: "0px 3%",
                      fontSize: 10,
                      justifyContent: "space-between",
                    }}
                  ><p><span onClick={() => setFilingsPopup(!filingsPopup)} style={{ cursor: "pointer" }}>See Filings</span>{" · "}<span onClick={() => setShowDetailedFinancials((current) => !current)} style={{ cursor: "pointer" }}>{showDetailedFinancials ? "Summary" : "Detailed financials"}</span></p>
                    <p>
                    All numbers shown in{" "}
                    {BSmultiplier == 1000 ? "Thousands" : "Millions"}
                    {activeStatement === "incomeStatement"
                      ? ", except per share amounts"
                      : ""}</p>
                  </div>
                  
  <Modal open={filingsPopup} onClose={() => setFilingsPopup(false)}>
    <p onClick={() => setFilingsPopup(false)} style={{fontFamily: "Lexend", textAlign: "right", margin: "0px", marginBottom: "10px", cursor: "pointer"}}>Close</p>
  {filings.map((f, i) => (
    <div key={i} style={{ marginBottom: 8 }}>
      <FileText size={16} strokeWidth={1.5} color="#555" />
      <a href={f.filingUrl} target="_blank" rel="noopener noreferrer" style={{color: "black", fontFamily: "Lexend", textDecoration: "none", marginLeft: 12}}>
        {f.form} — {f.reportDate} (filed {f.filingDate})
      </a>
    </div>
  ))}
</Modal>
                  <div className="topButtonsStatements" style={{marginTop: 20}}>
                  
                  
                  <div className="body-RangeSelector mobileRangeSelector" style={{boxShadow: "none", textAlign: "left", marginLeft: 28}}>
                    <button
                      className={
                        activeStatement === "balanceSheet"
                          ? "range-button active"
                          : "range-button"
                      }
                      style={{marginRight: 12}}
                      onClick={() => handleButtonClick("balanceSheet")}
                    >
                      Balance Sheet
                    </button>
                    <button
                    style={{marginRight: 12}}
                      className={
                        activeStatement === "incomeStatement"
                          ? "range-button active"
                          : "range-button"
                      }
                      onClick={() => handleButtonClick("incomeStatement")}
                    >
                      Income Statement
                    </button>
                    <button
                      className={
                        activeStatement === "cashFlow"
                          ? "range-button active"
                          : "range-button"
                      }
                      onClick={() => handleButtonClick("cashFlow")}
                    >
                      Cash Flow
                    </button>
                  </div>
                  <div className="body-RangeSelector mobileRangeSelector" style={{boxShadow: "none", textAlign: "right", marginRight: 28, flex: 1}}>
                    <button
                      className={!isQuarterly ? "range-button active" : "range-button"}
                      onClick={() => toggleQuarterly(false)}
                      style={{marginRight: 12}}
                    >
                      Annual
                    </button>
                    <button
                      className={isQuarterly ? "range-button active" : "range-button"}
                      onClick={() => toggleQuarterly(true)}
                    >
                      Quarterly
                    </button>
                  </div>
                  </div>

                  

                  <div
                    style={{
                      display: "flex",
                      flex: 9,
                      justifyContent: "center",
                      
                      width: "100%",
                      
                      
                      backgroundColor: "white",
                      overflow: "auto", // Enable scrolling
                      WebkitOverflowScrolling: "touch", // For smoother scrolling on touch devices
                      scrollbarWidth: "none", // For Firefox (to hide the scrollbar)
                      msOverflowStyle: "none",
                      zIndex: 1000,
                      overflowY: "auto",

                      borderRadius: 30,
                      paddingTop: 0,
                      paddingBottom: "2%",
                    }}
                  >
                    <div className="TableFinancials">{renderTable()}</div>
                  </div>
                </div>
              </></section>
      <section id="chart" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
        <h2
      
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      3. Chart{" "}
      <span
         onClick={() => handleCopyLink('chart')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2>
        <>
                <div
                  className="body-Chart"
                  ref={chartContainerRef}
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 58,
                    flexGrow: 1,
                  }}
                >
                  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    width: "100%"
  }}>
    <div className="topChartBar">
        
<div style={{display: "flex", gap: 1}}>
<div style={{ width: "100px", height: 32, position: "relative" }}>
      <input
      className="topChartElement"
        ref={inputRef_2}
        type="text"
        placeholder={ticker || "Search ticker..."}
        value={query_2}
        onChange={(e_2) => setQuery_2(e_2.target.value)}
        onFocus={() => setFocused_2(true)}
        onBlur={() => setTimeout(() => setFocused_2(false), 150)}
        onKeyDown={handleKeyDown_2}
        style={{
          width: "100%",
          height: "100%",
          padding: "8px",
          boxSizing: "border-box",
          //borderRadius: "6px",
          //border: "none",
          outline: "none",
          //boxShadow: "inset 0 0 3px rgba(0,0,0,0.1)",
        }}
      />
      {focused_2 && results_2.length > 0 && (
        <ul
          style={{
            position: "relative",
            width: "220px",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid rgba(0, 0, 0, 0.25)",
            color: "rgb(65, 63, 63)",
            borderRadius: "5px",
            textAlign: "left",
            fontSize: "14px",
            marginTop: "4px",
            maxHeight: "200px",
            overflowY: "auto",
            
          }}
        >
          {results_2.map((item_2) => (
            <li
              key={item_2.symbol}
              onClick={() => handleSelect_2(item_2.symbol)}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                marginBottom: 0,
              }}
            >
              <strong>{item_2.symbol}</strong> — { modifySecurityName(item_2.name)}
            </li>
          ))}
        </ul>
      )}
    </div>







        <select className="topChartElement" id="interval" style={{height: "32px", width: "100px"}} value={advInterval} onChange={handleChange}>
        <option value="" disabled hidden>
    Select interval...
  </option>
          <option value="1m" style={{marginTop: 4}}>1m</option>
          <option value="5m">5m</option>
          <option value="15m">15m</option>
          <option value="1h">1h</option>
          <option value="4h">4h</option>
          <option value="1d">1d</option>
          <option value="1wk">1wk</option>
          <option value="1mo">1mo</option>
        </select>
        
        <div>
        <button
        className="topChartElement"
          onClick={() => setOpen(!open)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            //background: "#fff",
            //border: "1px solid #ccc",
            //borderRadius: "6px",
            padding: "6px 10px",
            fontSize: "14px",
            height: "32px",
            cursor: "pointer",
          }}
        >
        <img
    src={
      chartType === "candlestick"
        ? candleStick
        : chartType === "ha"
        ? heikin
        : chartType === "ohlc"
        ? ohlc
        : chartType === "line"
        ? line
        : ""
    }
    alt="chart type"
    style={{ width: 24, height: 24 }}
  />

          
        </button>






        {open && (
    <div
      style={{
        position: "absolute",
        
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "5px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        zIndex: 10,
        marginTop: 4,
        fontSize: "14px",
        minWidth: "160px",
      }}
    >
      <div
        onClick={() => {
          handleChartTypeChange2("candlestick");
          setOpen(false);
        }}
        style={{ display: "flex", alignItems: "center", padding: "8px", cursor: "pointer" }}
      >
        <img src={candleStick} alt="Candlestick" style={{ width: 24, height: 24, marginRight: 8 }} />
        Candlestick
      </div>
      <div
        onClick={() => {
          handleChartTypeChange2("ha");
          setOpen(false);
        }}
        style={{ display: "flex", alignItems: "center", padding: "8px", cursor: "pointer" }}
      >
        <img src={heikin} alt="Heikin Ashi" style={{ width: 24, height: 24, marginRight: 8 }} />
        Heikin Ashi
      </div>
      <div
        onClick={() => {
          handleChartTypeChange2("ohlc");
          setOpen(false);
        }}
        style={{ display: "flex", alignItems: "center", padding: "8px", cursor: "pointer" }}
      >
        <img src={ohlc} alt="OHLC" style={{ width: 24, height: 24, marginRight: 8 }} />
        OHLC
      </div>
      <div
        onClick={() => {
          handleChartTypeChange2("line");
          setOpen(false);
        }}
        style={{ display: "flex", alignItems: "center", padding: "8px", cursor: "pointer" }}
      >
        <img src={line} alt="Line" style={{ width: 24, height: 24, marginRight: 8 }} />
        Line
      </div>
    </div>
  )}
  
</div>




        <div style={{ width: "200px", background: "#f9f9f9", height: 32 }}>
        <input
        ref={inputRef}
        type="text"
        className="topChartElement"
        placeholder=" ƒ Search indicators..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setTimeout(() => setFocused(false), 150)} // delay so click still registers
        style={{
          width: "100%",
          padding: "8px",
          height: "32px",
          boxSizing: "border-box",
          zIndex: 9999,
          position: "relative",
        }}
      />
      {focused && filteredIndicators.length > 0 && (
        <ul
          style={{
            position: "relative",
            width: "220px",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid rgba(0, 0, 0, 0.25)",
            color: "rgb(65, 63, 63)",
            borderRadius: "5px",
            textAlign: "left",
            fontSize: "14px",
            marginTop: "4px",
            maxHeight: "200px",
            overflowY: "auto",
            
          }}
        >
          {filteredIndicators.map((item) => (
            <li
              key={item.indicator}
              onClick={() => handleSelectI(item)}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid rgba(0, 0, 0, 0.25)",
                marginBottom: 0,
              }}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div></div>
    <div style={{display: "flex", gap: 1}}>
    
    
<div          className="download topChartElement"
                onClick={handleShowSettings}
                style={{ position: "relative", cursor: "pointer", height: "30px", border: "none"}}
              >
                <div className="search" style={{width: "auto", height: "31px"}}>
                  <div className="overlap-group" style={{ width: "100%", height: "100%" }}>
                    
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
<svg
fill="rgb(181, 183, 192)" // Change to white or another contrasting color
                          height="20px" // Define the size of the SVG icon
                          width="20px"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M256,192c-35.285,0-64,28.715-64,64s28.715,64,64,64s64-28.715,64-64S291.285,192,256,192z" />
      <path d="M494.699,212.48l-28.245-5.44c-12.651-2.411-22.571-10.688-27.285-22.635c-4.715-12.011-3.051-24.832,4.587-35.221 
        l17.728-24.192c6.229-8.469,5.312-20.245-2.133-27.669l-38.293-38.293c-7.211-7.232-18.603-8.299-27.029-2.581l-23.829,16.107 
        c-10.624,7.232-23.467,8.405-35.307,3.285c-11.797-5.163-19.712-15.403-21.653-28.139l-4.565-29.611 
        C307.072,7.68,298.112,0,287.573,0h-54.144c-10.219,0-19.008,7.253-20.949,17.301l-7.019,36.48 
        c-2.368,12.352-10.389,22.208-22.016,27.008c-11.627,4.843-24.299,3.541-34.709-3.52l-30.763-20.821 
        c-8.427-5.717-19.776-4.651-27.029,2.581L52.651,97.323c-7.445,7.424-8.363,19.2-2.133,27.669l17.728,24.213 
        c7.637,10.368,9.301,23.189,4.587,35.2c-4.715,11.947-14.635,20.224-27.307,22.635l-28.224,5.44 
        C7.253,214.421,0,223.211,0,233.429v54.144c0,10.539,7.68,19.499,18.091,21.099l29.611,4.565 
        c12.736,1.941,22.976,9.856,28.139,21.653c5.141,11.797,3.947,24.661-3.285,35.328l-16.107,23.808 
        c-5.739,8.448-4.651,19.797,2.581,27.029l38.293,38.293c7.445,7.467,19.2,8.32,27.669,2.133l24.213-17.728 
        c10.368-7.616,23.168-9.259,35.2-4.587c11.947,4.715,20.224,14.635,22.635,27.307l5.44,28.224 
        C214.421,504.747,223.211,512,233.429,512h54.144c10.539,0,19.499-7.68,21.099-18.091l3.2-20.821 
        c2.005-13.035,10.133-23.381,22.293-28.395c12.075-5.035,25.195-3.477,35.84,4.331l17.003,12.459 
        c8.427,6.187,20.224,5.333,27.669-2.133l38.293-38.293c7.232-7.232,8.32-18.581,2.581-27.029l-16.107-23.829 
        c-7.232-10.645-8.427-23.509-3.285-35.307c5.163-11.797,15.403-19.712,28.139-21.653l29.611-4.565 
        c10.411-1.6,18.091-10.56,18.091-21.099v-54.144C512,223.211,504.747,214.421,494.699,212.48z 
        M256,362.667c-58.816,0-106.667-47.851-106.667-106.667S197.184,149.333,256,149.333S362.667,197.184,362.667,256 
        S314.816,362.667,256,362.667z" />
    </g>
  </svg>                      </div>
                    
                  </div>
                </div>
                <div className="settingsPopup" style={{ borderRadius: "5px", color: "rgba(65, 63, 63, 1)", fontFamily: 'Lexend', border: "1px solid rgba(0, 0, 0, 0.25)", backgroundColor: "white", flexDirection: "column", position: "absolute", top: 40, left: -350, width: "500px", height: "500px", display: showSettings ? "flex" : "none", justifyContent: "center", alignItems: "center", zIndex: 10000 }}>
                  <h3>Candle Appearance Settings</h3>

      <label>
        Stroke:
        <input
          type="color"
          value={candlesAppearance.stroke}
          onChange={(e) => handleChange6("stroke", e.target.value)}
        />
      </label>
      <br />

      <label>
        Candle Stroke Width:
        <input
          type="number"
          step="0.1"
          value={candlesAppearance.candleStrokeWidth}
          onChange={(e) => handleChange6("candleStrokeWidth", parseFloat(e.target.value))}
        />
      </label>
      <br />

      <label>
        Width Ratio:
        <input
          type="range"
          min="0.1"
          max="1"
          step="0.05"
          value={candlesAppearance.widthRatio}
          onChange={(e) => handleChange6("widthRatio", parseFloat(e.target.value))}
        />
        <span>{candlesAppearance.widthRatio}</span>
      </label>
      <br />

      <label>
        Fill Color (Up Candle):
        <input
          type="color"
          value={rgbaToHex(fillColors6.up)}
          onChange={(e) => handleFillColorChange("up", hexToRgba(e.target.value, 0.8))}
        />
      </label>
      <br />

      <label>
        Fill Color (Down Candle):
        <input
          type="color"
          value={rgbaToHex(fillColors6.down)}
          onChange={(e) => handleFillColorChange("down", hexToRgba(e.target.value, 0.8))}
        />
      </label>
      <label>
        Fill Color Wick (Up Candle):
        <input
          type="color"
          value={rgbaToHex(fillColors62.up)}
          onChange={(e) => handleFillColorChange2("up", hexToRgba(e.target.value, 0.8))}
        />
      </label>
      <br />

      <label>
        Fill Color Wick (Down Candle):
        <input
          type="color"
          value={rgbaToHex(fillColors62.down)}
          onChange={(e) => handleFillColorChange2("down", hexToRgba(e.target.value, 0.8))}
        />
      </label>
              </div>
              </div>
              
              
              
              <div          className="download topChartElement"
                onClick={handleDownload}
                style={{ position: "relative", cursor: "pointer", height: "30px", border: "none"}}
              >
                <div className="search" style={{width: "auto", height: "31px"}}>
                  <div className="overlap-group" style={{ width: "100%", height: "100%" }}>
                    
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <svg
                          fill="rgb(181, 183, 192)" // Change to white or another contrasting color
                          height="20px" // Define the size of the SVG icon
                          width="20px" // Define the size of the SVG icon
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 512 512" // This is the only required attribute
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <g>
                              <path d="M440.125,0H0v512h512V71.875L440.125,0z M281.6,31.347h31.347v94.041H281.6V31.347z M136.359,31.347h113.894v125.388 h94.041V31.347h32.392v156.735H136.359V31.347z M417.959,480.653H94.041V344.816h323.918V480.653z M417.959,313.469H94.041 v-31.347h323.918V313.469z M480.653,480.653h-31.347V250.775H62.694v229.878H31.347V31.347h73.665v188.082h303.02V31.347h19.108 l53.512,53.512V480.653z"></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                    
                  </div>
                </div>
              </div>
              <button className="topChartElement" style={{ height: "32px", cursor: "pointer", backgroundColor: "#4e27d8", color: "white" }} onClick={handleFullscreen}>Fullscreen</button>


    {isFullscreen &&
  ReactDOM.createPortal(
    floatingDiv,
    document.body
  )}
  </div>
        </div>
        {/*indicators.map((ind, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px",
              border: "1px solid #ccc",
              margin: "5px",
              borderRadius: "5px"
            }}
          >
            <div style={{ flex: 1 }}>
              <span>{ind.indicator} - Value: {ind.value}</span>
            </div>
            <button
              onClick={() => removeIndicator(index)}
              style={{
                backgroundColor: "red",
                color: "white",
                border: "none",
                borderRadius: "50%",
                cursor: "pointer",
                padding: "5px",
                fontSize: "16px"
              }}
            >
              🗑️
            </button>
          </div>
        ))*/}
        <div style={{ position: "relative", display: "inline-block" }}>
        
        

{/*------------------------------------------------------------------------------- START OF CUSTOMIZATION ---------------------------------------------------------------------- */}
{/* selectedFib, selectedTrend */}



  


{/*------------------------------------------------------------------------------- END OF CUSTOMIZATION ---------------------------------------------------------------------- */}






        
        

      </div>





      <div
  className="DrawButtons"
  style={{
    marginTop: 64,
    borderRight: "2px solid #f1f4f7",
    position: "absolute",
    left: 12,
    width: 46,
    display: "flex",
    flexDirection: "column",
    gap: 6,
    zIndex: 1000,
  }}
>
  {/* Trend lines */}
  <div
    style={{
      height: 38,
      display: "flex",
      flexDirection: "row",
      position: "relative",
    }}
  >
    <button
      style={{
        width: 38,
        height: 38,
        padding: 4,
        border: "none",
        background: "transparent",
        borderRadius: 7,
        cursor: "pointer",
      }}
      onClick={() => {
        setEnableTrendLine(true);
        setTrendlineType("LINE");
      }}
    >
      <img
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        src={line2}
        alt=""
      />
    </button>

    <button
      style={{
        width: 8,
        height: 38,
        border: "none",
        background: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        fontSize: 10,
        color: "#64748b",
        cursor: "pointer",
      }}
      onClick={() =>
        setOpenDrawing((prev) =>
          prev === "Trendline" ? "" : "Trendline"
        )
      }
    >
      {openDrawing !== "Trendline" ? "›" : "‹"}
    </button>

    {openDrawing === "Trendline" && (
      <div className="openTab">
        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setEnableTrendLine(true);
            setTrendlineType("LINE");
            setOpenDrawing("");
          }}
        >
          <img style={drawingMenuImageStyle} src={line2} alt="" />
          <span>Trend Line</span>
        </button>

        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setEnableTrendLine(true);
            setTrendlineType("RAY");
            setOpenDrawing("");
          }}
        >
          <img style={drawingMenuImageStyle} src={line1} alt="" />
          <span>Ray</span>
        </button>

        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setEnableTrendLine(true);
            setTrendlineType("XLINE");
            setOpenDrawing("");
          }}
        >
          <img style={drawingMenuImageStyle} src={line3} alt="" />
          <span>Extended Line</span>
        </button>
      </div>
    )}
  </div>

  {/* Fibonacci */}
  <div
    style={{
      height: 38,
      display: "flex",
      flexDirection: "row",
      position: "relative",
    }}
  >
    <button
      style={{
        width: 38,
        height: 38,
        padding: 4,
        border: "none",
        background: "transparent",
        borderRadius: 7,
        cursor: "pointer",
      }}
      onClick={() => {
        setEnableFib(true);
        setFibType("BOUND");
      }}
    >
      <img
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        src={fib1}
        alt=""
      />
    </button>

    <button
      style={{
        width: 8,
        height: 38,
        border: "none",
        background: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        fontSize: 10,
        color: "#64748b",
        cursor: "pointer",
      }}
      onClick={() =>
        setOpenDrawing((prev) => (prev === "Fib" ? "" : "Fib"))
      }
    >
      {openDrawing !== "Fib" ? "›" : "‹"}
    </button>

    {openDrawing === "Fib" && (
      <div className="openTab">
        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setEnableFib(true);
            setFibType("BOUND");
            setOpenDrawing("");
          }}
        >
          <img style={drawingMenuImageStyle} src={fib1} alt="" />
          <span>Fibonacci Retracement</span>
        </button>

        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setEnableFib(true);
            setFibType("RAY");
            setOpenDrawing("");
          }}
        >
          <img style={drawingMenuImageStyle} src={fib3} alt="" />
          <span>Ray</span>
        </button>

        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setEnableFib(true);
            setFibType("EXTEND");
            setOpenDrawing("");
          }}
        >
          <img style={drawingMenuImageStyle} src={fib2} alt="" />
          <span>Extended</span>
        </button>
      </div>
    )}
  </div>

  {/* Channels */}
  <div
    style={{
      height: 38,
      display: "flex",
      flexDirection: "row",
      position: "relative",
    }}
  >
    <button
      style={{
        width: 38,
        height: 38,
        padding: 4,
        border: "none",
        background: "transparent",
        borderRadius: 7,
        cursor: "pointer",
      }}
      onClick={() => {
        setEnableEQC(true);
      }}
    >
      <img
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        src={channel}
        alt=""
      />
    </button>

    <button
      style={{
        width: 8,
        height: 38,
        border: "none",
        background: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        fontSize: 10,
        color: "#64748b",
        cursor: "pointer",
      }}
      onClick={() =>
        setOpenDrawing((prev) =>
          prev === "channels" ? "" : "channels"
        )
      }
    >
      {openDrawing !== "channels" ? "›" : "‹"}
    </button>

    {openDrawing === "channels" && (
      <div className="openTab">
        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setEnableEQC(true);
            setOpenDrawing("");
          }}
        >
          <img style={drawingMenuImageStyle} src={channel} alt="" />
          <span>Equidistant</span>
        </button>

        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setEnableSTD(true);
            setOpenDrawing("");
          }}
        >
          <span style={{ width: 26, textAlign: "center" }}>σ</span>
          <span>Standard Deviation</span>
        </button>
      </div>
    )}
  </div>

  {/* Clear */}
  <div
    style={{
      height: 38,
      display: "flex",
      flexDirection: "row",
      position: "relative",
    }}
  >
    <button
      style={{
        width: 38,
        height: 38,
        padding: 4,
        border: "none",
        background: "transparent",
        borderRadius: 7,
        cursor: "pointer",
      }}
      onClick={() => {
        setTrends1([]);
        setEQC1([]);
        setSTD1([]);
        setRetracements1([]);
      }}
    >
      <img
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        src={bin}
        alt=""
      />
    </button>

    <button
      style={{
        width: 8,
        height: 38,
        border: "none",
        background: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        fontSize: 10,
        color: "#64748b",
        cursor: "pointer",
      }}
      onClick={() =>
        setOpenDrawing((prev) => (prev === "bin" ? "" : "bin"))
      }
    >
      {openDrawing !== "bin" ? "›" : "‹"}
    </button>

    {openDrawing === "bin" && (
      <div className="openTab">
        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setTrends1([]);
            setEQC1([]);
            setSTD1([]);
            setRetracements1([]);
            setOpenDrawing("");
          }}
        >
          <span>Clear Drawings</span>
        </button>

        <button
          style={drawingMenuButtonStyle}
          onClick={() => {
            setIndicators([]);
            setOpenDrawing("");
          }}
        >
          <span>Remove Indicators</span>
        </button>

        <button
          style={{
            ...drawingMenuButtonStyle,
            color: "#dc2626",
          }}
          onClick={() => {
            setTrends1([]);
            setEQC1([]);
            setSTD1([]);
            setRetracements1([]);
            setIndicators([]);
            setShowVolume(false);
            setOpenDrawing("");
          }}
        >
          <span>Clear All</span>
        </button>
      </div>
    )}
  </div>
</div>





      </div>

                  {dimensions.width > 0 && dimensions.height > 0 && (
                    <div ref={chartRef}>
                      <div style={{position: "absolute", width: dimensions.width, height: height, display: "flex", justifyContent: "flex-end"}}>
                        <div style={{position: "relative", right: 100, top: 10}}> 
                          <img src={watermark} style={{width: 120, opacity: 0.1}}/>
                          </div></div>
                <ChartCanvas
                ref={chartRef}
        className="ChartCanvas4124"
        ratio={3}
        width={dimensions.width}
        height={height}
        margin={margin}
        data={data}
        displayXAccessor={displayXAccessor}
        seriesName="Data"
        xScale={xScale}
        xAccessor={xAccessor}
        xExtents={xExtents}
        zoomAnchor={lastVisibleItemBasedZoomAnchor}
      >
        {showVolume && (
        <ChartRF
          id={2}
          height={barChartHeight}
          origin={barChartOrigin}
          yExtents={barChartExtents}
        >
          <BarSeries fillStyle={volumeColor} yAccessor={volumeSeries} />
          
        </ChartRF>)}






        <ChartRF id={3} height={chartHeight} yExtents={candleChartExtents} >
        <XAxis showGridLines showTicks={lastChart == "price" ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={lastChart == "price" ? true : false}/>
          {lastChart == "price" && <MouseCoordinateX displayFormat={timeDisplayFormat} />}
          <YAxis showGridLines tickFormat={pricesDisplayFormat} />
          {(chartType === "candlestick" && (
      <CandlestickSeries data={calculatedData} {...candlesAppearance}/>
    ))}
  {(chartType === "ha") && (
      <CandlestickSeries data={calculatedData} />
    )}



 {(chartType == "line") && (
  <AreaSeries
  yAccessor={d => d.close}
  strokeWidth={2}
  fillStyle="rgba(89, 50, 234, 0.1)"
  strokeStyle="#5932ea"
  interpolation={curveMonotoneX}

/>
 )}



    {/* Kagi Series */}
    {chartType === "kagi" && (
    <KagiSeries
      data={calculatedData}
      stroke={strokeColors}
      fill={fillColors}
      currentValueStroke={"#a46fd9"}
      strokeWidth={2} // Optional: customize stroke width if needed
    />
  )}

  {chartType === "ohlc" && <OHLCSeries data={calculatedData} />}

    {chartType === "renko" && <RenkoSeries data={calculatedData} fill={{
    up: '#26a69a',
    down: '#ef5350',
    partial: '#a46fd9'
  }}/>}

    {/* Point and Figure Series */}
    {chartType === "pAndF" && <PointAndFigureSeries data={calculatedData} />}
          {indicatorPipeline.map((indicatorFn, i) => {
    const name = indicators[i].indicator;
    const width = indicators[i].width || 1;
    const id = i + 1;  // The 'id' here should start from 1
    const options = indicators[i];
    if (name == "rsi" || name =="atr" || name == "elder" || name == "macd" || name == "stoch" || name == "fi" || name == "fiEMA"){
      return;
    }
    if (name === "bb") {
      return (
        <BollingerSeries
          key={`bb-${i}`}
          yAccessor={(d) => d.bb}
          stroke={bbStroke}
          fill={bbFill}
        />
      );
    }

    const accessorKey = `${name}${id}`;
    const accessor = (d) => d[accessorKey];

    return (
      <React.Fragment key={`${name}-${id}`}>
        <LineSeries yAccessor={accessor} strokeStyle={indicatorFn.stroke()} strokeWidth={width}/>
        <CurrentCoordinate yAccessor={accessor} fillStyle={indicatorFn.stroke()} />
      </React.Fragment>
    );
  })}




{indicators.some((ind) => ind.indicator === "sar") && (<SARSeries yAccessor={d => d.sar}/>)}
{indicators.some((ind) => ind.indicator === "volumeProfile") && (<VolumeProfileSeries />)}
          <MouseCoordinateY
            
            displayFormat={pricesDisplayFormat}
          />
          <EdgeIndicator
            itemType="last"
            
            fill={openCloseColor}
            lineStroke={openCloseColor}
            displayFormat={pricesDisplayFormat}
            yAccessor={yEdgeIndicator}
          />
          {indicators.some((ind) => ind.indicator === "ema" || ind.indicator === "sma" || ind.indicator === "tma" || ind.indicator === "wma") && (
      <MovingAverageTooltip
        origin={[8, origins.ma]}
        onClick={() => openSettings("ma", null)}
        options={indicators
          .map((ind, i) => {
            if (ind.indicator !== "ema" && ind.indicator !== "sma" && ind.indicator !== "wma" && ind.indicator !== "tma") return null;
            const id = i + 1;
            const key = `${ind.indicator}${id}`;
            return {
              yAccessor: (d) => d[key],
              type: ind.indicator.toUpperCase(),
              stroke: indicatorPipeline[i].stroke(),
              windowSize: ind.value,
            };
          })
          .filter(Boolean)}
      />
      
    )}
    {/*<VolumeProfileSeries bySession orient="right" showSessionBackground />*/}
    {showVolume && (
      <SingleValueTooltip
      yAccessor={volumeSeries}
      onClick={() => setShowVolume(!showVolume)}
      yLabel="Vol"
      //yDisplayFormat={(d) => `${vol}`}
      origin={[8, origins.volume]}
    />
    )}

    {indicators.some((ind) => ind.indicator === "bb") && (
      <BollingerBandTooltip
        origin={[8, origins.bb]}
        onClick={() => openSettings("bb", indicatorPipeline[indicators.findIndex((i) => i.indicator === "bb")].options())}
        yAccessor={(d) => d.bb}
        options={indicatorPipeline[indicators.findIndex((i) => i.indicator === "bb")].options()}
      />
    )}
    {
  (() => {
    const sarIndicator = indicators.find((ind) => ind.indicator === "sar");
    return sarIndicator ? (
      <SingleValueTooltip
        yLabel={`SAR (${sarIndicator.accelerationFactor}, ${sarIndicator.maxAccelerationFactor})`}
        yAccessor={(d) => d.sar}
        origin={[8, origins.sar]}
        onClick={() =>
          setIndicators((prev) =>
            prev.filter((ind) => ind.indicator !== "sar")
          )
        }
      />
    ) : null;
  })()
}

            
    {indicators.some((ind) => ind.indicator === "volumeProfile") && (
      <SingleValueTooltip
      //yAccessor={volumeSeries}
      onClick={() =>
        setIndicators((prev) =>
          prev.filter((ind) => ind.indicator !== "volumeProfile")
        )
      }
      yLabel="Volume Profile"
      yDisplayFormat={(d) => ``}
      origin={[8, origins.vp]}
    />
    )}
          

         {/*} <ZoomButtons onReset={handleResetZoom}/>*/}
          <OHLCTooltip origin={[8, origins.ohlc]} />
          <TrendLine
    ref={saveInteractiveNodes(interactiveNodesRef, "Trendline", 3)}
    enabled={enableTrendLine}
    type={trendlineType}
    snap={false}
    snapTo={d => [d.high, d.low]}
    onStart={() => console.log("START")}
    onComplete={onDrawCompleteChart1}
    trends={trends1}
  />
<FibonacciRetracement
  ref={saveInteractiveNodes(interactiveNodesRef, "FibonacciRetracement", 3)}
  enabled={enableFib}
  type={fibType}
  retracements={retracements1}
  onComplete={onFibComplete1}
/>
<EquidistantChannel
            ref={saveInteractiveNodes(interactiveNodesRef, "EquidistantChannel", 3)}
            enabled={enableEQC}
            onStart={() => console.log("START")}
            onComplete={onEQCComplete1}
            channels={EQC1}
          /><StandardDeviationChannel
          ref={saveInteractiveNodes(interactiveNodesRef, "StandardDeviationChannel", 3)}
          enabled={enableSTD}
          onStart={() => console.log("START")}
          onComplete={onSTDComplete1}
          channels={STD1}
        />
          
        </ChartRF>


        {active.map((ind, i) => {
          //const Ycords[i] = layout.price + height * ((100 - layout.price)/100))/(active.length)
      const pct     = getPercent(i);
      const isLast = i === active.length - 1;
      // originY = totalHeight * (pct / 100)
      const originY = (gridHeight * pct) / 100;
      //console.log(ind, i, height, gridHeight, originY, pct);
      if (ind == "elder"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, elder.accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={pricesDisplayFormat} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={pricesDisplayFormat}
          />
    
          <ElderRaySeries yAccessor={elder.accessor()} />
    
          <SingleValueTooltip
            yAccessor={elder.accessor()}
            onClick={() => openSettings("elderRay", null)}
            yLabel="Elder Ray"
            yDisplayFormat={(d) =>
              `${pricesDisplayFormat(d.bullPower)}, ${pricesDisplayFormat(d.bearPower)}`
            }
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };
      if (ind == "macd"){
        const ind = indicators.find((ind) => ind.indicator === "macd");
        return (
          <ChartRF id={i+4} height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
        yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "macd")].accessor()]}
        origin={[0, originY]}
        //padding={{ top: 8, bottom: 8 }}
      >
        <XAxis showGridLines showTicks={isLast  ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ?  true : false}/>
        <YAxis ticks={4} tickFormat={pricesDisplayFormat} />

        {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
        <MouseCoordinateY
          at="right"
          orient="right"
          displayFormat={format(".2f")}
        />

        

        <MACDSeries yAccessor={(d) => d.macd} />

        
        <SingleValueTooltip 
  origin={[8, 16]}
  yAccessor={(d) => d}
  onClick={() => openSettings("macd", indicatorPipeline[indicators.findIndex((i) => i.indicator === "macd")].options())}
  yLabel=""
  yDisplayFormat={(d) => {
    const macd = d?.macd;
    return macd
      ? `MACD (${ind.macdSlow},${ind.macdFast}): ${macd.macd.toFixed(2)}, Signal (${ind.macdSignal}): ${macd.signal.toFixed(2)}, Divergence: ${macd.divergence.toFixed(2)}`
      : "MACD: n/a";
  }}
/>

      </ChartRF>
        )
        
      };
      if (ind == "rsi"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "rsi")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={pricesDisplayFormat} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={pricesDisplayFormat}
          />
    
    <RSISeries yAccessor={d => d.rsi} />
    
          
          <RSITooltip origin={[8, 16]}
            yAccessor={d => d.rsi}
            options={indicatorPipeline[indicators.findIndex((i) => i.indicator === "rsi")].options()} />
        </ChartRF>
        )
        
      };
      if (ind == "atr"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "atr")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={pricesDisplayFormat} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={pricesDisplayFormat}
          />
    
    <LineSeries yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "atr")].accessor()} />
    
          <SingleValueTooltip
            yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "atr")].accessor()}
            //onClick={() => openSettings("elderRay", null)}
            yLabel={`ATR (${indicatorPipeline[indicators.findIndex((i) => i.indicator === "atr")].options().windowSize})`}
            yDisplayFormat={format(".2f")}
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };
      if (ind == "stoch"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "stoch")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={pricesDisplayFormat} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={pricesDisplayFormat}
          />
    
    <StochasticSeries
            yAccessor={d => d.stoch} {...stoAppearance}/>
    
    <StochasticTooltip
            yAccessor={d => d.stoch}
            //onClick={() => openSettings("elderRay", null)}
            label="Stoch"
            options={indicatorPipeline[indicators.findIndex((i) => i.indicator === "stoch")].options()}
            appearance={stoAppearance}
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };
      if (ind == "fi"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "fi")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={format(".2s")}/>
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={format(".2s")}
          />
    
    <AreaSeries baseAt={scale => scale(0)} yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fi")].accessor()} />
    <StraightLine yValue={0} />
    
    <SingleValueTooltip
           yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fi")].accessor()}
            //onClick={() => openSettings("elderRay", null)}
            yLabel="ForceIndex (1)"
            yDisplayFormat={format(".4s")}
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };
      if (ind == "fiEMA"){
        return (
          <ChartRF
          id={i + 4}
          height={(gridHeight * ((100 - layout.price)/100))/(active.length)}
          yExtents={[0, indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].accessor()]}
          origin={[0, originY]}
          //padding={{ top: 8, bottom: 8 }}
        >
          <XAxis showGridLines showTicks={isLast ? true : false} gridLinesStrokeStyle="#f7f7f7"  showTickLabel={isLast ? true : false}/>
          <YAxis ticks={4} tickFormat={format(".2s")} />
    
          {isLast && (
          <MouseCoordinateX displayFormat={timeDisplayFormat} />
        )}
          <MouseCoordinateY
            //rectWidth={margin.right}
            displayFormat={format(".2s")}
          />
    
    <AlternatingFillAreaSeries
            baseAt={0}
            yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].accessor()}
          />
          <StraightLine yValue={0} />
    
          <SingleValueTooltip
            yAccessor={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].accessor()}
            //onClick={() => openSettings("elderRay", null)}
            yLabel={`ForceIndex (${indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].options().windowSize})`}
            options={indicatorPipeline[indicators.findIndex((i) => i.indicator === "fiEMA")].options()}
            //appearance={stoAppearance}
            origin={[8, 16]}
          />
        </ChartRF>
        )
        
      };




    
  })}





        


        <CrossHairCursor />
        <DrawingObjectSelector
          enabled={!enableSTD}
          getInteractiveNodes={() => {
            // Access the current node from the reference
            const interactiveNode = interactiveNodesRef.current;
          //console.log("interactiveNode", interactiveNode);
        
            return interactiveNode;
          }}
          drawingObjectMap={{
            StandardDeviationChannel: "channels"
          }}
          onSelect={handleSelectionSTD}
        />
        <DrawingObjectSelector
          enabled={!enableEQC}
          getInteractiveNodes={() => {
            // Access the current node from the reference
            const interactiveNode = interactiveNodesRef.current;
          //console.log("interactiveNode", interactiveNode);
        
            return interactiveNode;
          }}
          drawingObjectMap={{
            EquidistantChannel: "channels"
          }}
          onSelect={handleSelectionEQC}
        />

        <DrawingObjectSelector
  enabled={!enableFib}
  getInteractiveNodes={() => {
    // Access the current node from the reference
    const interactiveNode = interactiveNodesRef.current;
  //console.log("interactiveNode", interactiveNode);

    return interactiveNode;
  }}
  drawingObjectMap={{
    FibonacciRetracement: "retracements"
  }}
  onSelect={handleSelectionFib}
/>

        <DrawingObjectSelector
    enabled={!enableTrendLine}
    getInteractiveNodes={() => {
      // Access the current node from the reference
      const interactiveNode = interactiveNodesRef.current;
    //console.log("interactiveNode", interactiveNode);

      return interactiveNode;
    }}
    
    drawingObjectMap={{
      Trendline: "trends"
    }}
    onSelect={handleSelection}
  />

      </ChartCanvas></div>)}
                </div>
              </>
      </section>
      <section id="technicals" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
<h2
    
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      4. Technicals{" "}
      <span
         onClick={() => handleCopyLink('technicals')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2> 
<>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 10,
                  }}
                >
                  <p style={{
  fontSize: "12px",
  fontWeight: 300,
  display: "flex",
  justifyContent: "flex-start",
  textAlign: "left",
  margin: "10px 30px"
}}>Technical ratings offer a quick snapshot of a stock’s behavior based on price trends, momentum, and trading volume. They help identify whether a stock is gaining strength, losing steam, or moving with conviction—useful for spotting entry points, exits, or confirming patterns at a glance.</p>
                <div
                  
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    display: "flex",
                    flexDirection: "row",
                    paddingTop: 30,
                  }}
                >{mounted && (<>
                <div>
                  <h5 style={{ textAlign: "center", fontFamily: "Poppins", fontWeight: 600, marginBottom: 10, marginTop: 5, fontSize: 16 }}>Momentum</h5>
                <ReactSpeedometer
      minValue={-2}
      maxValue={2}
      segments={5}
      
      segmentColors={ratingColors}
      value={ratingToScore[momentumRating]*0.8/*-1.6, 0.8, 0, 0.8, 1.6*/}
      needleColor="#000"
      needleHeightRatio={0.7}
      ringWidth={30}
      
      width={250}
      height={160}
      maxSegmentLabel={""}
      currentValueText={momentumRating}
      valueTextFontSize="14px"
      labelFontSize="10px"
      customSegmentLabels={[
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
      ]}
    /></div>
    <div>
                  <h5 style={{ textAlign: "center", fontFamily: "Poppins", fontWeight: 600, marginBottom: 10, marginTop: 5, fontSize: 16 }}>Trend</h5>
    <ReactSpeedometer
      minValue={-2}
      maxValue={2}
      segments={5}
      
      segmentColors={ratingColors}
      value={ratingToScore[trendRating]*0.8}
      needleColor="#000"
      needleHeightRatio={0.7}
      ringWidth={30}
      width={250}
      height={160}
      maxSegmentLabel={""}
      currentValueText={trendRating}
      valueTextFontSize="14px"
      labelFontSize="10px"
      customSegmentLabels={[
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
      ]}
    /></div>
    <div>
                  <h5 style={{ textAlign: "center", fontFamily: "Poppins", fontWeight: 600, marginBottom: 10, marginTop: 5, fontSize: 16 }}>Volume</h5>
    <ReactSpeedometer
      minValue={-2}
      maxValue={2}
      segments={5}
      
      segmentColors={ratingColors}
      value={ratingToScore[volumeRating]*0.8}
      needleColor="#000"
      needleHeightRatio={0.7}
      ringWidth={30}
      width={250}
      height={160}
      maxSegmentLabel={""}
      currentValueText={volumeRating}
      valueTextFontSize="14px"
      labelFontSize="10px"
      customSegmentLabels={[
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
      ]}
    /></div>
                </>)}</div>
                </div>
              </>


      </section>
      <section id="valuation" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
<h2
     
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      5. Valuation{" "}
      <span
         onClick={() => handleCopyLink('news')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2> 
<>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 30,
                  }}
                >
<p
  style={{
    fontSize: "12px",
    fontWeight: 300,
    textAlign: "left",
    margin: "10px 30px",
    lineHeight: 1.5,
  }}
>
  {Number.isFinite(dcfPrice) && Number.isFinite(current) ? (
    <>
      Our normalized 10-year levered free cash flow model estimates a{" "}
      <strong>base-case fair value</strong> for {ticker} of{" "}
      <strong>{formatUSD(dcfPrice)}</strong> per share. Compared with the
      current price of <strong>{formatUSD(current)}</strong>, the stock
      appears <strong>{valuationStatus}</strong> by{" "}
      <strong>{formatUSD(Math.abs(valuationDifference))}</strong>, or{" "}
      <strong>{formatPercent(Math.abs(valuationPercent))}</strong>.
      {" "}The Monte Carlo analysis ran{" "}
      <strong>{simulationCount.toLocaleString("en-US")}</strong>{" "}
      simulations and produced a median fair value of{" "}
      <strong>{formatUSD(monteCarloMedian)}</strong> and a mean of{" "}
      <strong>{formatUSD(monteCarloMean)}</strong>. The central 80% of
      modeled outcomes ranges from{" "}
      <strong>{formatUSD(monteCarloP10)}</strong> to{" "}
      <strong>{formatUSD(monteCarloP90)}</strong>.
    </>
  ) : (
    <>
      The valuation could not be displayed because the required DCF or
      market-price data is unavailable.
    </>
  )}
</p>

<div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", width: "100%"}}>
                  <ReactSpeedometer
  minValue={-2}
  maxValue={2}
  segments={5}
  customSegmentLabels={[
    { text: "Undervalued", position: "OUTSIDE" },
    { text: "", position: "OUTSIDE" },
    { text: "Fair", position: "OUTSIDE" },
    { text: "", position: "OUTSIDE" },
    { text: "Overvalued", position: "OUTSIDE" },
  ]}
  segmentColors={ratingColors2}
  value={Number.isFinite(needle) ? needle : 0}
  needleColor="#000"
  needleHeightRatio={0.7}
  ringWidth={30}
  width={270}
  height={180}
  maxSegmentLabel=""
  currentValueText={
    Number.isFinite(dcfPrice)
      ? formatUSD(dcfPrice)
      : "N/A"
  }
  valueTextFontSize="14px"
  labelFontSize="11px"
/>



<MonteCarloHistogram
  dcfMC={dcfMC}
  currentPrice={current}
/></div>
                </div>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "row",
                    paddingTop: 30,
                  }}
                ><div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", marginBottom: "30px", alignSelf: "flex-start", width: "100%"}}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                        width: "calc(100% - 52px)",
                        margin: "0 26px 12px",
                        fontFamily: "Lexend",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column", gap: 3, fontFamily: "Poppins" }}>
                        <p style={{ margin: 0, display: "flex", alignItems: "center", fontSize: 14, fontWeight: 600, justifyContent: "flex-start" }}>
                          Comparables
                        </p>
                        <span style={{ fontSize: 10, color: "#94a3b8", fontWeight: 400 }}>
                          Bubble size: {activeSizeMetric?.label || "Market cap"}
                        </span>
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, color: "#64748b" }}>
                          X
                          <select value={compXAxis} onChange={(e) => setCompXAxis(e.target.value)} style={selectStyle}>
                            {comparableMetricOptions.map((metric) => (
                              <option key={metric.key} value={metric.key}>{metric.label}</option>
                            ))}
                          </select>
                        </label>

                        <label style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, color: "#64748b" }}>
                          Y
                          <select value={compYAxis} onChange={(e) => setCompYAxis(e.target.value)} style={selectStyle}>
                            {comparableMetricOptions.map((metric) => (
                              <option key={metric.key} value={metric.key}>{metric.label}</option>
                            ))}
                          </select>
                        </label>

                        <label style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, color: "#64748b" }}>
                          Size
                          <select value={compSizeMetric} onChange={(e) => setCompSizeMetric(e.target.value)} style={selectStyle}>
                            {comparableMetricOptions.map((metric) => (
                              <option key={metric.key} value={metric.key}>{metric.label}</option>
                            ))}
                          </select>
                        </label>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "calc(100% - 52px)",
                        margin: "0 26px",
                        border: "none",
                        borderRadius: 18,
                        background: "#ffffff",
                        boxShadow: "none",
                        overflow: "hidden",
                      }}
                    >
                      {series.length ? (
                        <ScatterChart
                          height={Math.min(420, Math.max(320, height * 0.42))}
                          series={series}
                          margin={{ top: 32, right: 28, bottom: 28, left: 5 }}
                          xAxis={[{
                            label: activeXMetric?.label || 'X metric',
                            valueFormatter: (v) => formatComparableValue(compXAxis, v),
                          }]}
                          yAxis={[{
                            label: activeYMetric?.label || 'Y metric',
                            valueFormatter: (v) => formatComparableValue(compYAxis, v),
                          }]}
                          tooltip={{
                            trigger: 'item',
                            itemContent: ({ series, item }) => {
                              const p = item;
                              return (
                                <div style={{ padding: 8, fontFamily: "Lexend", minWidth: 150 }}>
                                  <div style={{ fontWeight: 600, marginBottom: 4 }}>{series.label}</div>
                                  {p.name && <div style={{ fontSize: 11, color: "#64748b", marginBottom: 6 }}>{p.name}</div>}
                                  <div>{activeXMetric?.shortLabel || 'X'}: <b>{formatComparableValue(compXAxis, p.x)}</b></div>
                                  <div>{activeYMetric?.shortLabel || 'Y'}: <b>{formatComparableValue(compYAxis, p.y)}</b></div>
                                  <div>{activeSizeMetric?.shortLabel || 'Size'}: <b>{formatComparableValue(compSizeMetric, p.size)}</b></div>
                                  <div>Market cap: <b>${formatCompactNumber(p.marketCap)}</b></div>
                                </div>
                              );
                            },
                          }}
                          slots={{
    tooltip: ComparableTooltip,
  }}
                          legend={{ hidden: false }}
                          slotProps={{
                            legend: {
                              direction: 'row',
                              position: { vertical: 'top', horizontal: 'middle' },
                              sx: {
                                fontFamily: 'Poppins',
                                fontSize: 10,
                              },
                            },
                          }}
                        />
                      ) : (
                        <div style={{ height: 320, display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontFamily: "Lexend", fontSize: 12 }}>
                          Not enough comparable data for this metric pair.
                        </div>
                      )}
                    </div>


                    </div></div>
              </>


      </section>
            <section id="profile" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
<h2
    
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      6. Profile{" "}
      <span
         onClick={() => handleCopyLink('profile')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2> 
<>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 10,
                    fontFamily: "Poppins",
                  }}
                >
                  
                  <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 16, gap: "16px", alignSelf: "flex-start", width: "calc(100% - 60px)", padding: "0 30px"}}>
                    <div style={{display: "flex", flex: 2, flexDirection: "column", gap: "8px"}}>
<h3 style={{margin: 0, fontSize: 14, textAlign: "left"}}>Description</h3>
<p style={{margin: 0, fontSize: 12, textAlign: "justify"}}>{longBio}</p>
</div>
<div style={{display: "flex", flex: 1, flexDirection: "column", gap: "8px"}}>
  <h4 style={{margin: 0, fontSize: 14, textAlign: "left"}}>{modifySecurityName(nameInfo)}</h4>
  <p style={{margin: 0, fontSize: 12, textAlign: "justify"}}>Sector: {sector}</p>
<p style={{margin: 0, fontSize: 12, textAlign: "justify"}}>Industry: {industryt}</p>
  </div>
</div>

<div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "8px", marginBottom: 16, alignSelf: "flex-start", width: "calc(100% - 60px)", padding: "0 30px"}}>
<h3 style={{margin: 0, fontSize: 16, textAlign: "left"}}>Key Executives</h3>
<table style={{width: "100%", fontSize: 13}}>
  <thead>
    <tr>
      <th style={{textAlign: "left"}}>Name</th>
      <th style={{textAlign: "left"}}>Title</th>
    </tr>
  </thead>
  <tbody>
    {execs.map((exec, index) => (
      <tr key={index}>
        <td style={{textAlign: "left"}}>{exec.name}</td>
        <td style={{textAlign: "left"}}>{exec.title}</td>
      </tr>
    ))}
  </tbody>
</table>
</div>
<div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 16, gap: "16px", alignSelf: "flex-start", width: "calc(100% - 60px)", padding: "0 30px"}}>
                    <div style={{display: "flex", flex: 2, flexDirection: "column", gap: "8px"}}>
<h3 style={{margin: 0, fontSize: 14, textAlign: "left"}}>Risks</h3>
<ul style={{margin: 0, fontSize: 12, textAlign: "left", listStyleType: "disc", listStylePosition: "inside",}}>
  {(compRisks ?? []).map((risk, i) => (
    <li style={{margin: 2, fontSize: 12}} key={i}>{risk}</li>
  ))}
</ul>
</div>
</div>

                </div>
              </>


      </section>
      <section id="news" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
<h2
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      7. News{" "}
      <span
         onClick={() => handleCopyLink('news')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2> 
<>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 30,
                    marginBottom: 43
                  }}
                >
                {items.length === 0 ? (
      <p className="no-news">No news available.</p>
    ) : (
      items.map((item, idx) => (
        <div key={idx} className="news-item">
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="news-title"
          >
            {item.title}
          </a>
          <div className="news-meta">
            <span className="news-source">{item.creator}</span>
            <span className="news-time"> · {timeAgo(item.pubDate)}</span>
          </div>
        </div>
      ))
    )}
                </div>
              </>


      </section>
            {activeData === "Chart" ? (
              <>
                
              </>
            ) : activeData === "Discussion" ? (
              <div className="body-Chart" style={{ top: 275, bottom: 35 }}>
                <p
                  style={{
                    marginLeft: "40px",
                    fontSize: "16px",
                    fontFamily: "Lexend",
                    display: "flex",
                    alignContent: "left",
                    alignItems: "left",
                    justifyContent: "left",
                    marginTop: "14px",
                  }}
                >
                  Live Chat
                </p>
                <div
                  className="ChatBox"
                  style={{
                    display: "flex",
                    paddingLeft: 5,
                    paddingTop: 10,
                    top: 36,
                    left: 6,
                    right: 6,
                    bottom: 52,
                    position: "absolute",
                    overflowY: "auto",
                  }}
                  ref={chatBoxRef}
                  onScroll={handleScroll}
                >
                  <ul style={{ width: "100%" }}>
                    {messages
                      ?.slice()
                      .reverse()
                      .map((msg, index) => (
                        <li
                          key={index}
                          className="chat-message"
                          style={{
                            display: "flex",
                            alignContent: "left",
                            alignItems: "left",
                            justifyContent: "left",
                          }}
                        >
                          <b style={{ color: userColors[msg.username] }}>
                            <a
                              href={`/profile/${msg.username}`}
                              style={{ textDecoration: "none", color: "inherit" }}
                            >
                              {msg.username}
                            </a>
                          </b>
                          {`: ${msg.message}`}
                        </li>
                      ))}
                  </ul>
                </div>

                <input
                  type="text"
                  value={newMessage}
                  onChange={handleMessageChange}
                  onKeyDown={handleKeyDown}
                  placeholder="Send a message"
                  style={{
                    padding: 0,
                    paddingLeft: 20,
                    border: 0,
                    backgroundColor: "#EDEDED",
                    position: "absolute",
                    bottom: 6,
                    left: 6,
                    right: 60,
                    height: 40,
                    borderBottomLeftRadius: 30,
                    borderBottomRightRadius: 6,
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 6,
                  }}
                />

                <div
                  onClick={handleSendMessage}
                  className="sendMes"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#808EF6",
                    position: "absolute",
                    bottom: 6,
                    width: 50,
                    right: 6,
                    height: 40,
                    borderBottomLeftRadius: 6,
                    borderBottomRightRadius: 30,
                    borderTopLeftRadius: 6,
                    borderTopRightRadius: 10,
                  }}
                >
                  <img
                    src={FlyIcon}
                    style={{ marginLeft: "-6px", width: "70%", height: "70%" }}
                  />
                </div>
              </div>
            ) : activeData === "News" ? (
              <>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 30,
                  }}
                >
                {items.length === 0 ? (
      <p className="no-news">No news available.</p>
    ) : (
      items.map((item, idx) => (
        <div key={idx} className="news-item">
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="news-title"
          >
            {item.title}
          </a>
          <div className="news-meta">
            <span className="news-source">{item.creator}</span>
            <span className="news-time"> · {timeAgo(item.pubDate)}</span>
          </div>
        </div>
      ))
    )}
                </div>
              </>
            ) : activeData === "Profile" ? (
              <>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                  }}
                >
                  <div style={{ height: "90%" }}>
                    <Radar
                      style={{}}
                      data={chartDataRS}
                      options={chartOptionsRS}
                    />
                  </div>
                </div>
              </>
            ) : activeData === "Options" ? (
              <>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    
                    top: 275,
                    bottom: 35,
                  }}
                >
                  
                </div>
              </>
            ) : activeData === "StockSleuth AI" ? (
              <>
                <div
                  className="body-Chart"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    
                    justifyContent: "center",
                    width: "calc(100% - 60px)",
                    height: "100%",
                    padding: 30,
                    minHeight: 0,
                  }}
                >
          {/* Chat messages */}
          <div
  className="chat-box2"
  style={{
    flex: 1,
    overflowY: "auto",
    marginBottom: "1rem",
    fontSize: 12,
  }}
>
  {messagesAI.map((m, i) => {
    const isAI = m.sender === "sleuthAI";
  const isLast  = i === messagesAI.length - 1;
    return (
      <div
        key={i}
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: isAI ? "flex-start" : "flex-end",
          marginBottom: "0.75rem",
        }}
      >
        {isAI ? (
          <>
            {/* AI avatar on left */}
            <img
              src={SleuthAIIcon}
              style={{ marginRight: 8, width: 26, height: 26, borderRadius: 8, }}
            />
            <div
            
              style={{
                background: "rgb(255 180 0 / 26%)",
                padding: "0.5rem 0.75rem",
                borderRadius: 8,
                maxWidth: "80%",
                textAlign: "justify",
              }}
            ><div className={ showTypewriter && isLast ? 'typewriter' : '' }>
              <ReactMarkdown remarkPlugins={[remarkGfm]} style={{ margin: 0 }} >
                {m.text}
              </ReactMarkdown></div>
            </div>
          </>
        ) : (
          <>
            {/* User bubble first, then avatar on right */}
            <div
              style={{
                background: "rgb(89 50 234 / 14%)",
                padding: "0.5rem 0.75rem",
                borderRadius: 8,
                maxWidth: "80%",
                textAlign: "justify",
              }}
            >
              <ReactMarkdown remarkPlugins={[remarkGfm]} style={{ margin: 0 }}>
                {m.text}
              </ReactMarkdown>
            </div>
            {user?.profile_image && (
              <img
                src={`data:image/jpeg;base64,${user.profile_image}`}
                alt="pfp"
                style={{
                  marginLeft: 8,
                  width: 26,
                  height: 26,
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            )}
          </>
        )}
      </div>
    );
  })}
  {isThinking && (
    
    <div
        
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          marginBottom: "0.75rem",
        }}
      >
          <>
            {/* AI avatar on left */}
            <img
              src={SleuthAIIcon}
              style={{ marginRight: 8, width: 26, height: 26, borderRadius: 8, }}
            />
            <div
              style={{
                background: "rgb(255 180 0 / 26%)",
                padding: "0.5rem 0.75rem",
                borderRadius: 8,
                maxWidth: "80%",
                textAlign: "justify",
              }}
            >
              
      <ThinkingIndicator />
    
            </div>
          </>
        
      </div>
  )}
  <div ref={chatEndRef} />
</div>


          {/* Input + Send */}
          {messagesAI.length < 2 ? (
          <div
          className="chat-box2"
        style={{
          display: "flex",
          gap: "0.5rem",
          flexWrap: "wrap",
          marginBottom: "0.5rem",
          overflowX: "auto",
          display: "flex",
          flexDirection: "row",
        }}
      >
        {shownExamples.map((q, i) => (
         <button
    key={i}
    className="gradientOutlineText"
    onClick={() => { setInputText(q); handleSend(q); }}
  >
    {q}
  </button>
        ))}
      </div>) : (<></>)}
          <div
          className="chat-box2"
            style={{
              display: "flex",
              gap: "0.3rem",
              
            }}
          >
            <input
              type="text"
              spellcheck="false"
              className="chat-box2"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
              placeholder="Type your question…"
              style={{
                flex: 1,
                padding: "0.5rem",
                borderRadius: 12,
                border: "1px solid #aaa",
              }}
            />
            <button
            className="chat-box2"
              onClick={handleSend}
              style={{
                padding: "0.5rem 1rem",
                borderRadius: 12,
                background: "#5932ea",
                color: "white",
                border: "none",
                cursor: "pointer",
              }}
            >
              Send
            </button>
          </div>
        </div>
              </>
            ) : (
              <></>
            )}
    </div>


              </div>
              <div className="ContentContainer-Right">
               <div
  className={`body-details sticky-details stock-preview-card ${showStickyDetails ? "visible" : ""}`}
  style={{
    right: "calc(95px + var(--sidebar-width, 306px))",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
    height: showStickyDetails ? "88px" : "0px",
    overflow: "hidden",
    transition: "height 0.3s ease, opacity 0.3s ease",
    opacity: showStickyDetails ? 1 : 0,
    flexGrow: 0,
  }}
>
  <div className="otherdetails-container">
    <div className="firstRow">
      <div className="header-logo stock-preview-logo" style={{width: 32, display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'center', paddingLeft: '20px'}}>
    
    { logoim  && logoim != null ? ( <img
      src={logoim}
      alt={ticker}
      style={{
        maxWidth: '100%',   // Set maximum width
        maxHeight: '100%',  // Set maximum height
        objectFit: 'contain' // Ensure the image scales without distorting
      }}
    />) : (<p style={{fontSize: 20, color: "#9c9c9c", fontWeight: 600, margin: 0}}>{ticker ? ticker[0] : ''}</p>)}

  </div>
    <div className="header-Name stock-preview-name-wrap" style={{ right: 'calc(95px + var(--sidebar-width, 306px))', fontSize: '26px', display: 'flex', alignContent: 'left', alignItems: 'center', justifyContent: "flex-start", paddingLeft: '5px', paddingRight: 5}}>
      <div style={{display: "flex", gap: 3,flexDirection: "column", alignItems: "flex-start", fontSize: 14}}><div className="stock-preview-name" title={`${nameInfo ? modifySecurityName(nameInfo) : ""} (${ticker})`}>{nameInfo && formatPreviewSecurityName(nameInfo)} <span className="stock-preview-ticker">({ticker})</span></div>
      </div>
      
      
      
    </div></div>
    
    <div className="header-Price stock-preview-price" style={{display: 'flex', alignContent: 'center', alignItems: 'center', width: "auto", justifyContent: 'flex-start', fontSize: 16, paddingLeft: 20, marginBottom: 12}}>
      {currentPrice > prevPrice ? (<>
        <span>{currentPrice ? `$${currentPrice}` : 'Loading...'}</span><span style = {{paddingTop: 3, fontSize: 11, marginLeft: 8, color: "#299133", whiteSpace: "nowrap"}}>+{(currentPrice - prevPrice).toFixed(2)} ({`${((currentPrice - prevPrice) / prevPrice * 100).toFixed(2)}%`})</span>
      </>):(<>
        <span>{currentPrice ? `$${currentPrice}` : 'Loading...'}</span><span style = {{paddingTop: 3, fontSize: 11, marginLeft: 8, color: "#912929", whiteSpace: "nowrap" }}>{(currentPrice - prevPrice).toFixed(2)} ({`${(((currentPrice - prevPrice)*(-1)) / prevPrice * 100).toFixed(2)}%`})</span>
      </>)}
      
    </div>
    </div>
    


</div>

                <div
                  className="body-Data"
                  style={{
                    right: "calc(95px + var(--sidebar-width, 306px))",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "left",
                    marginTop: showStickyDetails ? "0px" : "-22px",
                  }}
                >
                  <ul className="selectMenu">
  {itemsN.map((item) => (
    <li
      key={item}
      onClick={() => scrollToItem(item)}
      className={`${activeSection === item ? "SelectorActive" : "Selector"}`}
    >
      <span className="SelectorLabel">{item}</span>
    </li>
  ))}
</ul>


                </div>

                <div
                  className="body-details"
                  style={{
                    right: "calc(95px + var(--sidebar-width, 306px))",
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Ad
                </div>
                <a
              href="https://clearbit.com"
              style={{
                textDecoration: "none",
                color: "inherit",
                fontSize: "12px",
                paddingBottom: 6,
                right: "calc(6.6% + var(--sidebar-width, 306px))",
              }}
            >
              Logos provided by Clearbit
            </a>
              </div>
            </div>
            
            

            
          </>
        ) : (
          <>
            <div
              style={{
                position: "absolute",
                left: 0,
                right: "var(--sidebar-width, 306px)",
                height: "100%",
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div class="loader"></div>
            </div>
          </>
        )}</>) : (<>
{FinishedLoading ? (
          <>
            
            <div className="whiteBarTop"></div>

            <div className="ContentContainer" style={{ paddingLeft: "18px", flexDirection: "column", paddingRight: "18px", }}>
            
              <div className="topMobileBar" style={{margin: "0px -18px", flex: 1, display: "flex", flexDirection: "row", gap: 17, overflowX: "auto", height: 50, backgroundColor: "#fff", position: "sticky", top: 63, zIndex: 100000, paddingLeft: 10, paddingRight: 10, alignItems: "center", justifyContent: "flex-start"}}>
                {[
    "Summary",
    "Financials",
    "Chart",
    "Technicals",
    "Valuation",
    "Profile",
    "Discussion",
    "News",
    "Options",
    "StockSleuth AI",
  ].map((item) => (
    <div
      key={item}
      onClick={() => {
      setActiveData(item);
      
      // Scroll to matching section by ID
      const sectionId = item.replace(/\s+/g, "").toLowerCase(); // e.g. "StockSleuth AI" -> "stocksleuthai"
      const el = document.getElementById(sectionId);
      //console.log("Scrolling to section:", sectionId, el);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }}
      className={`${
        activeData === item ? "SelectorActive" : "Selector"
      } ${item === "StockSleuth AI" ? "stockSleuthAI" : ""}`}
      style={{ cursor: "pointer", fontWeight: "normal", marginBottom: 6 }}
    >
      {item}
    </div>
  ))}
                </div>
              <div className="header" style={{
                boxShadow: "1px 30px 60px 0px rgba(225.83, 236.19, 248.63, 0.50)",
    marginTop: 0,
    zIndex: 100000,
    height: 100,
    //borderRadius: 12,
    position: "sticky",
    top: 108,
    transition: "all 0.3s ease", // enables smooth animation
    margin: isStickyTop ? "0 -18px" : "0",
    height: isStickyTop ? 75 : 100,
    //borderRadius: isStickyTop ? 0 : 12,
    borderBottomRightRadius: 12,
    borderBottomLeftRadius: 12,
    borderTopRightRadius: isStickyTop ? 0 : 12,
    borderTopLeftRadius: isStickyTop ? 0 : 12,
  }}>
                <div style={{backgroundColor: "#f2f5f7", position: "absolute", height: "110%"}}></div>
                
    
  <div className="otherdetails-container">
    <div className="firstRow" style={{marginTop:0}}>
      <div className="header-logo" style={{display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'center', paddingLeft: '20px'}}>
    
    { logoim  && logoim != null ? ( <img
      src={logoim}
      alt={ticker}
      style={{
        maxWidth: '38px',   // Set maximum width
        maxHeight: '38px',  // Set maximum height
        objectFit: 'contain' // Ensure the image scales without distorting
      }}
    />) : (<p style={{fontSize: 40, color: "#9c9c9c", fontWeight: 600, margin: 0}}>{ticker ? ticker[0] : ''}</p>)}

  </div>
    <div className="header-Name" style={{ right: 'calc(95px + var(--sidebar-width, 306px))', fontSize: '18px', display: 'flex', alignContent: 'left', alignItems: 'center', justifyContent: "space-between", paddingLeft: '20px', paddingRight: 20}}>
      <div style={{display: "flex", gap: 3,flexDirection: "column", alignItems: "flex-start"}}><div>{nameInfo && modifySecurityName(nameInfo)} ({ticker})</div>
      <div className="header-Price" style={{display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'flex-start', fontSize: 20, marginBottom: 0}}>
      {currentPrice > prevPrice ? (<>
        {currentPrice ? `$${currentPrice} ` : 'Loading...'}<span style = {{paddingTop: 3, fontSize: 15, marginLeft: 8, color: "#299133"}}>+{(currentPrice - prevPrice).toFixed(2)} ({`${((currentPrice - prevPrice) / prevPrice * 100).toFixed(2)}%`})</span>
      </>):(<>
        {currentPrice ? `$${currentPrice} ` : 'Loading...'}<span style = {{paddingTop: 3, fontSize: 15, marginLeft: 8, color: "#912929" }}>{(currentPrice - prevPrice).toFixed(2)} ({`${(((currentPrice - prevPrice)*(-1)) / prevPrice * 100).toFixed(2)}%`})</span>
      </>)}
     
    </div></div>
      
      
      <FavoriteStar isFavorite={isFavorite} toggleFavorite={toggleFavorite} />
    </div></div>
   </div>
    </div>

    <div className="bodyContent"  >
      <section id="summary" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
<h2
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontSize: 20,
        fontFamily: "Poppins"
      }}
    >
      1. Summary{" "}
      <span
         onClick={() => handleCopyLink('summary')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2>      <div style={{order: -2}}>
      <div className="chartSection body-Chart" id="chart2" style={{height: 300, display: "inherit", pointerEvents: "none"}}>
        {chartData && chartData.series.length > 0 && (
                <Chart
                  options={chartData.options}
                  series={chartData.series}
                  type={showCandlestick ? "candlestick" : "line"}
                  height={"100%"}
                  width={"100%"}
                />
              )}
</div>
      </div>


            <div>
            </div>

            
              <><div className="firstRow" style={{order: -1, flex: "none", marginTop: 0}}>
                <div
                  className="body-RangeSelector mobileRangeSelector"
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    padding: "0 20px",
                    overflowX: "auto",
                  }}
                >
                  <button
                    className={`range-button ${range === "1d" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("1d")}
                  >
                    1d
                  </button>
                  <button
                    className={`range-button ${range === "5d" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("5d")}
                  >
                    5d
                  </button>
                  <button
                    className={`range-button ${range === "1mo" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("1mo")}
                  >
                    1mo
                  </button>
                  <button
                    className={`range-button ${range === "3mo" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("3mo")}
                  >
                    3mo
                  </button>
                  <button
                    className={`range-button ${range === "6mo" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("6mo")}
                  >
                    6mo
                  </button>
                  <button
                    className={`range-button ${range === "ytd" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("ytd")}
                  >
                    ytd
                  </button>
                  <button
                    className={`range-button ${range === "1y" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("1y")}
                  >
                    1y
                  </button>
                  <button
                    className={`range-button ${range === "2y" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("2y")}
                  >
                    2y
                  </button>
                  <button
                    className={`range-button ${range === "5y" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("5y")}
                  >
                    5y
                  </button>
                  <button
                    className={`range-button ${range === "max" ? "active" : ""}`}
                    onClick={() => handleRangeButtonClick("max")}
                  >
                    max
                  </button>
                  
                </div>
                
                </div>

                <div
                  className="body-idk"
                  style={{
                    display: "flex",
                    flexDirection: "column", // Changed from 'column' to 'row'
                    justifyContent: "space-between",
                    fontSize: 11,
                    fontWeight: 200,
                    flexWrap: "wrap",
                    paddingLeft: 16,
                    paddingRight: 16, // Ensures the content wraps properly if it's too wide for one row
                  }}
                >


                  <p style={{ marginTop: 0, marginBottom: -3, alignSelf: "flex-start", padding: "0px 10px" }}>
  52 week Range
</p>

<div style={{ position: "relative", width: "100%", height: 24, marginTop: 2 }}>
  {/* Slider bar */}
  <div
    style={{
      background: "#ddd",
      height: 6,
      borderRadius: 3,
      position: "absolute",
      top: "8px",
      left: 10,
      right: 10,
    }}
  />

  {/* Current price marker */}
  <div
    style={{
      position: "absolute",
      top: "11px",
      transform: "translate(-50%, -50%)",
      height: 14,
      width: 14,
      borderRadius: "50%",
      backgroundColor: "#5830b6",
      transition: "left 0.4s ease",
      left: `calc(${(
        ((currentPrice - periodlow) / (periodhigh - periodlow)) *
        100
      ).toFixed(2)}% - 7px)`,
    }}
    title={`Current price: ${currentPrice}`}
  />

  {/* Min/Max labels below */}
  
</div>
<div
    style={{
      
      bottom: -10,
      marginTop: "-8px",
      display: "flex",
      justifyContent: "space-between",
      fontSize: 10,
      padding: "0 10px",
      color: "#555",
      marginBottom: 12
    }}
  >
    <span>{periodlow}</span>
    <span>{periodhigh}</span>
  </div>
<div style={{ display: "flex", flexDirection: "row", gap: 8, alignItems: "center" }}>
                          </div>
                  {ratios?.basicMetrics && (
                    <>
                      {/* First Column */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          justifyContent: "center",
                          fontSize: 13,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            Market Cap:
                          </p>
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            {formatMarketCap(ratios?.basicMetrics.marketCap)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>P/E:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.priceToEarnings.toFixed(2)}
                          </p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>P/S:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.priceToSales.toFixed(2)}
                          </p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>P/B:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.priceToBooks.toFixed(2)}
                          </p>
                        </div>
                      </div>

                      {/* Second Column 
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            52 week range:
                          </p>
                          <p
                            style={{ marginTop: 0, marginBottom: 0 }}
                          >{`${periodlow} - ${periodhigh}`}</p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>ROA:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.ROA.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>BVPS:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios &&
                              ratios?.basicMetrics.BookValuePerShare?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            Graham Number:
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.grahamNumber?.toFixed(2)}
                          </p>
                        </div>
                      </div>

                     
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>Beta</p>
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            {Number(ratios?.ratios?.beta)?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>D/E:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.debtToequity?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            Op margin:
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.OperatingMargin?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>ROE</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.ROE?.toFixed(2)}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>EPS:</p>
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            {ratios?.basicMetrics.TTMeps?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            Current Ratio
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.CurrentRatio?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            EV/Revenue
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.evtoRevenue?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            EV/EBITDA
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.evtoebitda?.toFixed(2)}
                          </p>
                        </div>
                      </div>*/}
                    </>
                  )}
                </div>
              </></section>
      <section id="financials" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
            <h2
      id="financials"
      style={{
        fontSize: 20,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      2. Financials{" "}
      <span
         onClick={() => handleCopyLink('financials')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2>  
              <>
              {financialChartsUnavailable && financialChartsUnavailableMessage}
              {hasAnyFinancialChartData && (<>
                <div
                  className="body-Chart"
                  style={{
                    height: "95%",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{display: "flex", justifyContent: "space-between", marginBottom: "2px", padding: "0 26px", marginTop: 10}}>
                    <p style={{margin: 0, display: "flex", alignItems: "center", fontSize: 14, justifyContent: "flex-start"}}>Revenue & Earnings</p>
                    <div><div
                  className="body-RangeSelector mobileRangeSelector"
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    borderRadius: 0,
                    overflowX: "auto",
                    boxShadow: "none",
                  }}
                >
                  <button
                    className={`range-button ${revenueChartTime === "year" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("year")}
                  >
                    Annual
                  </button>
                  <button
                    className={`range-button ${revenueChartTime === "quarter" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("quarter")}
                  >
                    Quarterly
                  </button></div></div>
                  </div>
                  {revenueChartTime === "year" ? <BarChart
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
 slots={{ tooltip: () => null }}
  xAxis={[
    {
      data: labelsYear,
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 60,
      valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  series={[
              { data: revData, color: '#5830b6' },
              { data: incData, color: '#ffcc00' }
            ]}
  height={300}
  borderRadius={10}
/> : <BarChart
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
 slots={{ tooltip: () => null }}
  xAxis={[
    {
      data: labelsQuarter,
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 60,
      valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  series={[{ data: revQData, color: '#5830b6' }, { data: incQData, color: '#ffcc00' }]}
  height={300}
  borderRadius={10}
/> }
                  

                </div>
                <div
                  className="body-Chart"
                  style={{
                    height: "95%",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{display: "flex", justifyContent: "space-between", marginBottom: "2px", padding: "0 26px", marginTop: 10}}>
                    <p style={{margin: 0, display: "flex", alignItems: "center", fontSize: 14, justifyContent: "flex-start"}}>EPS</p>
                    <div><div
                  className="body-RangeSelector mobileRangeSelector"
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    borderRadius: 0,
                    overflowX: "auto",
                    boxShadow: "none",
                  }}
                >
                  <button
                    className={`range-button ${revenueChartTime === "year" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("year")}
                  >
                    Annual
                  </button>
                  <button
                    className={`range-button ${revenueChartTime === "quarter" ? "active" : ""}`}
                    onClick={() => setRevenueChartTime("quarter")}
                  >
                    Quarterly
                  </button></div></div>
                  </div>
                  {revenueChartTime === "year" ? <BarChart
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
 slots={{ tooltip: () => null }}
  xAxis={[
    {
      data: epsAYears,
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 30,
      //valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
   series={[{ data: epsAData, color: '#5830b6' }]}
  height={300}
  borderRadius={10}
/> : <BarChart
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
 slots={{ tooltip: () => null }}
  xAxis={[
    {
      data: epsQLabels,
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 30,
      //valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
   series={[{ data: epsQData, color: '#5830b6' }]}
  height={300}
  borderRadius={10}
/> }
                  

                </div>
                <div
                  className="body-Chart"
                  style={{
                    height: "95%",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{display: "flex", justifyContent: "space-between", marginBottom: "2px", padding: "0 26px", marginTop: 10}}>
                    <p style={{margin: 0, display: "flex", alignItems: "center", fontSize: 14, justifyContent: "flex-start", height: 41, alignItems: "center"}}>Assets & Liabilities</p>
                    
                  </div>
                  <BarChart
                  
                  tooltip={{
    trigger: 'none',
    render: () => null, // 👈 Completely disable tooltip rendering
  }}
  
 slots={{ tooltip: () => null }}
 
  xAxis={[
    {
      data: ["Long Term", "Short Term"],
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
  ]}
  yAxis={[
    
    {
      width: 60,
      valueFormatter: (val) => formatMarketCap2(val),
      disableTicks: true, // 👈 removes tick lines
      disableLine: true,
    },
    
  ]}
  slotProps={{
  legend: {
    direction: 'horizontal',
    position: { vertical: 'bottom', horizontal: 'center' },
  },
}}
  series={[
            { data: [assetsLT, assetsST], label: 'Assets', color: '#008080' },
            { data: [liabLT, liabST], label: 'Liabilities', color: '#ff7043' }
          ]}
  height={300}
  
  borderRadius={10}
/>
                  

                </div>


<div
                  className="body-Chart"
                  style={{
                    height: "95%",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                  onClick={() => {setFinancialsTableVisible(true)}}
                >
                  <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", marginBottom: "2px", padding: "0 26px", marginTop: 10, fontSize: 12}}>
                    <p style={{margin: 0, display: "flex", alignItems: "center", fontSize: 14, justifyContent: "flex-start", height: 41}}>Ratios</p>
                  <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          
                          justifyContent: "center",
                          
                        }}
                      >
                        

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{marginBottom: 0 }}>ROA:</p>
                          <p style={{marginBottom: 0 }}>
                            {ratios?.ratios?.ROA.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>BVPS:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios &&
                              ratios?.basicMetrics.BookValuePerShare?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            Graham Number:
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.grahamNumber?.toFixed(2)}
                          </p>
                        </div>
                      </div>

                      {/* Third Column */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          justifyContent: "center",
                          marginTop: 12
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>Beta</p>
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            {Number(ratios?.ratios?.beta)?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>D/E:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.debtToequity?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            Op margin:
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.basicMetrics.OperatingMargin?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>ROE</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.ROE?.toFixed(2)}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          justifyContent: "center",
                          marginTop: 12,
                          marginBottom: 12
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 0, marginBottom: 0 }}>EPS:</p>
                          <p style={{ marginTop: 0, marginBottom: 0 }}>
                            {ratios?.basicMetrics.TTMeps?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            Current Ratio
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.CurrentRatio?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            EV/Revenue
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.evtoRevenue?.toFixed(2)}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            EV/EBITDA
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {ratios?.ratios?.evtoebitda?.toFixed(2)}
                          </p>
                        </div>
                      </div>
                    </></div></div>



              </>)}



              
                <div
                  className="body-Chart"
                  style={{
                    height: "95%",
                    alignContent: "center",
                    
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                  }}
                  onClick={() => {setFinancialsTableVisible(true)}}
                >
                  <div style={{display: "flex", justifyContent: "center", marginBottom: "2px", padding: "0 26px", margin: "16px 0"}}>
                    <p style={{margin: 0, display: "flex", alignItems: "center", fontSize: 14, justifyContent: "center"}}>See More Financials</p>
                  </div></div>
{financialsTableVisible && (
                  <div
                    className="body-Chart"
                    style={{
                      alignContent: "center",
                    
                    justifyContent: "center",
                    width: "100%",
                    position: "fixed",
    top: 65,
    left: 0,
    borderRadius: 0,
    width: "100vw",
    height: "calc(100vh - 65px)",
    zIndex: 999999,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      order: 3,
      flex: 0.2,
                      zIndex: 3000,
                      bottom: 8,
                      marginRight: "3%",
                      fontSize: 10,
                      textAlign: "right",
                    }}
                  >
                    <span onClick={() => setShowDetailedFinancials((current) => !current)} style={{ cursor: "pointer" }}>
                      {showDetailedFinancials ? "Summary" : "Detailed financials"}{" · "}
                    </span>
                    All numbers shown in{" "}
                    {BSmultiplier == 1000 ? "Thousands" : "Millions"}
                    {activeStatement === "incomeStatement"
                      ? ", except per share amounts"
                      : ""}
                  </p>
                  <div className="topButtonsStatements">
                  
                  
                  <div className="Statements">
                    <button
                      className={
                        activeStatement === "balanceSheet"
                          ? "SelectorActive"
                          : "Selector"
                      }
                      onClick={() => handleButtonClick("balanceSheet")}
                    >
                      Balance Sheet
                    </button>
                    <button
                      className={
                        activeStatement === "incomeStatement"
                          ? "SelectorActive"
                          : "Selector"
                      }
                      onClick={() => handleButtonClick("incomeStatement")}
                    >
                      Income Statement
                    </button>
                    <button
                      className={
                        activeStatement === "cashFlow"
                          ? "SelectorActive"
                          : "Selector"
                      }
                      onClick={() => handleButtonClick("cashFlow")}
                    >
                      Cash Flow
                    </button>
                  </div>
                  <div className="Periods">
                    <button
                      className={!isQuarterly ? "SelectorActive" : "Selector"}
                      onClick={() => setFinancialsTableVisible(false)}
                    >
                      Close
                    </button>
                    <button
                      className={!isQuarterly ? "SelectorActive" : "Selector"}
                      onClick={() => toggleQuarterly(false)}
                    >
                      Annual
                    </button>
                    <button
                      className={isQuarterly ? "SelectorActive" : "Selector"}
                      onClick={() => toggleQuarterly(true)}
                    >
                      Quarterly
                    </button>
                  </div>
                  </div>

                  

                  <div
                    style={{
                      display: "flex",
                      flex: 9,
                      justifyContent: "center",
                      
                      width: "100%",
                      
                      
                      backgroundColor: "white",
                      overflow: "auto", // Enable scrolling
                      WebkitOverflowScrolling: "touch", // For smoother scrolling on touch devices
                      scrollbarWidth: "none", // For Firefox (to hide the scrollbar)
                      msOverflowStyle: "none",
                      zIndex: 1000,
                      overflowY: "auto",

                      borderRadius: 30,
                      paddingTop: 0,
                      paddingBottom: "2%",
                    }}
                  >
                    <div className="TableFinancials">{renderTable()}</div>
                  </div>
                </div>)}
              </></section>
      
      <section id="technicals" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
<h2
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      4. Technicals{" "}
      <span
         onClick={() => handleCopyLink('technicals')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2> 
<>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 10,
                  }}
                >
                  <p style={{
  fontSize: "12px",
  fontWeight: 300,
  display: "flex",
  justifyContent: "flex-start",
  textAlign: "left",
  margin: "10px 30px"
}}>Technical ratings offer a quick snapshot of a stock’s behavior based on price trends, momentum, and trading volume. They help identify whether a stock is gaining strength, losing steam, or moving with conviction—useful for spotting entry points, exits, or confirming patterns at a glance.</p>
                <div
                  
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 30,
                  }}
                >{mounted && (<>
                <div>
                  <h5 style={{ textAlign: "center", fontFamily: "Poppins", fontWeight: 600, marginBottom: 10, marginTop: 5, fontSize: 16 }}>Momentum</h5>
                <ReactSpeedometer
      minValue={-2}
      maxValue={2}
      segments={5}
      
      segmentColors={ratingColors}
      value={ratingToScore[momentumRating]*0.8/*-1.6, 0.8, 0, 0.8, 1.6*/}
      needleColor="#000"
      needleHeightRatio={0.7}
      ringWidth={30}
      
      width={250}
      height={160}
      maxSegmentLabel={""}
      currentValueText={momentumRating}
      valueTextFontSize="14px"
      labelFontSize="10px"
      customSegmentLabels={[
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
      ]}
    /></div>
    <div>
                  <h5 style={{ textAlign: "center", fontFamily: "Poppins", fontWeight: 600, marginBottom: 10, marginTop: 5, fontSize: 16 }}>Trend</h5>
    <ReactSpeedometer
      minValue={-2}
      maxValue={2}
      segments={5}
      
      segmentColors={ratingColors}
      value={ratingToScore[trendRating]*0.8}
      needleColor="#000"
      needleHeightRatio={0.7}
      ringWidth={30}
      width={250}
      height={160}
      maxSegmentLabel={""}
      currentValueText={trendRating}
      valueTextFontSize="14px"
      labelFontSize="10px"
      customSegmentLabels={[
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
      ]}
    /></div>
    <div>
                  <h5 style={{ textAlign: "center", fontFamily: "Poppins", fontWeight: 600, marginBottom: 10, marginTop: 5, fontSize: 16 }}>Volume</h5>
    <ReactSpeedometer
      minValue={-2}
      maxValue={2}
      segments={5}
      
      segmentColors={ratingColors}
      value={ratingToScore[volumeRating]*0.8}
      needleColor="#000"
      needleHeightRatio={0.7}
      ringWidth={30}
      width={250}
      height={160}
      maxSegmentLabel={""}
      currentValueText={volumeRating}
      valueTextFontSize="14px"
      labelFontSize="10px"
      customSegmentLabels={[
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
        { text: "", position: "INSIDE" },
      ]}
    /></div>
    <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          padding: "0 10px",
                          flex: 1,
                          marginBottom: 12,
                          width: "100%",
                          fontSize: 12,
                          justifyContent: "center",
                          
                        }}
                      >
                        

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{marginBottom: 0 }}>50-day SMA:</p>
                          <p style={{marginBottom: 0 }}>
                            {sma50 ?? 'N/A'}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>200-day SMA:</p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {sma200 ?? 'N/A'}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            RSI (14):
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {rsiVal ?? 'N/A'}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            MACD:
                          </p>
                          <p style={{ marginTop: 12, marginBottom: 0 }}>
                            {macdVal ?? 'N/A'}
                          </p>
                        </div>
                      </div>
                </>)}</div>
                </div>
                
              </>


      </section>
      <section id="valuation" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
<h2
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      5. Valuation{" "}
      <span
         onClick={() => handleCopyLink('news')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2> 
<>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 30,
                  }}
                > 
         <p>
  {parseFloat(ratios?.basicMetrics?.DCFsharePrice ?? "0").toFixed(2)}
</p>


                </div>
              </>


      </section>
      <section id="news" style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px' }}>
<h2
      style={{
        order: -3,
        textAlign: "left",
        margin: 0,
        paddingLeft: 10,
        fontWeight: 600,
        fontFamily: "Poppins"
      }}
    >
      6. News{" "}
      <span
         onClick={() => handleCopyLink('news')}
        style={{
          cursor: "pointer",
          color: "#c5c5c5",
          textDecoration: "underline"
        }}
        onMouseOver={(e) => (e.target.style.color = "#888")}
        onMouseOut={(e) => (e.target.style.color = "#c5c5c5")}
        title="Copy link"
      >
        #
      </span>
    </h2> 
<>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 30,
                  }}
                >
                {items.length === 0 ? (
      <p className="no-news">No news available.</p>
    ) : (
      items.map((item, idx) => (
        <div key={idx} className="news-item">
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="news-title"
          >
            {item.title}
          </a>
          <div className="news-meta">
            <span className="news-source">{item.creator}</span>
            <span className="news-time"> · {timeAgo(item.pubDate)}</span>
          </div>
        </div>
      ))
    )}
                </div>
              </>


      </section>
            {activeData === "Chart" ? (
              <>
                
              </>
            ) : activeData === "Discussion" ? (
              <div className="body-Chart" style={{ top: 275, bottom: 35 }}>
                <p
                  style={{
                    marginLeft: "40px",
                    fontSize: "16px",
                    fontFamily: "Lexend",
                    display: "flex",
                    alignContent: "left",
                    alignItems: "left",
                    justifyContent: "left",
                    marginTop: "14px",
                  }}
                >
                  Live Chat
                </p>
                <div
                  className="ChatBox"
                  style={{
                    display: "flex",
                    paddingLeft: 5,
                    paddingTop: 10,
                    top: 36,
                    left: 6,
                    right: 6,
                    bottom: 52,
                    position: "absolute",
                    overflowY: "auto",
                  }}
                  ref={chatBoxRef}
                  onScroll={handleScroll}
                >
                  <ul style={{ width: "100%" }}>
                    {messages
                      ?.slice()
                      .reverse()
                      .map((msg, index) => (
                        <li
                          key={index}
                          className="chat-message"
                          style={{
                            display: "flex",
                            alignContent: "left",
                            alignItems: "left",
                            justifyContent: "left",
                          }}
                        >
                          <b style={{ color: userColors[msg.username] }}>
                            <a
                              href={`/profile/${msg.username}`}
                              style={{ textDecoration: "none", color: "inherit" }}
                            >
                              {msg.username}
                            </a>
                          </b>
                          {`: ${msg.message}`}
                        </li>
                      ))}
                  </ul>
                </div>

                <input
                  type="text"
                  value={newMessage}
                  onChange={handleMessageChange}
                  onKeyDown={handleKeyDown}
                  placeholder="Send a message"
                  style={{
                    padding: 0,
                    paddingLeft: 20,
                    border: 0,
                    backgroundColor: "#EDEDED",
                    position: "absolute",
                    bottom: 6,
                    left: 6,
                    right: 60,
                    height: 40,
                    borderBottomLeftRadius: 30,
                    borderBottomRightRadius: 6,
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 6,
                  }}
                />

                <div
                  onClick={handleSendMessage}
                  className="sendMes"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#808EF6",
                    position: "absolute",
                    bottom: 6,
                    width: 50,
                    right: 6,
                    height: 40,
                    borderBottomLeftRadius: 6,
                    borderBottomRightRadius: 30,
                    borderTopLeftRadius: 6,
                    borderTopRightRadius: 10,
                  }}
                >
                  <img
                    src={FlyIcon}
                    style={{ marginLeft: "-6px", width: "70%", height: "70%" }}
                  />
                </div>
              </div>
            ) : activeData === "News" ? (
              <>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 30,
                  }}
                >
                {items.length === 0 ? (
      <p className="no-news">No news available.</p>
    ) : (
      items.map((item, idx) => (
        <div key={idx} className="news-item">
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="news-title"
          >
            {item.title}
          </a>
          <div className="news-meta">
            <span className="news-source">{item.creator}</span>
            <span className="news-time"> · {timeAgo(item.pubDate)}</span>
          </div>
        </div>
      ))
    )}
                </div>
              </>
            ) : activeData === "Profile" ? (
              <>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    top: 275,
                    bottom: 35,
                  }}
                >
                  <div style={{ height: "90%" }}>
                    <Radar
                      style={{}}
                      data={chartDataRS}
                      options={chartOptionsRS}
                    />
                  </div>
                </div>
              </>
            ) : activeData === "Options" ? (
              <>
                <div
                  className="body-Chart"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    
                    top: 275,
                    bottom: 35,
                  }}
                >
                  
                </div>
              </>
            ) : activeData === "StockSleuth AI" ? (
              <>
                <div
                  className="body-Chart"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    
                    justifyContent: "center",
                    width: "calc(100% - 60px)",
                    height: "100%",
                    padding: 30,
                    minHeight: 0,
                  }}
                >
          {/* Chat messages */}
          <div
  className="chat-box2"
  style={{
    flex: 1,
    overflowY: "auto",
    marginBottom: "1rem",
    fontSize: 12,
  }}
>
  {messagesAI.map((m, i) => {
    const isAI = m.sender === "sleuthAI";
  const isLast  = i === messagesAI.length - 1;
    return (
      <div
        key={i}
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: isAI ? "flex-start" : "flex-end",
          marginBottom: "0.75rem",
        }}
      >
        {isAI ? (
          <>
            {/* AI avatar on left */}
            <img
              src={SleuthAIIcon}
              style={{ marginRight: 8, width: 26, height: 26, borderRadius: 8, }}
            />
            <div
            
              style={{
                background: "rgb(255 180 0 / 26%)",
                padding: "0.5rem 0.75rem",
                borderRadius: 8,
                maxWidth: "80%",
                textAlign: "justify",
              }}
            ><div className={ showTypewriter && isLast ? 'typewriter' : '' }>
              <ReactMarkdown remarkPlugins={[remarkGfm]} style={{ margin: 0 }} >
                {m.text}
              </ReactMarkdown></div>
            </div>
          </>
        ) : (
          <>
            {/* User bubble first, then avatar on right */}
            <div
              style={{
                background: "rgb(89 50 234 / 14%)",
                padding: "0.5rem 0.75rem",
                borderRadius: 8,
                maxWidth: "80%",
                textAlign: "justify",
              }}
            >
              <ReactMarkdown remarkPlugins={[remarkGfm]} style={{ margin: 0 }}>
                {m.text}
              </ReactMarkdown>
            </div>
            {user?.profile_image && (
              <img
                src={`data:image/jpeg;base64,${user.profile_image}`}
                alt="pfp"
                style={{
                  marginLeft: 8,
                  width: 26,
                  height: 26,
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            )}
          </>
        )}
      </div>
    );
  })}
  {isThinking && (
    
    <div
        
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          marginBottom: "0.75rem",
        }}
      >
          <>
            {/* AI avatar on left */}
            <img
              src={SleuthAIIcon}
              style={{ marginRight: 8, width: 26, height: 26, borderRadius: 8, }}
            />
            <div
              style={{
                background: "rgb(255 180 0 / 26%)",
                padding: "0.5rem 0.75rem",
                borderRadius: 8,
                maxWidth: "80%",
                textAlign: "justify",
              }}
            >
              
      <ThinkingIndicator />
    
            </div>
          </>
        
      </div>
  )}
  <div ref={chatEndRef} />
</div>


          {/* Input + Send */}
          {messagesAI.length < 2 ? (
          <div
          className="chat-box2"
        style={{
          display: "flex",
          gap: "0.5rem",
          flexWrap: "wrap",
          marginBottom: "0.5rem",
          overflowX: "auto",
          display: "flex",
          flexDirection: "row",
        }}
      >
        {shownExamples.map((q, i) => (
         <button
    key={i}
    className="gradientOutlineText"
    onClick={() => { setInputText(q); handleSend(q); }}
  >
    {q}
  </button>
        ))}
      </div>) : (<></>)}
          <div
          className="chat-box2"
            style={{
              display: "flex",
              gap: "0.3rem",
              
            }}
          >
            <input
              type="text"
              spellcheck="false"
              className="chat-box2"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
              placeholder="Type your question…"
              style={{
                flex: 1,
                padding: "0.5rem",
                borderRadius: 12,
                border: "1px solid #aaa",
              }}
            />
            <button
            className="chat-box2"
              onClick={handleSend}
              style={{
                padding: "0.5rem 1rem",
                borderRadius: 12,
                background: "#5932ea",
                color: "white",
                border: "none",
                cursor: "pointer",
              }}
            >
              Send
            </button>
          </div>
        </div>
              </>
            ) : (
              <></>
            )}
    </div>


              
              
            </div>
            
            

            
          </>
        ) : (
          <>
            <div
              style={{
                position: "absolute",
                left: 0,
                right: "var(--sidebar-width, 306px)",
                height: "100%",
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div class="loader"></div>
            </div>
          </>
        )}


        </>)}
      </div>
    );
  };
function rgbaToHex(rgba) {
  if (!rgba) return "#000000"; // fallback to black
  const match = rgba.match(/\d+/g);
  if (!match || match.length < 3) return "#000000";
  const [r, g, b] = match.map(Number);
  return (
    "#" +
    [r, g, b]
      .map((x) => {
        const hex = x.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      })
      .join("")
  );
}

// Helper to convert hex color to rgba with fixed alpha
function hexToRgba(hex, alpha = 1) {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}


export default React.memo(StockPage);
